import React from 'react'

import { withRouter } from 'react-router-dom'

import { Chart } from 'primereact/chart';
import { DataTable } from 'primereact/datatable' 
import { DataView, DataViewLayoutOptions } from 'primereact/dataview';
import { Column } from 'primereact/column'
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { Dialog } from 'primereact/dialog'
import { Dropdown } from 'primereact/dropdown'
import { OverlayPanel } from 'primereact/overlaypanel';
import { MultiSelect } from 'primereact/multiselect'
import { InputText } from 'primereact/inputtext'
import { InputMask } from 'primereact/inputmask';
import { InputNumber } from 'primereact/inputnumber'
import { AutoComplete } from 'primereact/autocomplete';
import { InputTextarea } from 'primereact/inputtextarea'
import { Calendar } from 'primereact/calendar'
import { TabView, TabPanel } from 'primereact/tabview';
import { Accordion, AccordionTab } from 'primereact/accordion'
import { locale, addLocale, updateLocaleOption, updateLocaleOptions, localeOption, localeOptions } from 'primereact/api'
import { RadioButton } from 'primereact/radiobutton'
import { Checkbox } from 'primereact/checkbox'
import { ProgressSpinner } from 'primereact/progressspinner';

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import { ProgressBar } from 'primereact/progressbar';
import { Tag } from 'primereact/tag';
import { uniqueId } from "lodash"
import filesize from 'filesize'

import NavBar from '../../componentes/Navbar'
import Progresso from '../../componentes/Progresso'
import ProgressoFile from '../../componentes/ProfressoFile'
import PartesAlterar from '../../componentes/PartesAlterar'
import Upload from '../../componentes/Upload/Index'
import FileList from '../../componentes/FileList/index'

import ProcessoService from '../../app/service/ProcessoService'
import LocalStorageService from '../../app/service/localStorageService'
import GrupoTrabalhoService from '../../app/service/GrupoTrabalhoService'
import TipoAcaoService from '../../app/service/TipoAcaoService'
import StatusProcessualService from '../../app/service/StatusProcessualService'
import TipoDecisaoService from '../../app/service/TipoDecisao'
import ObjetoScaoService from '../../app/service/ObjetoAcaoService'
import PessoaService from '../../app/service/PessoaService'
import AreaAtuacaoService from '../../app/service/AreaAtuacaoService'
import ObjetoAcaoProcessoService from '../../app/service/ObjetoAcaoProcessoService'
import PagamentoProcessoService from '../../app/service/PagamentoProcessoService'
import TipoPagamentoService from '../../app/service/TipoPagamentoService'
import CustasProcessoService from '../../app/service/CustasProcessoService'
import TipoCustaService from '../../app/service/TiposCustasService'
import TipoGarantiaService from '../../app/service/TipoGarantiaService'
import GarantiaProcessoService from '../../app/service/GarantiaProcessoService'
import HistoricoProcessoService from '../../app/service/HistoricoProcessoService'
import UploadService from '../../app/service/UploadService'
import ArquivoProcessoServiice from '../../app/service/ArquivoProcessoService'
import ProcessoImportanciaService from '../../app/service/ProcessoImportanciaService'
import AtivividadeService from '../../app/service/AtividadeService'
import UsuarioGrupoTrabalhoService from '../../app/service/UsuarioGrupoTrabalhoService'
import ArquivoAtividadeService from '../../app/service/ArquivoAtividadeService'
import ArquivoPessoaService from '../../app/service/ArquivoPessoaService'
import FinanceiroService from '../../app/service/FinanceiroService'
import EstadoService from '../../app/service/EstadoService'
import CidadeService from '../../app/service/CidadeService'
import StatusAtividadeService from '../../app/service/StatusAtividadeService'
import PedidoService from '../../app/service/PedidoService'
import PedidoProcessoService from '../../app/service/PedidoProcessoService'
import TipoAndamentoProcessualService from '../../app/service/TipoAndamentoProcessualService'
import MotivoResultadoService from '../../app/service/MotivoResultadoService'
import AgravoApensoService from '../../app/service/AgravoApensoService'
import FaseService from '../../app/service/FaseService'
import RitoService from '../../app/service/RitoService'
import TituloAtividadeService from '../../app/service/TituloAtividadeService'
import GrupoTarefaService from '../../app/service/GrupoTarefaService'
import TarefaService from '../../app/service/TarefaService'
import FaseTarefaService from '../../app/service/FaseTarefaService'
import GraficoAtividadeService from '../../app/service/GraficoAtividadeService'
import TituloAtividadeFaseService from '../../app/service/TituloAtividadeFaseService'
import UsuarioService from '../../app/service/UsuarioService'
import LiminarService from '../../app/service/LiminarService'
import DecisaoService from '../../app/service/DecisaoService'
import StatusrecursoApensoService from '../../app/service/StatusRecursoApensoService'
import ProvisaoJudicialService from '../../app/service/ProvisaoJudicialService'

import { AuthContext } from '../../main/ProvedorAutenticacao'

import './processo.css'
import './upload.css'
import '../home/painel.css'

class FichaProcesso extends React.Component {

  constructor(props) {
    super(props);

    this.processoService = new ProcessoService();
    this.grupoTrabalhoService = new GrupoTrabalhoService();
    this.tipoAcaoService = new TipoAcaoService();
    this.statusProcessualService = new StatusProcessualService();
    this.tipoDecisaoService = new TipoDecisaoService();
    this.objetoAcaoService = new ObjetoScaoService();
    this.pessoaService = new PessoaService();
    this.areaAtuacaoService = new AreaAtuacaoService();
    this.objetoAcaoProcessoService = new ObjetoAcaoProcessoService();
    this.pagamentoProcessoService = new PagamentoProcessoService();
    this.tipoPagamentoService = new TipoPagamentoService();
    this.custasProcessoService = new CustasProcessoService();
    this.tipoCustaService = new TipoCustaService();
    this.tipoGarantiaService = new TipoGarantiaService();
    this.garantiaProcessoService = new GarantiaProcessoService();
    this.historicoProcessoService = new HistoricoProcessoService();
    this.uploadService = new UploadService();
    this.arquivoProcessoService = new ArquivoProcessoServiice();
    this.processoImportanciaService = new ProcessoImportanciaService();
    this.atividadeService = new AtivividadeService();
    this.usuarioGrupoTrabalhoService = new UsuarioGrupoTrabalhoService();
    this.arquivoAtividadeService = new ArquivoAtividadeService();
    this.arquivoPessoaService = new ArquivoPessoaService();
    this.financeiroService = new FinanceiroService();
    this.estadoService = new EstadoService();
    this.cidadeService = new CidadeService();
    this.statusAtividadeService = new StatusAtividadeService();
    this.pedidoService = new PedidoService();
    this.pedidoProcessoService = new PedidoProcessoService();
    this.tipoAndamentoProcessualService = new TipoAndamentoProcessualService();
    this.motivoResultadoService = new MotivoResultadoService();
    this.agravoApensoService = new AgravoApensoService();
    this.faseService = new FaseService();
    this.ritoService = new RitoService();
    this.tituloAtividadeService = new TituloAtividadeService();
    this.grupoTarefaService = new GrupoTarefaService();
    this.tarefaService = new TarefaService();
    this.faseTarefaService = new FaseTarefaService();
    this.graficoAtividadeSerice = new GraficoAtividadeService();
    this.tituloAtividadeFaseService = new TituloAtividadeFaseService();
    this.usuarioService = new UsuarioService();
    this.liminarService = new LiminarService(); 
    this.decisaoService = new DecisaoService();
    this.statusrecursoApensoService = new StatusrecursoApensoService();
    this.provisaoJudicialService = new ProvisaoJudicialService();

    this.consultarPessoa = this.consultarPessoa.bind(this);
    this.acoesObjetosAcao = this.acoesObjetosAcao.bind(this);
    this.onTipoDecisaoChange = this.onTipoDecisaoChange.bind(this);
    this.vlPagamento = this.vlPagamento.bind(this);
    this.acoesPagamentosProcesso = this.acoesPagamentosProcesso.bind(this);
    this.acoesCustasProcesso = this.acoesCustasProcesso.bind(this);
    this.onChangeTipoPagamento = this.onChangeTipoPagamento.bind(this);
    this.onChangeStatusProcessual = this.onChangeStatusProcessual.bind(this);
    this.onChangeGrupoTrabalho = this.onChangeGrupoTrabalho.bind(this);
    this.onChangeTipoAcao = this.onChangeTipoAcao.bind(this);
    this.onChangeAreaAtuacao = this.onChangeAreaAtuacao.bind(this);
    this.renderFooterCadastroPagamentos = this.renderFooterCadastroPagamentos.bind(this);
    this.confirmaExclusaoPagamento = this.confirmaExclusaoPagamento.bind(this);
    this.confirmaExclusaoCusta = this.confirmaExclusaoCusta.bind(this);
    this.acceptExcluirPagamento = this.acceptExcluirPagamento.bind(this);
    this.acceptExcluirCustas = this.acceptExcluirCustas.bind(this);
    this.vlCustas = this.vlCustas.bind(this);
    this.onChangeTipoCustas = this.onChangeTipoCustas.bind(this);
    this.renderFooterCadastroCustas = this.renderFooterCadastroCustas.bind(this);
    this.acoesGarantiasProcesso = this.acoesGarantiasProcesso.bind(this);
    this.acceptExcluirGarantias = this.acceptExcluirGarantias.bind(this);
    this.confirmaExclusaoGarantia = this.confirmaExclusaoGarantia.bind(this);
    this.vlPenhora = this.vlPenhora.bind(this);
    this.headerResumoPagamentos = this.headerResumoPagamentos.bind(this);
    this.headerResumoCustas = this.headerResumoCustas.bind(this);
    this.onChangeTipoGarantia = this.onChangeTipoGarantia.bind(this);
    this.headerTotalPenhora = this.headerTotalPenhora.bind(this);
    this.aceptExcluirObjetoAcao = this.aceptExcluirObjetoAcao.bind(this);
    this.onCityChange = this.onCityChange.bind(this);
    this.acoesHistoricoProcesso = this.acoesHistoricoProcesso.bind(this);
    this.acceptExcluirHistoricoAtividade = this.acceptExcluirHistoricoAtividade.bind(this);
    this.acceptExcluirHistorico = this.acceptExcluirHistorico.bind(this);
    this.usuarioHistorico = this.usuarioHistorico.bind(this);
    this.confirmaExclusaoProvisaoJudicial = this.confirmaExclusaoProvisaoJudicial.bind(this);
    this.acceptExcluirProvisao = this.acceptExcluirProvisao.bind(this);
    //Upload
    this.acoesArquivos = this.acoesArquivos.bind(this);
    this.renderFooterDescricaoArquivo = this.renderFooterDescricaoArquivo.bind(this);
    this.acceptExcluirArquivo = this.acceptExcluirArquivo.bind(this);
    //Atividades
    this.renderFooterAtividade = this.renderFooterAtividade.bind(this);
    this.acoesHistoricoUsuario = this.acoesHistoricoUsuario.bind(this);
    this.acoesHistoricoAtividade = this.acoesHistoricoAtividade.bind(this);
    this.acoesAtividade = this.acoesAtividade.bind(this);
    this.onChangeStatusAtividade = this.onChangeStatusAtividade.bind(this);
    this.onSubGrupoChange = this.onSubGrupoChange.bind(this);
    this.acoesArquivosAtividade = this.acoesArquivosAtividade.bind(this);
    this.renderFooterDescricaoArquivoAtividade = this.renderFooterDescricaoArquivoAtividade.bind(this);
    this.novaAtividadeHeader = this.novaAtividadeHeader.bind(this);
    this.acceptExcluirArquivoNovaAtividade = this.acceptExcluirArquivoNovaAtividade.bind(this);
    this.acoesArquivosNovaAtividade = this.acoesArquivosNovaAtividade.bind(this);
    this.renderFooterAtividadeNovaAtividade = this.renderFooterAtividadeNovaAtividade.bind(this);
    this.renderFooterDescricaoArquivoNovaAtividade = this.renderFooterDescricaoArquivoNovaAtividade.bind(this);
    this.onChangeEstado = this.onChangeEstado.bind(this);
    this.onChangeCidade = this.onChangeCidade.bind(this);
    this.onChangeTipoPessoa = this.onChangeTipoPessoa.bind(this);
    this.acceptExcluirArquivoAtividade = this.acceptExcluirArquivoAtividade.bind(this);
    this.acoesPedidos = this.acoesPedidos.bind(this);
    this.acceptExcluirPedido = this.acceptExcluirPedido.bind(this);
    //Lançamentos Financeiros
    this.acoesFinanceiro = this.acoesFinanceiro.bind(this);
    this.onChangeObjetos = this.onChangeObjetos.bind(this);
    //Agravo Apenso
    this.renderFooterCadastroAgravoApenso = this.renderFooterCadastroAgravoApenso.bind(this);
    this.acoesPartesAgravoApenso = this.acoesPartesAgravoApenso.bind(this);
    this.renderFooterAgravoApensoExistente = this.renderFooterAgravoApensoExistente.bind(this);
    this.acoesProcessoAgravosApensos = this.acoesProcessoAgravosApensos.bind(this);
    this.acceptExcluirAgravoApenso = this.acceptExcluirAgravoApenso.bind(this);
    this.onMudancaData = this.onMudancaData.bind(this);
    this.acoesPartes = this.acoesPartes.bind(this);
    this.incluirParte = this.incluirParte.bind(this);
    this.acceptExcluirParte = this.acceptExcluirParte.bind(this);
    this.renderFooterCadastroRecurso = this.renderFooterCadastroRecurso.bind(this);
    //Tarefas Agrupadas
    this.renderFooterAtividadeAgrupada = this.renderFooterAtividadeAgrupada.bind(this);
    this.onChangeGrupoTarefa = this.onChangeGrupoTarefa.bind(this);
    this.informacoesUsuariosTarefas = this.informacoesUsuariosTarefas.bind(this);
    this.renderFooterInformacaoUsuario = this.renderFooterInformacaoUsuario.bind(this);
    this.onChangeFasesPorTitulo = this.onChangeFasesPorTitulo.bind(this);
    this.acoesLiminares = this.acoesLiminares.bind(this);
    this.renderFooterCadastroLiminar = this.renderFooterCadastroLiminar.bind(this);
    this.acceptExcluirLiminar = this.acceptExcluirLiminar.bind(this);
    this.renderFooterAlterarLiminar  = this.renderFooterAlterarLiminar.bind(this);
    this.acceptExcluirDecisao = this.acceptExcluirDecisao.bind(this);
    this.acoesDecisoes = this.acoesDecisoes.bind(this);
    this.renderFooterCadastroDecisao = this.renderFooterCadastroDecisao.bind(this);
    this.renderFooterAlterarDecisao = this.renderFooterAlterarDecisao.bind(this);
    this.acoesProvisoes = this.acoesProvisoes.bind(this);
    
    this.state = {
      processo: {},
      codigo: '',
      gruposTrabalho: [],
      grupoTrabalho: null,
      pasta: '',
      nrProcesso: '',
      nrCnj: '',
      instancia: null,
      dsComarca: '',
      tiposAcao: [],
      tipoAcao: null,
      statusProcessuais: [],
      statusProcessual: null,
      areasAtuacao: [],
      areaAtuacao: null,
      tiposDecisao: [],
      tipoDecisao: null,
      dataDistribuicao: '',
      dataUltimaMovimentacao: '',
      dataCadastro: '',
      dataSentenca: '',
      dataUltimaDecisao: '',
      vlProvavel: '',
      vlPossivel: '',
      vlRemoto: '',
      vlCausa: '',
      objetosAcao: [],
      subObjetosAcao: [],
      selectSubObjetos: null,
      modalObjetos: false,
      uf: null,
      objetoAcao: null,
      dsPedidos: '',
      observacao: '',
      responsavel: null,
      pagamentos: [],
      push: [],
      modalLoad: '',
      pedidosProcesso: [],
      contingenciaContabil: null,
      orgaoColegiado: '',
      relatorProcesso: '',
      //Partes
      partesProcesso: [],
      filterPessoas: null,
      pessoas: [],
      linkFichaPessoa: '',
      exibirNovaParte: 'none',
      iconeExibirNovaParte: '+',
      codigoParte: '',
      selectParte: null,
      codigoObjeto: '',
      visibleObjeto: false,
      pedidos: [],
      pedido: null,
      pedidosProcesso: [],
      pedidoProcesso: null,
      modalPedidos: false,
      modalAlterarPedidos: false,
      //Pagamentos de Processo
      codigoPagamento: '',
      modalPagamentos: false,
      tipo: null,
      pagamento: null,
      tiposPagamentos: [],
      tipoPagamento: null,
      vlPagamento: '',
      dtPagamento: '',
      visiblePagamento: false,
      vlCredito: 0,
      vlDebito: 0,
      saldo: 0,
      corSaldo: '',
      //Custas do Processo
      codigoCustas: '',
      modalCustas: false,
      custasProcessos: [],
      custas: null,
      vlCustas: '',
      visibleCusas: false,
      vlCreditoCustas: 0,
      vlDebitoCustas: 0,
      saldoCustas: 0,
      corSaldoCustas: '',
      tiposCustas: [],
      tipoCusta: null,
      //Garantias de Processo
      codigoGarantia: '',
      garantiasProcesso: [],
      tipoGarantia: null,
      tiposGarantias: [],
      vlPenhora: '',
      visibleGarantias: false,
      modalGarantias: false,
      totalPenhora: 0,
      //historico do Processo
      codigoHistorico: '',
      historico: '',
      dataHistorico: '',
      dataOcorrencia: '',
      listaHistorico: [],
      modalHistorico: false,
      visibleHistorico: false,
      modalVisualizeHistorico: false,
      visibleVisualiseHistorico: false,
      //Tipos de Andamento Processual
      tiposAndamento: [],
      tipoAndamento: null,
      //Arquivos
      upLoadFiles: [],
      nome: '',
      dsArquivo: '',
      arquivosAtividades: [],
      modalDescricaoArquivo: false,
      modalDescricaoArquivoNovaAtividade: false,
      arquivo: null,
      arquivoCodigo: '',
      visibleExcluirArquivo: false,
      //processo Importancia
      iconeImportanteParaMim: 'p-button-rounded p-button-secondary',
      iconeImportanteParaMimTitle: 'Clique para favoritar o proceso',
      iconeImportanteParaEmpresa: '',
      iconeImportanteParaEmpresaTitle: '',
      iconeEstrategico: '',
      iconeEstrátegicoTitle: '',
      processoImportancia: null,
      //Atividades
      atividades: [],
      //Alterar Atividade
      atividade: null,
      codigo: '',
      titulo: '',
      descricao: '',
      dtLimite: '',
      dtFatal: '',
      tipo: '',
      status: '',
      hora: '',
      displayAtividade: false,
      displayProcesso: false,
      displayAtividadeAlterar: false,
      displayProcesso: false,
      displayDescricao: false,
      tipoAtividade: null,
      grupos: [],
      usuarios: [],
      selectGrupo: null,
      subGrupos: [],
      selectSubGrupo: null,
      responsaveis: [],
      interessados: [],
      interessado: null,
      pesquisaProcesso: '',
      sizePesquisa: 'col-sm-12',
      escondeBotalExcluirPesquisa: {display: 'none'},
      bloqueiaGrupo: false,
      optionStatus: null,
      responsaveisLista: [],
      quantidadeResponsaveis: '',
      interessadosLista: [],
      quantidadeInteressados: '',
      nomeGrupoTrabalho: '',
      detail: '',
      //Histórico da Atividade
      historico: [],
      registroHistorico: null,
      displayHistorico: null,
      dsHistorico: '',
      displayHistoricoIncluir: false,
      visibleHistorico: false,
      //Arquivos Anexados da atividade
      exibirLinkAnexo: 'none',
      displayArquivosAnexadosAtividade: false,
      upLoadFiles: [],
      nome: '',
      dsArquivo: '',
      modalDescricaoArquivoAtividade: false,
      arquivo: null,
      arquivoCodigo: '',
      visibleExcluirArquivo: false,
      arquivosNovaAtividade: [],
      displayAnexoNovaAtividade: false,
      //Lançamentos Financeiros
      lancamentosFinanceiros: [],
      lancamento: null,
      displayConsultaLancamento: false,
      displayPagarLancamento: false,
      tipo: '',
      categoriaNome: '',
      tipoNome: '',
      vlLancamento: '',
      vlLancamentoMascara: '',
      vlPagoMascara: '',
      dtVencimento: '',
      vlPago: '',
      dtPago: '',
      dsLancamento: '',
      observacao: '',
      situacao: '',
      vlLancamentoNovo: '',
      dtVencimentoNovo: '',
      modalDespesaPagamento: false,
      modalReceitaPagamento: false,
      //Cadastro de nova Pessoa
      modalNovoCliente: null,
      nome: '',
      selectTipo: null,
      perfil: null,
      perfis: [],
      selectCidade: null,
      selectEstado: null,
      estados: [],
      cidades: [],
      openSpinner: false,
      //Motivo Resultado
      motivos: [],
      motivo: null,
      //Agravo e Apenso
      agravosApensos: [],
      agravoApenso: null,
      tipoProcessoAgravoApenso: null,
      numeroAgravoApenso: '',
      parteAgravoApenso: null,
      nomeParteAgravoApenso: '',
      tipoParteAgravoApenso: null,
      camara: '',
      relator: '',
      agravoApensoConsulta: null,
      camaraConsulta: '',
      relatorConsulta: '',
      exibirAgravoApenso: 'none',
      exibirAgravoApensoNegacao: 'block',
      modalAgravoApenso: false,
      agravoApensoExistente: null,
      modalAgravoApensoExistente: false,
      codigoProcessoExistente: '',
      codigoAgravoApenso: '',
      linkProcessoPrincipal: '',
      exibeLInkProcessoPrincipal: 'none',
      paramProcessoPrincipal: '',
      mudancaDataAtividade: false,
      //Ritos e Fases de Processo
      ritos: [],
      rito: null,
      fases: [],
      fase: null,
      //Informações do processo na tela de edição de atividade
      partes: '',
      favorito: '',
      titleFavorito: '',
      exibirFavorito: '',
      importante: '',
      titleImportante: '',
      exibirImportanteEmpresa: '',
      mudancaDataHistorico: [],
      //Títulos de Atividades
      titulos: [],
      tituloAtividade: null,
      //Tarefas Agrupadas
      modalTarefaAgrupada: false,
      grupoTarefa: null,
      tarefas: [],
      gruposTarefas: [],
      exibirComponentes: 'none',
      exibirComponentesGrupos: 'none',
      usuariosTarefas: [],
      //Recorrência
      recorrencia: null,
      repeticao: null,
      classeDiv: 'hide',
      desabilitaBotao: false,
      separador: 'none',
      //Fases da atividade
      fasesAtividade: [],
      faseAtividade: null,
      //Informações de Usuários da Tarefa
      modalInformacaoUsuario: false,
      //Partes
      montaPartes: '',
      //Gráfico das fases das atividades
      graficoAtividadeFasesPie: null,
      graficoStatusData: null,
      //Bancada
      bancadas: [],
      bancada: null,
      //Liminar
      liminar: null,
      liminares: [],
      setorInterno: null,
      //Cadastro
      codigoLiminar: '',
      liminarDecisao: null,
      liminarDtFatal: '',
      liminarMultaDiaria: '',
      liminarTetoMulta: '',
      modalLiminar: false,
      modalAlterarLiminar: false,
      //Decisões
      decisao: null,
      decisoes: [],
      setorInternoDecisao: null,
      //Cadastro
      codigoDecisao: '',
      decisaoDecisao: '',
      decisaoDtFatal: '',
      decisaoMultaDiaria: '',
      decisaoTetoMulta: '',
      modalDecisao: false,
      modalAlterarDecisao: false,
      //Arquivado
      exibeDatasStatusProcessual: 'none',
      dataArquivamento: '',
      dataArquivamentoTj: '',
      usuarioArquivou: '',
      isArquivar: false,
      resultadoArquivamento: null,
      //Risco
      risco: null,
      //Alterações Branch Melhorias
      observacaoPedido: '',
      valorPedido: '',
      observacaoDecisao: '',
      onservacaoLiminar: '',
      //Recurso
      tipoRecurso: null,
      parteRecurso: null,
      partesRecuso: [],
      modalRecurso: false,
      statusRecursoApenso: null,
      statusRecursoApensos: [],
      observacaoRecursoApenso: '',
      //Provisões Judiciais
      tipoProvisao: null,
      tiposProvisao: [],
      provisaoJudicial: null,
      codigoProvisao: '',
      observacaoProvisao: '',
      provisoesJudiciais: [],
      modalProvisaoJudicial: false,
      modalProvisaoJudicialAlterar: false,
    };

    this.tipoDecisao = [
      {codigo: 'DEFERIDO', nome: 'Deferido'},
      {codigo: 'INDEFERIDO', nome: 'Indeferido'}
    ]

    this.options = this.getLightTheme();

    this.recorrencia = [
      {codigo: '2', nome: '2'},
      {codigo: '3', nome: '3'},
      {codigo: '4', nome: '4'},
      {codigo: '5', nome: '5'},
      {codigo: '6', nome: '6'},
      {codigo: '7', nome: '7'},
      {codigo: '8', nome: '8'},
      {codigo: '9', nome: '9'},
      {codigo: '10', nome: '10'},
      {codigo: '11', nome: '11'},
      {codigo: '12', nome: '12'},
      {codigo: '13', nome: '13'},
      {codigo: '14', nome: '14'},
      {codigo: '15', nome: '15'},
      {codigo: '16', nome: '16'},
      {codigo: '17', nome: '17'},
      {codigo: '18', nome: '18'},
      {codigo: '19', nome: '19'},
      {codigo: '20', nome: '20'},
      {codigo: '21', nome: '21'},
      {codigo: '22', nome: '22'},
      {codigo: '23', nome: '23'},
      {codigo: '24', nome: '24'}
    ];

    this.autoresAgravoApenso = [];
    this.reusAgravoApenso = [];
    this.partesAgravoApenso = [];

    this.tipoParte = [
      {codigo: 'RD', nome: 'Recorrido'},
      {codigo: 'RT', nome: 'Recorrente'},
    ]

    this.tiposProcessoAgravoApenso = [
      {codigo: 'ET', nome: 'Embargante'},
      {codigo: 'EG', nome: 'Embargado'},
      {codigo: 'ED', nome: 'Embargos de Declaração'},
      {codigo: 'CP', nome: 'Cumprimento Provisório'},
      {codigo: 'EX', nome: 'Embargos a Execução,'},
      {codigo: 'RP', nome: 'RESP'},
      {codigo: 'RX', nome: 'REX'},
      {codigo: 'OT', nome: 'Outros'}
    ]

    this.tiposPessoa = [
      {codigo: 'F', nome: 'Física'},
      {codigo: 'J', nome: 'Jurídica'}
    ]

    this.contingenciaContabil = [
      {codigo: 'PO', nome: 'Possível'},
      {codigo: 'PR', nome: 'Provável'},
      {codigo: 'RE', nome: 'Remoto'}
    ];

    this.tiposPagamentosCustas =[
      {codigo: 'C', nome: 'Crédito'},
      {codigo: 'D', nome: 'Débito'}
    ]

    this.estados = [
      {codigo: 'AC', nome: 'Acre'},
      {codigo: 'AL', nome: 'Alagoas'},
      {codigo: 'AM', nome: 'Amazonas'},
      {codigo: 'AP', nome: 'Amapá'},
      {codigo: 'BA', nome: 'Bahia'},
      {codigo: 'CE', nome: 'Ceará'},
      {codigo: 'DF', nome: 'Distrito Federal'},
      {codigo: 'ES', nome: 'Espírito Santo'},
      {codigo: 'GO', nome: 'Goiás'},
      {codigo: 'MA', nome: 'Maranhão'},
      {codigo: 'MG', nome: 'Minas Gerais'},
      {codigo: 'MS', nome: 'Mato Grosso do Sul'},
      {codigo: 'MT', nome: 'Mato Grosso'},
      {codigo: 'PA', nome: 'Pará'},
      {codigo: 'PB', nome: 'Paraíba'},
      {codigo: 'PE', nome: 'Pernambuco'},
      {codigo: 'PI', nome: 'Piauí'},
      {codigo: 'PR', nome: 'Paraná'},
      {codigo: 'RJ', nome: 'Rio de janeiro'},
      {codigo: 'RN', nome: 'Rio Grande do Norte'},
      {codigo: 'RO', nome: 'Rondônia'},
      {codigo: 'RR', nome: 'Roraima'},
      {codigo: 'RS', nome: 'Rio Grande do Sul'},
      {codigo: 'SC', nome: 'Santa Catarina'},
      {codigo: 'SE', nome: 'Sergipe'},
      {codigo: 'SP', nome: 'São Paulo'},
      {codigo: 'TO', nome: 'Tocantins'}
    ];

    this.tipoPartes = [
      {codigo: 'A', nome: 'Autor'},
      {codigo: 'R', nome: 'Réu'},
      {codigo: 'AD', nome: 'Advogado'},
      {codigo: 'EM', nome: 'Embargante'},
      {codigo: 'RE', nome: 'Reclamado'},
      {codigo: 'TE', nome: 'Testemunha'},
      {codigo: 'EN', nome: 'Envolvido'},
      {codigo: 'IN', nome: 'Inventariante'},
      {codigo: 'RC', nome: 'Reclamante'},
      {codigo: 'NO', nome: 'Notificado'},
      {codigo: 'NC', nome: 'Notificante'},
      {codigo: 'RT', nome: 'Recorrente'},
      {codigo: 'RD', nome: 'Recorrido'}
    ];

    this.setoresInterno = [
      {codigo: 'OP', nome: 'OPME'},
      {codigo: 'AT', nome: 'ATENDIMENTO'},
      {codigo: 'FA', nome: 'FARMÁCIA'},
      {codigo: 'CA', nome: 'CADASTRO'},
      {codigo: 'IN', nome: 'INTERCÂMBIO'},
      {codigo: 'FR', nome: 'FINANCEIRO A RECEBER'},
      {codigo: 'HC', nome: 'HOME CARE'}
    ];

    this.resultadoArquivamento = [
      {codigo: 'I', nome: 'Improcedente'},
      {codigo: 'P', nome: 'Procedente'},
      {codigo: 'E', nome: 'Extinto'},
      {codigo: 'A', nome: 'Acordo'}
    ];

    this.riscos = [
      {codigo: 'P', nome: 'Possível'},
      {codigo: 'V', nome: 'Provável'},
      {codigo: 'R', nome: 'Remoto'}
    ]

    this.objetosProcesso = [];

    addLocale('es', {
      firstDayOfWeek: 1,
      dayNames: ['Domingo', 'Domingo', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
      dayNamesShort: ['Domingo', 'Domingo', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
      dayNamesMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
      monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Stembro', 'Outubro', 'Novembro', 'Dezemro'],
      monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
      today: 'Hoy',
      clear: 'Claro'
    });
  }

  listarStatusRecursoApensos = async () => {
    await this.statusrecursoApensoService.listar()
      .then(response => {
        this.setState({statusRecursoApensos: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Status Rcurso Apenso', detail:`${error}`, life: 4000});
      })
  }

  retornaLiminares = async (processo) => {
    await this.liminarService.listar(processo.codigo)
      .then(response => {
        this.setState({liminares: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Liminar', detail:`${this.state.detail}`, life: 4000});
      })
  }

  retornaProvisoesJudiciais = async(processo) => {
    await this.provisaoJudicialService.provisoesPorProcesso(processo.codigo)
      .then(response => {
        this.setState({provisoesJudiciais: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Provisões Judiciais', detail:`${this.state.detail}`, life: 4000});
      })
  }

  retornaDecisoes = async (processo) => {
    await this.decisaoService.listar(processo.codigo)
      .then(response => {
        this.setState({decisoes: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Liminar', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarUsuarios = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.usuarioService.listarUsuariosEmpresa(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({usuarios: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao listar usuários', life: 4000});
      })
  }

  listarFases = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.faseTarefaService.listar(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({fasesAtividade: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar Fases da Atividade', life: 4000});
      })
  }

  listarFasesTarefasPorTitulo = async (titulo) => {
    await this.tituloAtividadeFaseService.listar(titulo.codigo)
      .then(response => {
        this.setState({fasesAtividade: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar Fases da Atividade por Título', life: 4000});
      })
  }

  //Tarefas Agrupdas
  renderFooterAtividadeAgrupada(name) {
    return (
        <div className="left">
            <Button label="Cadastrar"
                    className="p-button-primary p-button-text"
                    onClick={this.cadastrartividadeAgrupada}/>
            &nbsp;
            <Button label="Cancelar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModalAtividade(name)}/>
        </div>
    );
  }

  renderFooterInformacaoUsuario(name) {
    return (
      <div className="left">
          <Button label="Fechar" 
                  className="p-button-secondary p-button-text"
                  onClick={() => this.fecharModalAtividade(name)}/>
      </div>
    );
  }
  
  //Atividades Agrupadas
  listarGruposTarefas = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.grupoTarefaService.listar(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({gruposTarefas: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Grupos de Tarefas', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarTarefas = async (grupo) => {
    await this.tarefaService.listarTarefasPorGrupo(grupo.codigo)
      .then(response => {
        this.setState({tarefas: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Tarefas', detail:'Erro ao tentar listar tarefas por grupo', life: 4000});
      })
  }
  async consultarUsuariosTarefas(tarefa) {
    await this.tarefaService.listarUsuariosPorTarefa(tarefa.codigo)
      .then(response => {
        this.setState({usuariosTarefas: response.data});
        this.abrirModalInformacaoUsuario('modalInformacaoUsuario');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      });
  }

  abrirModalInformacaoUsuario(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  informacoesUsuariosTarefas(rowData) {
    return(
      <React.Fragment>
        <Button icon="fas fa-users" className="p-button-rounded p-button-text" 
                tooltip="Clique para saber os usuários designados para esta tarefa"
                onClick={() => this.consultarUsuariosTarefas(rowData)} 
                tooltipOptions={{position: 'top'}} />
      </React.Fragment>
    );
  }

  async onChangeGrupoTarefa(e) {
    if(e.value != null) {
      this.setState({openSpinner: true});
      this.setState({grupoTarefa: e.value});
      await this.listarTarefas(e.value);
      if(this.state.tarefas.length > 0) {
        this.setState({exibirComponentes: 'block'});
        this.setState({exibirComponentesGrupos: 'block'});
        this.setState({dataLimite: ''});
      }
      this.setState({openSpinner: false});
    } else {
      this.setState({exibirComponentes: 'none'});
      this.setState({exibirComponentesGrupos: 'none'});
      this.setState({tarefas: null});
      this.setState({grupoTarefa: null});
    }
  }
 
  async abrirModalAtividadeAgrupada(name, position) { 
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState({openSpinner: true});
    this.setState({exibirComponentes: 'none'});
    this.setState({exibirComponentesGrupos: 'none'});
    await this.listarGruposTarefas();
    
    this.consultarSubGrupos(this.state.grupoTrabalho.grupoPai);
    this.setState({grupoTrabalhoNome: this.state.grupoTrabalho.nome});
    if(this.state.nrCnj == null) {
      this.setState({pesquisaProcesso: this.state.nrProcesso});
    } else {
      this.setState({pesquisaProcesso: this.state.nrCnj});
    }

    this.setState({dtLimite: ''});
    this.setState({grupoTarefa: null});
    this.setState({tarefas: null});
    this.setState(state);
    this.setState({openSpinner: false});
  }

  cadastrartividadeAgrupada = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(this.state.selectSubGrupo == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o Sub-Grupo de Trabalho', life: 4000});
      return false;
    }

    if(this.state.dtLimite == '' || this.state.dtLimite == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe a Data Limite', life: 4000});
      return false;
    }
    //Data Limite
    var tipoTarefa = '';
    var dataFormatadaDataLimite = '';
    if(this.state.dtLimite != '' && this.state.dtLimite != null) {
      var date = this.state.dtLimite;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      dataFormatadaDataLimite =  year+"-"+month+"-"+day;
    }
    const atividades = {
      usuario: usuarioLogado,
      tarefas: this.state.tarefas,
      grupoTarefa: this.state.grupoTarefa.codigo,
      dataLimite: dataFormatadaDataLimite,
      grupo: this.state.selectSubGrupo,
      processo: this.state.processo,
      descricao: this.state.descricao
    }

    this.setState({openSpinner: true});
    await this.atividadeService.cadastrarAtividadeAgrupada(atividades)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Tarefas', detail:'Tarefa cadastrada com sucesso!', life: 4000});
        this.fecharModalAtividade('modalTarefaAgrupada');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Grupos de Tarefas', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  onMudancaData(e) {
    let selectedCities = [...this.state.mudancaDataHistorico];

    if (e.checked)
        selectedCities.push(e.value);
    else
        selectedCities.splice(selectedCities.indexOf(e.value), 1);

    this.setState({ mudancaDataHistorico: selectedCities });
  }

  listarTitulosAtividade = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.tituloAtividadeService.listar(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({titulos: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar Títulos de Atividades', life: 4000});
      })
  }

  listarFasesProcessuais = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.faseService.listar(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({fases: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Fases Processuais', detail:'Erro ao carregar fases processuais', life: 4000});
      })
  }

  listarRitosProcessuais = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.ritoService.listar(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({ritos: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Ritos Processuais', detail:'Erro ao carregar ritos processuais', life: 4000});
      })
  }

  consultarAgravoApensoExistente = async () => {
    if(this.state.numeroAgravoApenso != '' && this.state.numeroAgravoApenso != null) {
      const usuarioLogado = this.context.usuarioAutenticado;
      this.setState({openSpinner: true});
      await this.agravoApensoService.consultarPorNumero(this.state.numeroAgravoApenso,usuarioLogado.empresa.codigo)
        .then(response => {
          console.log('Calma', response.data);
          if(response.data.codigo != null) {
            this.setState({agravoApensoExistente: response.data});
            this.setState({codigoProcessoExistente: response.data.codigo});
            this.abrirModalAgravoApensoProcessoExistente('modalAgravoApensoExistente')
          }
        }).catch(error => {
          console.log('Processo não encontrado')
        });
        this.setState({openSpinner: false});
      }
  }

  carregaProcessoExistenteAgravoApenso = async () => {
    this.setState({openSpinner: true});
    await this.agravoApensoService.consultarProcessoExistente(this.state.codigoProcessoExistente)
      .then(response => {
        this.setState({agravoApensoExistente: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Agravo/Apenso', detail:'Erro ao buscar processo já existente', life: 4000});
        return;
      });
      let partes = null;
      for(let i = 0; i < this.state.agravoApensoExistente.autores.length; i++) {
        partes = {
          nome: this.state.agravoApensoExistente.autores[i].nome,
          tipo: {
            codigo: 1,
            nome: 'Autor'
          }
        };
        this.partesAgravoApenso.push(partes);
      }

      for(let i = 0; i < this.state.agravoApensoExistente.reus.length; i++) {
        partes = {
          nome: this.state.agravoApensoExistente.reus[i].nome,
          tipo: {
            codigo: 2,
            nome: 'Reu'
          }
        };
        this.partesAgravoApenso.push(partes);
      }

      this.fecharModal('modalAgravoApensoExistente');
      this.setState({openSpinner: false});
  }

  renderFooterCadastroAgravoApenso(name) {
    return (
        <div>
          <Button label="Cadastrar" 
                  className="p-button-primary p-button-text"
                  onClick={this.cadastrarAgravoApenso}/>
          &nbsp;
          <Button label="Fechar" 
                  className="p-button-secondary p-button-text" 
                  onClick={() => this.fecharModalCadastro(name)}/>
        </div>
    );
  }

  renderFooterCadastroRecurso(name) {
    return (
        <div>
          <Button label="Cadastrar" 
                  className="p-button-primary p-button-text"
                  onClick={this.cadastrarRecurso}/>
          &nbsp;
          <Button label="Fechar" 
                  className="p-button-secondary p-button-text" 
                  onClick={() => this.fecharModalCadastro(name)}/>
        </div>
    );
  }

  cadastrarRecurso = async () => {
    if(this.state.numeroAgravoApenso == '') {
      this.toast.show({severity:'error', summary: 'Recurso', detail:'Informe o número do processo', life: 4000});
      return;
    }

    if(this.state.tipoProcessoAgravoApenso == null) {
      this.toast.show({severity:'error', summary: 'Recurso', detail:'Informe o tipo de processo', life: 4000});
      return;
    }

    if(this.partesAgravoApenso.length === 0) {
      this.toast.show({severity:'error', summary: 'Recurso', detail:'Nenhuma parte informada', life: 4000});
      return;
    }

    var partes = [];
    
    for(let i = 0; i < this.partesAgravoApenso.length; i++) {
      partes.push({
        pessoa: this.partesAgravoApenso[i].parte,
        tipo: this.partesAgravoApenso[i].tipo.codigo
      })
    }

    const usuarioLogado = this.context.usuarioAutenticado;

    const objeto = {
      processoPrincipal: this.state.processo,
      processo: {
        nrCnj: this.state.numeroAgravoApenso
      },
      camara: this.state.camara,
      relator: null,
      partes: partes,
      tipo: this.state.tipoProcessoAgravoApenso.codigo,
      tipoProcesso: 'R',
      observacao: this.state.observacaoRecursoApenso,
      status: this.state.statusRecursoApenso,
      usuario: usuarioLogado
    }

    this.setState({openSpinner: true});
    await this.agravoApensoService.cadastrarAgravoApenso(objeto)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Agravo/Apenso', detail:'Registro inserido com sucesso', life: 4000});
        this.listarAgravosApensos();
        this.fecharModal('modalRecurso');
      }).catch(error => {
        console.log('Erro ', error);
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Recuro de Proceso', detail:`${error}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  cadastrarAgravoApenso = async () => {
    if(this.state.numeroAgravoApenso == '') {
      this.toast.show({severity:'error', summary: 'Agravo/Apenso', detail:'Informe o número do processo', life: 4000});
      return;
    }

    if(this.state.tipoProcessoAgravoApenso == null) {
      this.toast.show({severity:'error', summary: 'Agravo/Apenso', detail:'Informe o tipo de processo', life: 4000});
      return;
    }

    if(this.partesAgravoApenso.length === 0) {
      this.toast.show({severity:'error', summary: 'Agravo/Apenso', detail:'Nenhuma parte informada', life: 4000});
      return;
    }

    var parteAutor = false;
    var parteReu = true;
    for(let i = 0; i < this.partesAgravoApenso.length; i++) {
      if(this.partesAgravoApenso[i].tipo.codigo == 1) {
        parteAutor = true;
      }

      if(this.partesAgravoApenso[i].tipo.codigo == 2) {
        parteReu = true;
      }
    }

    if(!parteAutor && !parteReu) {
      this.toast.show({severity:'error', summary: 'Agravo/Apenso', detail:'Uma das partes está faltando no processo', life: 4000});
      return;
    }

    var partes = [];
    
    for(let i = 0; i < this.partesAgravoApenso.length; i++) {
      partes.push({
        pessoa: {
          nome: this.partesAgravoApenso[i].nome
          },
        tipo: this.partesAgravoApenso[i].tipo.codigo
      })
    }
    const usuarioLogado = this.context.usuarioAutenticado;
    const objeto = {
      processoPrincipal: this.state.processo,
      processo: {
        nrCnj: this.state.numeroAgravoApenso
      },
      camara: this.state.camara,
      relator: this.state.relator,
      partes: partes,
      tipo: this.state.tipoProcessoAgravoApenso.codigo,
      usuario: usuarioLogado
    }
    this.setState({openSpinner: true});
    await this.agravoApensoService.cadastrarAgravoApenso(objeto)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Agravo/Apenso', detail:'Registro inserido com sucesso', life: 4000});
        this.listarAgravosApensos();
        this.fecharModal('modalAgravoApenso');
      }).catch(error => {
        this.setState(error.response.data);
        //console.log(error);
        this.toast.show({severity:'error', summary: 'Status de Atividade', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  consultarProcessoPrincipal = () => {
    this.setState({paramProcessoPrincipal: `#/fichaProcesso/${this.state.processo.processoPrincipal.codigo}/SEARCH`});
    //this.props.history.push(`/fichaProcesso/${this.state.processo.processoPrincipal.codigo}/SEARCH`);
  }

  renderFooterAgravoApensoExistente(name) {
    return (
        <div>
          <Button label="Confirmar" 
                  className="p-button-primary p-button-text"
                  onClick={this.carregaProcessoExistenteAgravoApenso}/>
          &nbsp;
          <Button label="Cancelar" 
                  className="p-button-danger p-button-text" 
                  onClick={this.cancelarConsultaAgravoApenso}/>
        </div>
    );
  }

  cancelarConsultaAgravoApenso = () => {
    this.setState({numeroAgravoApenso: ''});
    this.setState({agravoApensoExistente: null});
    this.fecharModal('modalAgravoApensoExistente');
  }

  async abrirModalAgravoApensoProcessoExistente(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  async abrirModalAgravoApenso(name, position) {
    this.setState({openSpinner: true});
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.limparCamposAgravoApenso();
    this.setState({openSpinner: false});
    this.setState(state);
  }

  abrirModalReurso(name, position) {
    this.setState({openSpinner: true});
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.listarStatusRecursoApensos(); 
    this.limparCamposRecursos();
    this.setState({openSpinner: false});
    this.setState(state);
  }

  limparCamposRecursos = () => {
    this.setState({tipoRecurso: null}); 
    this.setState({parteRecurso: null});
    this.setState({numeroAgravoApenso: ''});
    this.setState({tipoProcessoAgravoApenso: null});
    this.setState({tipoRecurso: null});
    this.partesAgravoApenso = [];
  } 

  async abrirModalAgravoApenso2(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  limparCamposAgravoApenso = () => {
    this.setState({agravoApenso: null});
    this.setState({numeroAgravoApenso: ''});
    this.setState({nomeParteAgravoApenso: ''});
    this.setState({parteAgravoApenso: null});
    this.setState({camara: ''});
    this.setState({relator: ''});
    this.autoresAgravoApenso = [];
    this.reusAgravoApenso = [];
    this.partesAgravoApenso = [];
  } 

  incluirParteAgravoApenso = () => {
    if(this.state.parteRecurso == null) {
      this.toast.show({severity:'error', summary: 'Recurso', detail:'Informe o nome da parte', life: 4000});
      return;
    }

    if(this.state.tipoRecurso == null) {
      this.toast.show({severity:'error', summary: 'Recusro', detail:'Informe tipo da parte', life: 4000});
      return;
    }

    const parte = {
      parte: this.state.parteRecurso,
      tipo: this.state.tipoRecurso
    }

    this.partesAgravoApenso.push(parte);
    this.setState({parteRecurso: null});
    this.setState({tipoRecurso: null});

    this.abrirModalAgravoApenso2('modalAgravoApenso');
  }

  acoesProcessoAgravosApensos(rowData) {
    return (
      <div>
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                onClick={() => this.confirmaExclusaoAgravoApenso(rowData)} 
                tooltip="Excluir Agravo/Apenso" 
                tooltipOptions={{position: 'top'}}/>
      </div>
    );
  }

  confirmaExclusaoAgravoApenso(processo) {
    this.setState({codigoAgravoApenso: processo.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir este registro?',
        header: 'Exclusão de registro de Agravo Apenso',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirAgravoApenso,
        reject: this.reject
    });
  }

  acceptExcluirAgravoApenso() {
    this.excluirAgravoApenso();
  }

  excluirAgravoApenso = async () => {
    this.setState({openSpinner: true});
    await this.agravoApensoService.excluirRegistro(this.state.codigoAgravoApenso)
      .then(response => {
        this.listarAgravosApensos();
        this.toast.show({severity:'success', summary: 'Agravo/Apenso', detail:'Registro excluído com sucesso', life: 4000});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Agravo/Apenso', detail:'Erro ao excluir registro', life: 4000});
      });

      this.setState({openSpinner: false});
  }

  listarAgravosApensos = () => {
    this.agravoApensoService.listar(this.state.processo.codigo)
      .then(response => {
        this.setState({agravosApensos: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Agravo/Apenso', detail:'Erro ao listar processo de Agravo/Apenso', life: 4000});
      })
  }

  acoesPartesAgravoApenso(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                tooltip="Excluir Parte"
                onClick={() => this.excluirParteAgravoApenso(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
      </React.Fragment>
    );
  }

  excluirParteAgravoApenso(parte) {
    for(let i = 0; i < this.partesAgravoApenso.length; i++) {
      if(parte.nome === this.partesAgravoApenso[i].nome) {
        this.partesAgravoApenso.splice(i,1);
        this.abrirModalAgravoApenso2('modalAgravoApenso');
        return;
      }
    }
  }

  listarMotivosResultado = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.motivoResultadoService.listar(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({motivos: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao carregar Motivos de Resultado', life: 4000});
      })
  }

  listarTiposAndamento = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.tipoAndamentoProcessualService.listar(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({tiposAndamento: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Tipos de Andamento Processual', detail:`${this.state.detail}`, life: 4000});
      });
  }

  listarPedidos = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.pedidoService.listarPedidos(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({pedidos: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Status de Atividade', detail:`${this.state.detail}`, life: 4000});
      })
  }

  async abrirModalPedidos(name, position) {
    this.setState({openSpinner: true});
    await this.listarPedidos();
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.limparCampospedidos();
    this.setState({openSpinner: false});
    this.setState(state);
  }

  limparCampospedidos = () => {
    this.setState({pedido: null});
    this.setState({valorPedido: ''});
    this.setState({observacaoPedido: ''});
  }
  //Emilia
  async abrirModalDecisao(name, position) {
    this.setState({openSpinner: true});
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.limparCamposDecisao();
    this.setState({openSpinner: false});
    this.setState(state);
  }

  acoesDecisoes(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-pencil" className="p-button-rounded p-button-text" 
                tooltip="Editar Decisão"
                onClick={() => this.consultarDecisao(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                tooltip="Excluir Decisão"
                onClick={() => this.confirmaExclusaoDecisao(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
      </React.Fragment>
    );
  }

  confirmaExclusaoDecisao(decisao) {
    this.setState({codigoDecisao: decisao.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir a decisão selecionada ?',
        header: 'Exclusão de Decisão',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirDecisao,
        reject: this.reject
    });
  }

  acceptExcluirDecisao() {
    this.excluirDecisao();
  }

  excluirDecisao = async () => {
    this.setState({openSpinner: true});
    await this.decisaoService.excluir(this.state.codigoDecisao)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Decisão', detail:'Decisão excluída com sucesso!', life: 4000});
        this.retornaLiminares(this.state.processo);
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Decisão', detail:`${error}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  async consultarDecisao(decisao){
    this.setState({openSpinner: true});
    await this.decisaoService.consultar(decisao.codigo)
      .then(response => {
        this.setState({decisao: response.data});
        this.setState({codigoDecisao: response.data.codigo});
        if(response.data.decisao == 'DEFERIDO') {
          this.setState({decisaoDecisao: {
            codigo: 'DEFERIDO',
            nome: 'Deferido'
          }});
        } else {
          this.setState({decisaoDecisao: {
            codigo: 'INDEFERIDO',
            nome: 'Indeferido'
          }});
        }
        if(response.data.dtFatal != null) {
          var dataSet = new Date(response.data.dtFatal);
          dataSet.setDate(dataSet.getDate()+1);
          this.setState({decisaoDtFatal: dataSet});
        }
        this.setState({decisaoMultaDiaria: response.data.multaDiaria});
        this.setState({observacaoDecisao: response.data.observacao});
        if(response.data.setorInterno == 'OP') {
          this.setState({setorInternoDecisao: {codigo: 'OP', nome: 'OPME'}});
        } else if(response.data.setorInterno == 'AT') {
          this.setState({setorInternoDecisao: {codigo: 'AT', nome: 'ATENDIMENTO'}});
        } else if(response.data.setorInterno == 'FA') {
          this.setState({setorInternoDecisao: {codigo: 'FA', nome: 'FARMÁCIA'}});
        } else if(response.data.setorInterno == 'CA') {
          this.setState({setorInternoDecisao: {codigo: 'CA', nome: 'CADASTRO'}});
        } else if(response.data.setorInterno == 'IN') {
          this.setState({setorInternoDecisao: {codigo: 'IN', nome: 'INTERCÂMBIO'}});
        } else if(response.data.setorInterno == 'FR') {
          this.setState({setorInternoDecisao: {codigo: 'FR', nome: 'FINANCEIRO A RECEBER'}});
        } else {
          this.setState({setorInternoDecisao: {codigo: 'HC', nome: 'HOME CARE'}});
        }
        this.abrirModaAlterarlLiminar('modalAlterarDecisao');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Decisão', detail:`${error}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  limparCamposDecisao = () => {
    this.setState({decisaoDecisao: ''});
    this.setState({decisaoDtFatal: ''});
    this.setState({setorInternoDecisao: null});
    this.setState({decisaoMultaDiaria: ''});
    this.setState({decisaoTetoMulta: ''});
  }

  abrirModaAlterarlDecisao(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  cadastrarDecisao = async () => {
    if(this.state.decisaoDecisao == '') {
      this.toast.show({severity:'error', summary: 'Decisão', detail:'Informe o Tipo de  decisão', life: 4000});
      return;
    }

    if(this.state.decisaoDtFatal == '') {
      this.toast.show({severity:'error', summary: 'Decisão', detail:'Informe a data de Decisão', life: 4000});
      return;
    }

    if(this.state.multaDiaria == '') {
      this.toast.show({severity:'error', summary: 'Decisão', detail:'Informe o valor da condenação', life: 4000});
      return;
    }

    if(this.state.decisaoDtFatal != '') {
      var date = this.state.decisaoDtFatal;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      var dataFormatadaDecisaoFatal =  year+"-"+month+"-"+day;
    }

    const decisao = {
      processo: this.state.processo,
      decisao: this.state.decisaoDecisao.codigo,
      dtFatal: dataFormatadaDecisaoFatal,
      multaDiaria: this.state.multaDiaria,
      //setorInterno: 'CA',
      descSetorInterno: null,
      observacao: this.state.observacaoDecisao
      //tetoMultaDiaria: this.state.decisaoTetoMulta
    };

    this.setState({openSpinner: true});
    await this.decisaoService.cadastrar(decisao)
      .then(response => {
        this.retornaDecisoes(this.state.processo);
        this.toast.show({severity:'success', summary: 'Decisão', detail:'Decisão cadastrada com sucesso', life: 4000});
        this.fecharModal('modalDecisao');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Decisões', detail:`${this.state.detail}`, life: 4000});
      })
      this.setState({openSpinner: false});
  }

  alterarDecisao = async () => {
    
    if(this.state.decisaoDecisao == '') {
      this.toast.show({severity:'error', summary: 'Decisão', detail:'Informe o Tipo de  decisão', life: 4000});
      return;
    }

    if(this.state.decisaoDtFatal == '') {
      this.toast.show({severity:'error', summary: 'Decisão', detail:'Informe a data de Decisão', life: 4000});
      return;
    }

    if(this.state.multaDiaria == '') {
      this.toast.show({severity:'error', summary: 'Decisão', detail:'Informe o valor da condenação', life: 4000});
      return;
    }

    if(this.state.decisaoDtFatal != '') {
      var date = this.state.decisaoDtFatal;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      var dataFormatadaDecisaoFatal =  year+"-"+month+"-"+day;
    }


    const decisao = {
      codigo: this.state.decisao.codigo,
      processo: this.state.processo,
      decisao: this.state.decisaoDecisao.codigo,
      dtFatal: dataFormatadaDecisaoFatal,
      multaDiaria: this.state.multaDiaria,
      //setorInterno: 'CA',
      descSetorInterno: null,
      observacao: this.state.observacaoDecisao
    };

    this.setState({openSpinner: true});
    await this.decisaoService.alterar(decisao)
      .then(response => {
        this.retornaDecisoes(this.state.processo);
        this.toast.show({severity:'success', summary: 'Frcisão', detail:'Decisão alterada com sucesso', life: 4000});
        this.fecharModal('modalAlterarDecisao');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Decição', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  async abrirModalLiminar(name, position) {
    this.setState({openSpinner: true});
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.limparCamposLiminar();
    this.setState({openSpinner: false});
    this.setState(state);
  }

  abrirModaAlterarlLiminar(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  limparCamposLiminar = () => {
    this.setState({liminarDecisao: ''});
    this.setState({liminarDtFatal: ''});
    this.setState({setorInterno: null});
    this.setState({liminarMultaDiaria: ''});
    this.setState({liminarTetoMulta: ''});
  }

  cadastrarLiminar = async () => {
    if(this.state.liminarDecisao == null) {
      this.toast.show({severity:'error', summary: 'Liminar', detail:'Informe a decisão', life: 4000});
      return;
    }

    if(this.state.liminarDtFatal == '') {
      this.toast.show({severity:'error', summary: 'Liminar', detail:'Informe a data da liminar', life: 4000});
      return;
    }

    if(this.state.liminarDtFatal != '') {
      var date = this.state.liminarDtFatal;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      var dataFormatadaLiminarFatal =  year+"-"+month+"-"+day;
    }

    const liminar = {
      decisao: this.state.liminarDecisao.codigo,
      processo: this.state.processo,
      decisao: this.state.liminarDecisao.codigo,
      dtFatal: dataFormatadaLiminarFatal,
      multaDiaria: this.state.liminarMultaDiaria,
      //setorInterno: 'CA',
      descSetorInterno: null,
      observacao: this.state.observacaoLiminar
    };

    this.setState({openSpinner: true});
    await this.liminarService.cadastrar(liminar)
      .then(response => {
        this.retornaLiminares(this.state.processo);
        this.toast.show({severity:'success', summary: 'Liminar', detail:'Liminar cadastrada com sucesso', life: 4000});
        this.fecharModal('modalLiminar');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Liminar', detail:`${this.state.detail}`, life: 4000});
      })
      this.setState({openSpinner: false});
  }

  cadastrarPedido = () => {
    if(this.state.pedido == null) {
      this.toast.show({severity:'error', summary: 'Pedidos do Processo', detail:'O pedido é obrigatório', life: 4000});
      return;
    }

    let encontrou = false;
    for(let i = 0; i < this.state.pedidosProcesso.length; i++) {
      if(this.state.pedido.codigo === this.state.pedidosProcesso[i].pedido.codigo) {
        encontrou = true;
      }
    };

    if(encontrou) {
      this.toast.show({severity:'error', summary: 'Pedidos do Processo', detail:'Pedido já cadastrado no processo', life: 4000});
      return;
    }

    let valorRemoto = 0;
    if(this.state.valorPedido != null || this.state.valorPedido != '') {
      valorRemoto = this.state.valorPedido;
    }

    const pedidoProcesso = {
      pedido: this.state.pedido,
      processo: this.state.processo,
      vlProvavel: 0,
      vlPossivel: 0,
      vlRemoto: valorRemoto,
      observacao: this.state.observacaoPedido,
      vlCausa: '0'
    }
    this.setState({openSpinner: true});
    this.pedidoProcessoService.cadastrarPedidoProcesso(pedidoProcesso)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Pedidos do Processo', detail:'Pedido cadastrado com sucesso', life: 4000});
        this.consultarPedidosProcesso();
        this.fecharModal('modalPedidos');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Pedidos do Processo', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  async consultarPedidoProcesso(pedido) {
    this.setState({openSpinner: true});
    await this.pedidoProcessoService.consultarPedidoProcesso(pedido.codigo)
      .then(response => {
        this.setState({pedidoProcesso: response.data});
        this.setState({pedido: response.data.pedido})
        //this.setState({vlPossivel: response.data.vlPossivel});
        //this.setState({vlProvavel: response.data.vlProvavel});
        this.setState({valorPedido: response.data.vlRemoto});
        this.setState({observacaoPedido: response.data.observacao});
        this.abrirModalPedidoProcesso('modalAlterarPedido')
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Pedidos do Processo', detail:`${error}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  async abrirModalPedidoProcesso(name, position) {
    await this.listarPedidos();
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  alterarPedidoProcesso = async () => {
    if(this.state.pedido == null) {
      this.toast.show({severity:'error', summary: 'Pedidos do Processo', detail:'O pedido é obrigatório', life: 4000});
      return;
    }

    let valorRemoto = 0;
    if(this.state.valorPedido != null || this.state.valorPedido != '') {
      valorRemoto = this.state.valorPedido;
    }

    this.setState({openSpinner: true});
    const pedidoAlterar = {
      codigo: this.state.pedidoProcesso.codigo,
      pedido: this.state.pedido,
      processo: this.state.processo,
      vlPossivel: 0,
      vlProvavel: 0,
      vlRemoto: valorRemoto,
      observacao: this.state.observacaoPedido
    };

    await this.pedidoProcessoService.alterarPedidoProcesso(pedidoAlterar)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Pedidos do Processo', detail:'Pedido do processo alterado com sucesso!', life: 4000});
        this.consultarPedidosProcesso();
        this.fecharModal('modalAlterarPedido');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Pedidos do Processo', detail:`${error}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  acoesPedidos(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-pencil" className="p-button-rounded p-button-text" 
                tooltip="Editar Pedido"
                onClick={() => this.consultarPedidoProcesso(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                tooltip="Excluir Pedido"
                onClick={() => this.confirmaExclusaoPedido(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
      </React.Fragment>
    );
  }

  acoesLiminares(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-pencil" className="p-button-rounded p-button-text" 
                tooltip="Editar Liminar"
                onClick={() => this.consultarLiminar(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                tooltip="Excluir Liminar"
                onClick={() => this.confirmaExclusaoLiminar(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
      </React.Fragment>
    );
  }

  acoesProvisoes(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-pencil" className="p-button-rounded p-button-text" 
                tooltip="Editar Provisão"
                onClick={() => this.consultarProvisaoJudicial(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                tooltip="Excluir Provisão"
                onClick={() => this.confirmaExclusaoProvisaoJudicial(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
      </React.Fragment>
    );
  }

  confirmaExclusaoLiminar(liminar) {
    this.setState({codigoLiminar: liminar.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir a lliminar selecionada ?',
        header: 'Exclusão de Liminar',
        icon: 'pi pi-question-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirLiminar,
        reject: this.reject
    });
  }

  acceptExcluirLiminar() {
    this.excluirLiminar();
  }

  excluirLiminar = async () => {
    this.setState({openSpinner: true});
    await this.liminarService.excluir(this.state.codigoLiminar)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Liminar de Processo', detail:'Liminar excluída com sucesso!', life: 4000});
        this.retornaLiminares(this.state.processo);
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Liminar de Processo', detail:`${error}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  async consultarLiminar(liminar){
    this.setState({openSpinner: true});
    await this.liminarService.consultar(liminar.codigo)
      .then(response => {
        this.setState({liminar: response.data});
        this.setState({codigo: response.data.codigo});
        if(response.data.decisao == 'DEFERIDO') {
          this.setState({liminarDecisao: {
            codigo: 'DEFERIDO',
            nome: 'Deferido'
          }});
        } else {
          this.setState({liminarDecisao: {
            codigo: 'INDEFERIDO',
            nome: 'Indeferido'
          }});
        }
        this.setState({observacaoLiminar: response.data.observacao});
        if(response.data.dtFatal != null) {
          var dataSet = new Date(response.data.dtFatal);
          dataSet.setDate(dataSet.getDate()+1);
          this.setState({liminarDtFatal: dataSet});
        }
        this.setState({liminarMultaDiaria: response.data.multaDiaria});
        this.setState({liminarTetoMulta: response.data.tetoMultaDiaria});
        if(response.data.setorInterno == 'OP') {
          this.setState({setorInterno: {codigo: 'OP', nome: 'OPME'}});
        } else if(response.data.setorInterno == 'AT') {
          this.setState({setorInterno: {codigo: 'AT', nome: 'ATENDIMENTO'}});
        } else if(response.data.setorInterno == 'FA') {
          this.setState({setorInterno: {codigo: 'FA', nome: 'FARMÁCIA'}});
        } else if(response.data.setorInterno == 'CA') {
          this.setState({setorInterno: {codigo: 'CA', nome: 'CADASTRO'}});
        } else if(response.data.setorInterno == 'IN') {
          this.setState({setorInterno: {codigo: 'IN', nome: 'INTERCÂMBIO'}});
        } else if(response.data.setorInterno == 'FR') {
          this.setState({setorInterno: {codigo: 'FR', nome: 'FINANCEIRO A RECEBER'}});
        } else {
          this.setState({setorInterno: {codigo: 'HC', nome: 'HOME CARE'}});
        }
        this.abrirModaAlterarlLiminar('modalAlterarLiminar');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Liminar de Processo', detail:`${error}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  confirmaExclusaoPedido(pedido) {
    this.setState({codigoPedidoProcesso: pedido.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir o pedido do processo?',
        header: 'Exclusão de Pagamento',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirPedido,
        reject: this.reject
    });
  }

  acceptExcluirPedido() {
    this.excluirPedido();
  }

  excluirPedido = async () => {
    await this.pedidoProcessoService.excluirPedido(this.state.codigoPedidoProcesso)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Pedidos do Processo', detail:'Pedido excluído com sucesso', life: 4000});
        this.consultarPedidosProcesso();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Pedidos do Processo', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarPedidosProcesso = async () => {
    await this.pedidoProcessoService.consultarPedidosProcesso(this.state.processo.codigo)
      .then(response => {
        this.setState({pedidosProcesso: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Pedidos do Processo', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarStatusAtividade = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.statusAtividadeService.listarStatus(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({statusAtividade: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Status de Atividade', detail:`${this.state.detail}`, life: 4000});
      });
  }

  listarEstados = async () => {
    this.estadoService.listarEstados()
      .then(response => {
        this.setState({estados: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao listar Estados', life: 4000});
      });
  }

  onChangeTipoPessoa(e) {
    this.setState({selectTipo: e.value});
  }

  async onChangeEstado(e) {
    await this.setState({selectEstado: e.value});
    this.listarCidades();
  }

  listarCidades = () => {
    this.cidadeService.listarCidades(this.state.selectEstado.codigo)
      .then(response => {
        this.setState({cidades: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao listar Cidades', life: 4000});
      })
  }

  onChangeCidade(e) {
    this.setState({selectCidade: e.value});
  }

  fecharModal(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  abrirModalCadastroCliente(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.listarEstados();
    this.setState({nome: ''});
    this.setState({selectTipo: null});
    this.setState({selectEstado: null});
    this.setState({selectCidade: null});
    this.setState(state);
  }

  async novoAutor() {
    await this.listarPerfisPessoa();
    this.abrirModalCadastroCliente('modalNovoCliente');
  }

  async novoReu() {
    await this.listarPerfisPessoa();
    this.abrirModalCadastroCliente('modalNovoCliente');
  }

  async novoAdvogado() {
    await this.listarPerfisPessoa();
    this.abrirModalCadastroCliente('modalNovoCliente');
  }

  cadastrarNovoCliente = async () => {
    const usuarioLogado = this.context.usuarioAutenticado

    if(this.state.nome == '') {
      this.toast.show({severity:'error', summary: 'Cadastro de nova Pessoa', detail:'Informe o nome da Pessoa', life: 4000});
      return false;
    }

    if(this.state.selectTipo == null || this.state.selectTipo.codigo == null) {
      this.toast.show({severity:'error', summary: 'Cadastro de nova Pessoa', detail:'Informe o Tipo de Pessoa', life: 4000});
      return false;
    }

    if(this.state.selectCidade == null || this.state.selectCidade.codigo == null) {
      this.toast.show({severity:'error', summary: 'Cadastro de nova Pessoa', detail:'Informe a Cidade', life: 4000});
      return false;
    }

    if(this.state.perfil == null) {
      this.toast.show({severity:'error', summary: 'Cadastro de nova Pessoa', detail:'Informe o perfil da pessoa', life: 4000});
      return false;
    }

    await this.pessoaService.cadastrarPessoaProcesso({
      nome: this.state.nome,
      tipoPessoa: this.state.selectTipo.codigo,
      perfil: this.state.perfil,
      cidade: this.state.selectCidade,
      empresa: usuarioLogado.empresa,
      usuario: usuarioLogado.codigo
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Cadastro de nova Pessoa', detail:'Nova Pessoa cadastrada com sucesso', life: 4000});
      this.fecharModal('modalNovoCliente');
      this.listarPessoasEmpresaParteCliente(this.state.processo.codigo);
      this.listarPessoasEmpresaParteContraria(this.state.processo.codigo);
      this.listarPessoasEmpresaAdvogados(this.state.processo.codigo);
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Cadastro de nova Pessoa', detail:`${this.state.detail}`, life: 4000});
    })
  }

  listarPerfisPessoa = async () => {
    await this.pessoaService.listarPerfilPessoa()
      .then(response => {
        this.setState({perfis: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Pessoas', detail:'Erro ao listar tipos de perfis de pessoa', life: 4000});
      })
  }

  carregaCombosConsulta = () => {
    const usuarioLogado = this.context.usuarioAutenticado
    this.listarGruposTrabalho2(usuarioLogado);
    this.listarTiposAcao2(usuarioLogado.empresa);
    this.listarStatusProcessual2(usuarioLogado.empresa);
    this.listarTiposDecisao(usuarioLogado.empresa);
    this.listarObjetosAcao(usuarioLogado.empresa);
    this.listarAreaAtuacao2(usuarioLogado.empresa);
    this.listarMotivosResultado();
    this.listarFasesProcessuais();
    this.listarRitosProcessuais();
    this.listarUsuarios();
    this.listarBancadas();
  }

  listarGruposTrabalho = (usuario) => {
    this.grupoTrabalhoService.listarGruposUsuario(usuario.codigo)
      .then(response => {
        this.setState({gruposTrabalho: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao carregar Grupos de Trabalhos do usuário', life: 4000});
      });
  }

  listarGruposTrabalho2 = (usuario) => {
    this.grupoTrabalhoService.listarGruposUsuario2(usuario.codigo)
      .then(response => {
        this.setState({gruposTrabalho: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao carregar Grupos de Trabalhos do usuário', life: 4000});
      });
  }

  listarTiposGarantias = async () => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.tipoGarantiaService.listarGarantias(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({tiposGarantias: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Tipos de Garantias', detail:'Erro ao carregar Tipos de Garantias', life: 4000});
      })
  }

  listarTiposAcao = (empresa) => {
    this.tipoAcaoService.listarTipoAcao(empresa.codigo)
      .then(response => {
        this.setState({tiposAcao: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao carregar Tipos de Ação', life: 4000});
      })
  }

  listarTiposAcao2 = (empresa) => {
    this.tipoAcaoService.listarTipoAcao2(empresa.codigo)
      .then(response => {
        this.setState({tiposAcao: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao carregar Tipos de Ação', life: 4000});
      })
  }

  listarStatusProcessual = (empresa) => {
    this.statusProcessualService.listarStatusProcessual(empresa.codigo)
      .then(response => {
        this.setState({statusProcessuais: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao carregar Status Processual', life: 4000});
      })
  }

  listarStatusProcessual2 = (empresa) => {
    this.statusProcessualService.listarStatusProcessual2(empresa.codigo)
      .then(response => {
        this.setState({statusProcessuais: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao carregar Status Processual', life: 4000});
      })
  }

  listarTiposDecisao = (empresa) => {
    this.tipoDecisaoService.listarTiposDecisao(empresa.codigo)
      .then(response => {
        this.setState({tiposDecisao: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao carregar Tipos de Decisão', life: 4000});
      })
  }

  listarObjetosAcao = async(empresa) => {
    const filtro = {
      empresa: empresa.codigo,
      processo: this.state.processo.codigo
    }
    await this.objetoAcaoService.listarObjetosForaProcesso(filtro)
      .then(response => {
        this.setState({objetosAcao: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao carregar Objetos de Ação', life: 4000});
      })
  }

  listarSubObjetosAcao = (objetoPai) => {
    const filtro = {
      processo: this.state.processo.codigo,
      objetoPai: objetoPai
    }
    this.objetoAcaoService.listarSubObjetosForaProcesso(filtro)
      .then(response => {
        this.setState({subObjetosAcao: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao carregar Sub-Objetos de Ação', life: 4000});
      })
  }

  async onChangeObjetos(e) {
    await this.setState({objetoAcao: e.value});
    this.listarSubObjetosAcao(this.state.objetoAcao.codigo);
  }

  listarAreaAtuacao = (empresa) => {
    this.areaAtuacaoService.listarAreaAtuacao(empresa.codigo)
      .then(response => {
        this.setState({areasAtuacao: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao carregar Áreas de Atuação', life: 4000});
      })
  }

  listarAreaAtuacao2 = (empresa) => {
    this.areaAtuacaoService.listarAreaAtuacao2(empresa.codigo)
      .then(response => {
        this.setState({areasAtuacao: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao carregar Áreas de Atuação', life: 4000});
      })
  }

  confirmaExclusaoObjetoAcao(objeto) {
    this.setState({codigoObjeto: objeto.codigo});
    console.log('Objeto para ser excluído',objeto.codigo)
    confirmDialog({
        message: 'Deseja realmente excluir o Objeto de Ação?',
        header: 'Exclusão de Objeto de Ação',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.aceptExcluirObjetoAcao,
        reject: this.reject
    });
  }

  aceptExcluirObjetoAcao() {
    this.excluirObjetoAcao();
  }

  excluirObjetoAcao = async () => {
    this.setState({openSpinner: true});
    await this.objetoAcaoProcessoService.excluirObjetoProcesso(this.state.codigoObjeto)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Objetos de Ação', detail:'Objeto de Ação excluído', life: 4000});
        const usuarioLogado = this.context.usuarioAutenticado
        this.listarObjetosAcao(usuarioLogado.empresa);
        this.consultarObjetosPorProcesso(this.state.processo.codigo);
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Objetos de Ação', detail:`${this.state.detail}`, life: 4000});
      })

      this.setState({openSpinner: false});
  }

  listarTiposPagamentos = async() => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.tipoPagamentoService.listarTiposPagamentos(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({tiposPagamentos: response.data});
      }).catch(error => {
        console.log('Erro ao listar os tipos de pagamentos', error.data);
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  onChangeTipoPagamento(e) {
    this.setState({tipoPagamento: e.value});
  }

  onChangeTipoCustas(e) {
    this.setState({tipoCusta: e.value});
  }

  onChangeStatusProcessual(e) {
    if(e.value != null) {
      if(e.value.descricao == 'Arquivado') {
        this.setState({isArquivar: true});
        this.setState({exibeDatasStatusProcessual: 'block'});
        this.setState({resultadoArquivamento: null});
      } else {
        this.setState({isArquivar: false});
        this.setState({exibeDatasStatusProcessual: 'none'});
      }
    } else {
      this.setState({isArquivar: false});
      this.setState({exibeDatasStatusProcessual: 'none'});
    }
    this.setState({statusProcessual: e.value})
  }

  onChangeGrupoTrabalho(e) {
    this.setState({grupoTrabalho: e.value})
  }

  onChangeAreaAtuacao(e) {
    this.setState({areaAtuacao: e.value})
  }

  onChangeTipoAcao(e) {
    this.setState({tipoAcao: e.value})
  }

  consultarPessoa(event) {
    setTimeout(() => {
        let filterPessoas;
        if (!event.query.trim().length) {
            filterPessoas = [...this.state.pessoas];
        }
        else {
            filterPessoas = this.state.pessoas.filter((pessoa) => {
                return pessoa.nome.toLowerCase().startsWith(event.query.toLowerCase());
            });
        }

        this.setState({ filterPessoas });
    }, 250);
  }

  load(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  async componentDidMount(){
    this.setState({openSpinner: true});
    const params = this.props.match.params;
    if(params.codigo) {
       await this.consultarProcesso(params.codigo);
       this.consultarProcessoImportancia();
       if(params.action == 'NEW') {
        this.toast.show({severity:'success', summary: 'Processos', detail:'Processo cadastrado com sucesso !', life: 4000});
       }
    }
    this.carregaCombosConsulta();
    this.listarPessoasEmpresaPartes();
    
    this.setState({openSpinner: false})
  }

  listarPessoasEmpresaPartes = async() => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.pessoaService.listarPessoas(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({pessoas: response.data});
      }).catch(error => {
        console.log('Erro ao carregar pessoas');
      })
  }

  consultarObjetosPorProcesso = async (codigo) => {
    await this.objetoAcaoProcessoService.consultarObjetos(codigo)
      .then(response => {
        this.setState({objetosProcesso: response.data});
        let objetos = '';
        let contador = 0;
        const tamanhoLista = response.data.length;
        for(let i = 0; i < response.data.length; i++) {
          if(contador === tamanhoLista - 1) {
            objetos = objetos + response.data[i].objeto.nome;
          } else {
            objetos = objetos + response.data[i].objeto.nome + ',';
          }
          contador++;
        }
        this.setState({objetos: objetos});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos', detail:`${this.state.detail}`, life: 4000});
      });
  }

  consultarHistoricoProcesso = async () => {
    await this.historicoProcessoService.listarHistorico(this.state.processo.codigo)
      .then(response => {
        this.setState({listaHistorico: response.data})
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  acoesHistoricoProcesso(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                tooltip="Excluir Histórico"
                onClick={() => this.confirmaExclusaoHistorico(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
      </React.Fragment>
    );
  }

  usuarioHistorico(rowData) {
    if(rowData.usuario.nome !== 'ILAW') {
      return(
        <React.Fragment>
          <i className="pi pi-user-plus" title="Incluído manualmente"></i>
        </React.Fragment>
      )
    }
  }

  confirmaExclusaoHistorico(historico) {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(usuarioLogado.perfil.codigo != 1) {
      this.toast.show({severity:'error', summary: 'Andamento Processual', detail:'Vocẽ não tem permissão para excluir andamentos processuais', life: 4000});
      return;
    }
    this.setState({codigoHistorico: historico.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir o Andamento Processual?',
        header: 'Exclusão de Andamento Processual',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirHistorico,
        reject: this.reject
    });
  }

  acceptExcluirHistorico() {
    this.excluirHistpricoProcesso();
  }

  excluirHistpricoProcesso = async () => {
    this.setState({classeDiv: 'show'});
    this.historicoProcessoService.excluirHistorico(this.state.codigoHistorico)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Andamento Processual', detail:'Andamento Processual excluído', life: 4000});
        this.listarHistoricoProcesso();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos', detail:`${this.state.detail}`, life: 4000});
      });

      this.setState({classeDiv: 'hide'});
  }

  listarHistoricoProcesso = () => {
    this.historicoProcessoService.listarHistorico(this.state.processo.codigo)
      .then(response => {
        this.setState({listaHistorico: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Andamento Processual', detail:`${this.state.detail}`, life: 4000});
      })
  }

  renderFooterCadastroHistorico(name) {
    return (
        <div>
          <Button label="Cadastrar" 
                  className="p-button-primary p-button-text"
                  onClick={this.incluirHistorico}/>
          &nbsp;
          <Button label="Fechar" 
                          className="p-button-secondary p-button-text"
                          onClick={() => this.fecharModalCadastro(name)}/> 
        </div>
    );
  }

  abrirModalCadastroHistorico(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.listarTiposAndamento();
    this.limparCamposHistorico();
    this.setState(state);
  }

  limparCamposHistorico = () => {
    this.setState({
      historico: '',
      dataOcorrencia: ''
    })
  }

  incluirHistorico = async () => {  
    const usuarioLogado = this.context.usuarioAutenticado;
    
    if(this.state.dataOcorrencia == '') {
      this.toast.show({severity:'error', summary: 'Histórico do Processo', detail:'Informe a Data de Ocorrência', life: 4000});
      return false;
    }

    if(this.state.historico == '') {
      this.toast.show({severity:'error', summary: 'Histórico do Processo', detail:'Informe o Histórico', life: 4000});
      return false;
    }

    if(this.state.tipoAndamento == null) {
      this.toast.show({severity:'error', summary: 'Histórico do Processo', detail:'Informe o Tipo de Andamento', life: 4000});
      return false;
    }

    if(this.state.dataOcorrencia != '') {
      var date = this.state.dataOcorrencia;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      var dataFormatadaDataOcorrencia =  year+"-"+month+"-"+day;
    }

    this.setState({openSpinner: true});
    await this.historicoProcessoService.incluirHistorico({
      processo: this.state.processo,
      historico: this.state.historico,
      tipoAndamento: this.state.tipoAndamento,
      dataOcorrencia: dataFormatadaDataOcorrencia,
      usuario: usuarioLogado
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Histórico do Processo', detail:'Histórico incluído com sucesso', life: 4000});
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Histórico do Processo', detail:`${this.state.detail}`, life: 4000});
    });

    await this.listarHistoricoProcesso();
    this.fecharModalCadastro('modalHistorico')
    this.setState({openSpinner: false});
  }

  consultarArquivosProcesso = async codigo => {
    await this.arquivoProcessoService.listarArquivos(codigo)
      .then(response => {
        this.setState({arquivos: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Histórico do Processo', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarProcesso = async (codigo) => {
    await this.processoService.consultarProcessoPorCodigo(codigo)
      .then(response => {
        this.setState({processo: response.data});
        this.setState({codigo: response.data.codigo})
        this.setState({grupoTrabalho: response.data.grupoTrabalho});
        this.setState({pasta: response.data.pasta});
        this.setState({nrProcesso: response.data.nrProcesso});
        this.setState({nrCnj: response.data.nrCnj});
        this.setState({instancia: response.data.instancia});
        this.setState({dsComarca: response.data.dsComarca});
        this.setState({tipoAcao: response.data.tipoAcao});
        this.setState({statusProcessual: response.data.statusProcessual});
        this.setState({areaAtuacao: response.data.areaAtuacao});
        this.setState({tipoDecisao: response.data.tipoDecisao});
        this.setState({vlProvavel: response.data.vlProvavel});
        this.setState({vlPossivel: response.data.vlPossivel});
        this.setState({vlRemoto: response.data.vlRemoto});
        this.setState({vlCausa: response.data.vlCausa});
        this.setState({dsPedidos: response.data.dsPedidos});
        this.setState({observacao: response.data.observacao});
        this.setState({orgaoColegiado: response.data.orgaoColegiado});
        this.setState({relatorProcesso: response.data.relator});
        this.setState({bancada: response.data.bancada});
        this.setState({decisoes: response.data.decisoes});
        this.setState({liminares: response.data.liminares});
        if(response.data.dataDistribuicao != null) {
          var dataDist = new Date(response.data.dataDistribuicao);
          dataDist.setDate(dataDist.getDate()+1)
          this.setState({dataDistribuicao: new Date(Date.parse(dataDist))})
        }

        if(response.data.dataSentenca != null) {
          var dataSet = new Date(response.data.dataSentenca);
          dataSet.setDate(dataSet.getDate()+1);
          this.setState({dataSentenca: dataSet});
        }

        if(response.data.dataUltimaDecisao != null) {
          var dataUltDec = new Date(response.data.dataUltimaDecisao);
          dataUltDec.setDate(dataUltDec.getDate()+1);
          this.setState({dataUltimaDecisao: dataUltDec})
        }
        
        if(response.data.dataCadastro != null) {
          var dataCad = new Date(response.data.dataCadastro);
          dataCad.setDate(dataCad.getDate()+1);
          this.setState({dataCadastro: dataCad})
        }
        
        if(response.data.dataUltimaMovimentacao != null) {
          var dataUltMov = new Date(response.data.dataUltimaMovimentacao);
          dataUltMov.setDate(dataUltMov.getDate()+1);
          this.setState({dataUltimaMovimentacao: dataUltMov})
        }
        
        this.setState({responsavel: response.data.responsavel});
        let p = [];
        if(response.data.snPush == 'S') {
          p.push('push')
        }
        if(response.data.snEmail == 'S') {
          p.push('email')
        }
        if(response.data.snHistorico == 'S') {
          p.push('historico');
        }
        if(response.data.snImportante == 'S') {
          this.setState({iconeImportanteParaEmpresa: 'p-button-rounded p-button-warning'});
          this.setState({iconeImportanteParaEmpresaTitle: 'Processo importante para empresa'});
        } else {
          this.setState({iconeImportanteParaEmpresa: 'p-button-rounded p-button-secondary'});
          this.setState({iconeImportanteParaEmpresaTitle: 'Clique para classificar o processo como importante'})
        }

        if(response.data.estrategico == 'S') {
          this.setState({iconeEstrategico: 'p-button-rounded p-button-info'});
          this.setState({iconeEstrátegicoTitle: 'Processo Estrategico'});
        } else {
          this.setState({iconeEstrategico: 'p-button-rounded p-button-secondary'});
          this.setState({iconeEstrátegicoTitle: 'Clique para tornar o processo estratégico'});
        }

        this.setState({push: p});
        if(response.data.uf != null) {
          this.setaEstado(response.data.uf);
        }
      
        this.setState({partesRecurso: response.data.partesRecurso});
        this.setState({partesProcesso: response.data.partes});
        var partes = '';
        for(let i = 0; i < response.data.partes.length; i++) {
          partes = partes + response.data.partes[i].pessoa.nome + ", ";
        }
        this.setState({montaPartes: partes});
        this.setState({objetosProcesso: response.data.objetos});
        this.setState({pedidosProcesso: response.data.pedidos});
        this.retornaPagamentosProcesso(response.data);
        this.retornaCustasProcessuais(response.data);
        this.retornaGarantiasprocesso(response.data);
        this.retornaLiminares(response.data);
        this.retornaProvisoesJudiciais(response.data);
        this.setState({listaHistorico: response.data.historico});
        this.setState({atividades: response.data.atividades});
        this.setState({arquivos: response.data.arquivos});
        this.setState({lancamentosFinanceiros: response.data.lancamentos});
        this.setState({agravosApensos: response.data.agravosApensos})
        if(response.data.tipoContingenciaContabil != null && response.data.tipoContingenciaContabil != '') {
          if(response.data.tipoContingenciaContabil == 'PO') {
            this.setState({contingenciaContabil: {
              codigo: 'PO',
              nome: 'Possível'
            }});
          } else if(response.data.tipoContingenciaContabil == 'PR') {
            this.setState({contingenciaContabil: {
              codigo: 'PR',
              nome: 'Provável'
            }});
          } else {
            this.setState({contingenciaContabil: {
              codigo: 'RE',
              nome: 'Remoto'
            }});
          }
        }

        if(response.data.risco != null) {
          if(response.data.risco == 'P') {
            this.setState({risco: {
              codigo: 'P',
              nome: 'Possível'
            }});
          } else if(response.data.risco == 'V') {
            this.setState({risco: {
              codigo: 'V',
              nome: 'Provável'
            }});
          } else {
            this.setState({risco: {
              codigo: 'R',
              nome: 'Remoto'
            }});
          }
        }
  
        if(response.data.motivoDto != null) {
          this.setState({motivo: response.data.motivoDto});
        }

        if(response.data.processoPrincipal != null) {
          if(response.data.processoPrincipal.nrCnj != null) {
            this.setState({linkProcessoPrincipal: response.data.processoPrincipal.nrCnj});
          } else {
            this.setState({linkProcessoPrincipal: response.data.processoPrincipal.nrProcesso});
          }
          this.setState({exibeLInkProcessoPrincipal: 'block'});
        } else {
          this.setState({exibeLInkProcessoPrincipal: 'none'});
        }

        this.setState({fase: response.data.fase});
        this.setState({rito: response.data.rito});
        this.consultarAgravoApenso(response.data.codigo);

        if(response.data.graficoAtividadesFase != null) {
          this.graficoAtividadeFase(response.data.graficoAtividadesFase);
        }
     
        if(response.data.graficoAtividadesStatus != null) {
          this.ativdadesStatus(response.data.graficoAtividadesStatus);
        }
    
        if(response.data.processoArquivado != null) {
          this.setState({exibeDatasStatusProcessual: 'block'});
          this.setState({usuarioArquivou: response.data.processoArquivado.usuario.nome});
          var dataArquivado = new Date(response.data.processoArquivado.dataArquivado);
          dataArquivado.setDate(dataArquivado.getDate()+1);
          this.setState({dataArquivamento: dataArquivado})
          
          if(response.data.processoArquivado.dataArquivadoTribunal != null) {
            var dataArquivadoTribunal = new Date(response.data.processoArquivado.dataArquivadoTribunal);
            dataArquivadoTribunal.setDate(dataArquivadoTribunal.getDate()+1);
            this.setState({dataArquivamentoTj: dataArquivadoTribunal})
          }

          if(response.data.processoArquivado.resultadoArquivamento == 'P') {
            this.setState({resultadoArquivamento: {
              codigo: 'P',
              nome: 'Procedente'
            }});
          } else if(response.data.processoArquivado.resultadoArquivamento == 'E') {
            this.setState({resultadoArquivamento: {
              codigo: 'E',
              nome: 'Extinto'
            }});
          } else {
            this.setState({resultadoArquivamento: {
              codigo: 'A',
              nome: 'Acordo'
            }});
          }
        }

      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarAgravoApenso = async (processo) => {
    await this.agravoApensoService.consultaAgravoApenso(processo)
      .then(response => {
        this.setState({agravoApensoConsulta: response.data});
        if(response.data.codigo != null) {
          this.setState({camaraConsulta: response.data.camara});
          this.setState({relatorConsulta: response.data.relator});
          this.setState({exibirAgravoApenso: 'block'});
          this.setState({exibirAgravoApensoNegacao: 'none'});
        }
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos', detail:`${this.state.detail}`, life: 4000});
      })

      console.log('CSS', this.state.exibirAgravoApenso)
  }

  setaEstado = (uf) => {
    for(let i = 0; i < this.estados.length; i++) {
      if(uf == this.estados[i].codigo) {
        this.setState({uf: this.estados[i]});
        break;
      }
    }
  }

  consultarLancamentosFinanceiros = (processo) => {
    this.processoService.consultarLancamentosFinanceiros(processo)
      .then(response => {
        this.setState({lancamentosFinanceiros: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos - Lançamentos Financeiros', detail:`${this.state.detail}`, life: 4000});
      })
  }

  acoesFinanceiro(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-search-plus" className="p-button-rounded p-button-text"
                tooltip="Consultar Lançamento"
                onClick={() => this.consultarLancamento(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
      </React.Fragment>
    )
  }

  formatCurrency(value) {
    return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  async consultarLancamento(lancamento) {
    this.setState({openSpinner: true});
    await this.financeiroService.consultarLancamento(lancamento.codigo)
      .then(response => {
        this.setState({lancamento: response.data});
        this.setState({tipo: response.data.tipo});
        if(response.data.tipo.tipo == 'D') {
          this.setState({categoriaNome: 'Despesa'})
        } else {
          this.setState({categoriaNome: 'Receita'})
        }
        this.setState({tipoNome: response.data.tipo.nome});
        this.setState({vlLancamento: response.data.vlLancamento});
        this.setState({vlLancamentoMascara: this.formatCurrency(response.data.vlLancamento)});
        this.setState({dtVencimento: response.data.dtVencimento});
        this.setState({vlPago: response.data.vlPago});
        this.setState({vlPagoMascara: this.formatCurrency(response.data.vlPago)});
        this.setState({dtPago: response.data.dtPago});
        this.setState({dsLancamento: response.data.dsLancamento});
        this.setState({observacao: response.data.observacao});
        if(response.data.processo != null) {
          this.setState({dsProcesso: response.data.processo.nrCnj});
        } else {
          this.setState({dsProcesso: ''});
        }
        if(response.data.situacao == 'P') {
          this.setState({situacao: 'Pago'});
        } else {
          this.setState({situacao: 'Ativo'});
        }
        this.abrirModaConsultaLancamanto('displayConsultaLancamento');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Consulta de Lancamento', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  renderFooterConsultaLancamento(name) {
    return (
        <div className="right">
            <Button label="Reabrir" 
                    className="p-button-info p-button-text" 
                    onClick={this.reabrirLancamento}/>
            &nbsp;
            <Button label="Pagar" 
                    className="p-button-success p-button-text" 
                    onClick={this.consultarLancamentoPagamento}/>
            &nbsp;
            <Button label="Fechar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  abrirModaConsultaLancamanto(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  reabrirLancamento = () => {
    if(this.state.lancamento.situacao == 'A') {
      this.toast.show({severity:'error', summary: 'Pagamento', detail:'O lançamento está ativo', life: 4000});
      return false;
    }
    this.financeiroService.reabrirLancamento({
      codigo: this.state.lancamento.codigo,
      situacao: 'A'
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Pagamento', detail:'Lançamento Reaberto', life: 4000});
      this.fecharModal('displayConsultaLancamento');
      this.consultarLancamentosFinanceiros(this.state.processo.codigo);
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Pagamento', detail:`${this.state.detail}`, life: 4000});
    })
  }

  consultarLancamentoPagamento = () => {
    this.setState({vlLancamentoNovo: ''});
    this.setState({dtVencimentoNovo: ''});
    if(this.state.lancamento.tipo.tipo == 'D') {
      this.abrirModaConsultaLancamanto('modalDespesaPagamento')
    } else {
      this.abrirModal('modalReceitaPagamento')
    }
  }

  fecharModal(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  pagarDespesaReceita = async () => {
    const usuarioLogado = this.context.usuarioAutenticado

    if(this.state.lancamento.situacao == 'P') {
      this.toast.show({severity:'error', summary: 'Pagamento', detail:'Lançamento já pago', life: 4000});
      return false;
    }

    //Se o campo de novo valor estiver preenchido, paga o novo valor e cria um novo lancamento com a diferença
    if(this.state.vlLancamentoNovo != '') {
      //Efetua pagamento
      if(this.state.dtVencimentoNovo == '') {
        this.toast.show({severity:'error', summary: 'Pagamento', detail:'Informe a data de Vencimento', life: 4000});
        return false;
      }

      await this.financeiroService.pagarOuCancelarLancamentoIndividual({
        codigo: this.state.lancamento.codigo,
        situacao: 'P',
        vlPago: this.state.vlLancamentoNovo,
        observacao: this.state.observacao
      }).then(response => {
        this.toast.show({severity:'success', summary: 'Pagamento', detail:'Pagamento Efetuado', life: 4000});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Pagamento', detail:`${this.state.detail}`, life: 4000});
      });

      //Data de vencimento
      var novoValor = this.state.vlLancamento - this.state.vlLancamentoNovo;
      var dataFormatadaDataVencimento = '';
      if(this.state.dtVencimentoNovo != '') {
        var date = this.state.dtVencimentoNovo;
        var month = this.pad2(date.getMonth()+1);//months (0-11)
        var day = this.pad2(date.getDate());//day (1-31)
        var year= date.getFullYear();
        dataFormatadaDataVencimento =  year+"-"+month+"-"+day;
      };

      this.financeiroService.cadastrarLancamento({
        tipo: this.state.tipo,
        vlLancamento: novoValor,
        dtVencimento: dataFormatadaDataVencimento,
        observacao: 'Diferença do pagamento anterior',
        situacao: 'A',
        usuario: usuarioLogado.codigo,
        vlPago: '0',
        processo: this.state.lancamento.processo
      }).then(response => {
        this.toast.show({severity:'success', summary: 'Cadastro de Lançamento', detail:'Novo lançamento cadastrado', life: 4000});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Cadastro de Lançamento', detail:`${this.state.detail}`, life: 4000});
      });

      this.fecharModal('modalDespesaPagamento');
      this.fecharModal('displayConsultaLancamento');
      this.consultarLancamentosFinanceiros(this.state.processo.codigo);

    } else {
      await this.financeiroService.pagarOuCancelarLancamentoIndividual({
        codigo: this.state.lancamento.codigo,
        situacao: 'P',
        vlPago: this.state.vlLancamento,
        observacao: this.state.observacao
      }).then(response => {
        this.toast.show({severity:'success', summary: 'Pagamento de Despesa', detail:'Pagamento Efetuado', life: 4000});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Pagamento de Despesa', detail:`${this.state.detail}`, life: 4000});
      });

      this.fecharModal('modalDespesaPagamento');
      this.fecharModal('displayConsultaLancamento');
      this.consultarLancamentosFinanceiros(this.state.processo.codigo);
    }
  }

  consultarPagamentosProcesso = async (codigo) => {
    await this.pagamentoProcessoService.listarPagamentos(codigo)
      .then(response => {
        this.setState({pagamentos: response.data});
        //Resumo
        let vlCredito = 0;
        let vlDebito = 0;
        let saldo = 0;
        for(let i = 0; i < this.state.pagamentos.length; i++) {
          if(this.state.pagamentos[i].tipo === 'Crédito') {
            vlCredito = vlCredito + this.state.pagamentos[i].vlPagamento;
          } else {
            vlDebito = vlDebito + this.state.pagamentos[i].vlPagamento;
          }
        }
        saldo = vlCredito - vlDebito;
        this.setState({vlCredito: vlCredito});
        this.setState({vlDebito: vlDebito});
        this.setState({saldo: saldo});
        this.setState({corSaldo: saldo < 0 ? 'vermelho' : 'verde'});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  retornaPagamentosProcesso = (processo) => {
    if(processo.pagamentos.length > 0) {
      this.setState({pagamentos: processo.pagamentos});
      let vlCredito = 0;
      let vlDebito = 0;
      let saldo = 0;
      for(let i = 0; i < processo.pagamentos.length; i++) {
        if(processo.pagamentos[i].tipo === 'Crédito') {
          vlCredito = vlCredito + processo.pagamentos[i].vlPagamento;
        } else {
          vlDebito = vlDebito + processo.pagamentos[i].vlPagamento;
        }
      }
    
      saldo = vlCredito - vlDebito;
      this.setState({vlCredito: vlCredito});
      this.setState({vlDebito: vlDebito});
      this.setState({saldo: saldo});
      this.setState({corSaldo: saldo < 0 ? 'vermelho' : 'verde'});
    }
  }

  adicionarAutor = () => {
    if(this.state.classeDivAutor === 'hide') {
      this.setState({classeDivAutor: 'show'});
      this.setState({iconAutor: 'pi pi-angle-double-left'});
      this.setState({classeAutor: 'p-button-rounded  p-button-secondary p-button-text'});
      this.setState({toolTipAutor: 'Cancelar adicionar autor(es)'});
      this.setState({selectedAutor: null});
    } else {
      this.setState({classeDivAutor: 'hide'});
      this.setState({iconAutor: 'pi pi-plus-circle'});
      this.setState({classeAutor: 'p-button-rounded p-button-text'});
      this.setState({toolTipAutor: 'Clique para adicionar autor(es)'})
    }
  }

  adicionarReu = () => {
    if(this.state.classeDivReu === 'hide') {
      this.setState({classeDivReu: 'show'});
      this.setState({iconReu: 'pi pi-angle-double-left'});
      this.setState({classeReu: 'p-button-rounded  p-button-secondary p-button-text'});
      this.setState({toolTipReu: 'Cancelar adicionar réu(s)'});
      this.setState({selectedReu: null});
    } else {
      this.setState({classeDivReu: 'hide'});
      this.setState({iconReu: 'pi pi-plus-circle'});
      this.setState({classeReu: 'p-button-rounded p-button-text'});
      this.setState({toolTipReu: 'Clique para adicionar réu(s)'})
    }
  }

  adicionarAdvogado = () => {
    if(this.state.classeDivAdvogado === 'hide') {
      this.setState({classeDivAdvogado: 'show'});
      this.setState({iconAdvogado: 'pi pi-angle-double-left'});
      this.setState({classeAdvogado: 'p-button-rounded  p-button-secondary p-button-text'});
      this.setState({toolTipAdvogado: 'Cancelar adicionar advogado(s)'});
      this.setState({selectedAdvogado: null});
    } else {
      this.setState({classeDivAdvogado: 'hide'});
      this.setState({iconAdvogado: 'pi pi-plus-circle'});
      this.setState({classeAdvogado: 'p-button-rounded p-button-text'});
      this.setState({toolTipAdvogado: 'Clique para adicionar advogado(s)'})
    }
  }

  acoesObjetosAcao(rowData) {
    return (
      <React.Fragment>
       <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
               tooltip="Retirar Objeto"
               tooltipOptions={{position: 'top'}}
               onClick={() => this.confirmaExclusaoObjetoAcao(rowData)}
               style={{width: '20px', height: '10px'}}/>
      </React.Fragment>
    );
  }

  onTipoDecisaoChange(e) {
    this.setState({tipoDecisao: e.value});
  }

  pad2 = (n) => {
    return (n < 10 ? '0' : '') + n;
  }

  formatCurrency(value) {
    return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  vlPagamento(rowData) {
    return this.formatCurrency(rowData.vlPagamento);
  }

  vlCustas(rowData) {
    return this.formatCurrency(rowData.vlCustas);
  }

  vlPenhora(rowData) {
    return this.formatCurrency(rowData.vlPenhora);
  }

  acoesPagamentosProcesso(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                tooltip="Excluir Pagamento"
                onClick={() => this.confirmaExclusaoPagamento(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
      </React.Fragment>
    );
  }

  headerResumoPagamentos() {
    return(
      <React.Fragment>
        <label>Pagamentos: &nbsp;&nbsp; 
        <span className="verde">Credito: {this.formatCurrency(this.state.vlCredito)}</span>&nbsp;&nbsp;&nbsp; 
        <span className="vermelho">Débito: {this.formatCurrency(this.state.vlDebito)}</span> &nbsp;&nbsp;&nbsp;
        <span className={this.state.corSaldo}>Saldo: {this.formatCurrency(this.state.saldo)}</span></label>
      </React.Fragment>
    );
  }

  headerResumoCustas() {
    return(
      <React.Fragment>
        <label>Custas: &nbsp;&nbsp; 
        <span className="verde">Credito: {this.formatCurrency(this.state.vlCreditoCustas)}</span>&nbsp;&nbsp;&nbsp; 
        <span className="vermelho">Débito: {this.formatCurrency(this.state.vlDebitoCustas)}</span> &nbsp;&nbsp;&nbsp;
        <span className={this.state.corSaldoCustas}>Saldo: {this.formatCurrency(this.state.saldoCustas)}</span></label>
      </React.Fragment>
    )
  }

  acoesCustasProcesso(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                tooltip="Excluir Custas"
                onClick={() => this.confirmaExclusaoCusta(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
      </React.Fragment>
    );
  }

  renderFooterCadastroPagamentos(name) {
    return (
        <div>
          <Button label="Cadastrar" 
                  className="p-button-primary p-button-text"
                  onClick={this.incluirPagamento}/>
          &nbsp;
          <Button label="Cancelar" 
                  className="p-button-secondary p-button-text"
                  onClick={() => this.fecharModalCadastro(name)}/>
        </div>
    );
  }

  fecharModalCadastro(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  abrirModalCadastroPagamentos(name, position) {
    this.listarTiposPagamentos();
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.limparCamposPagamentos();
    this.setState(state);
  }

  limparCamposPagamentos = () => {
    this.setState({
      tipoPagamento: null,
      dtPagamento: '',
      tipo: '',
      vlPagamento: ''});
  }

  renderFooterCadastroCustas(name) {
    return (
        <div>
          <Button label="Cadastrar" 
                  className="p-button-primary p-button-text"
                  onClick={this.incluirCustas}/>
          &nbsp;
          <Button label="Cancelar" 
                  className="p-button-secondary p-button-text"
                  onClick={() => this.fecharModalCadastro(name)}/>
        </div>
    );
  }

  renderFooterCadastroLiminar(name) {
    return (
        <div>
          <Button label="Cadastrar" 
                  className="p-button-primary p-button-text"
                  onClick={this.cadastrarLiminar}/>
          &nbsp;
          <Button label="Cancelar" 
                  className="p-button-secondary p-button-text"
                  onClick={() => this.fecharModalCadastro(name)}/>
        </div>
    );
  }

  renderFooterAlterarLiminar(name) {
    return (
        <div>
          <Button label="Alterar" 
                  className="p-button-primary p-button-text"
                  onClick={this.alterarLiminar}/>
          &nbsp;
          <Button label="Cancelar" 
                  className="p-button-secondary p-button-text"
                  onClick={() => this.fecharModalCadastro(name)}/>
        </div>
    );
  }

  renderFooterCadastroDecisao(name) {
    return (
        <div>
          <Button label="Cadastrar" 
                  className="p-button-primary p-button-text"
                  onClick={this.cadastrarDecisao}/>
          &nbsp;
          <Button label="Cancelar" 
                  className="p-button-secondary p-button-text"
                  onClick={() => this.fecharModalCadastro(name)}/>
        </div>
    );
  }

  renderFooterAlterarDecisao(name) {
    return (
        <div>
          <Button label="Alterar" 
                  className="p-button-primary p-button-text"
                  onClick={this.alterarDecisao}/>
          &nbsp;
          <Button label="Cancelar" 
                  className="p-button-secondary p-button-text"
                  onClick={() => this.fecharModalCadastro(name)}/>
        </div>
    );
  }

  alterarLiminar = async () => {
    if(this.state.liminarDecisao == null) {
      this.toast.show({severity:'error', summary: 'Liminar', detail:'Informe a decisão', life: 4000});
      return;
    }

    if(this.state.liminarDtFatal == '') {
      this.toast.show({severity:'error', summary: 'Liminar', detail:'Informe a data da liminar', life: 4000});
      return;
    }

    if(this.state.liminarDtFatal != '') {
      var date = this.state.liminarDtFatal;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      var dataFormatadaLiminarFatal =  year+"-"+month+"-"+day;
    }

    const liminar = {
      codigo: this.state.liminar.codigo,
      processo: this.state.processo,
      decisao: this.state.liminarDecisao.codigo,
      dtFatal: dataFormatadaLiminarFatal,
      multaDiaria: this.state.liminarMultaDiaria,
      //setorInterno: 'CA',
      descSetorInterno: null,
      observacao: this.state.observacaoLiminar
    };

    this.setState({openSpinner: true});
    await this.liminarService.alterar(liminar)
      .then(response => {
        this.retornaLiminares(this.state.processo);
        this.toast.show({severity:'success', summary: 'Liminar', detail:'Liminar alterada com sucesso', life: 4000});
        this.fecharModal('modalAlterarLiminar');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Pedidos do Processo', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  fecharModalCadastro(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  abrirModalCadastroCustas(name, position) {
    this.listarTiposCustas();
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.limparCamposCustas();
    this.setState(state);
  }

  limparCamposCustas = () => {
    this.setState({
      tipoCusta: null,
      dtPagamento: '',
      tipo: '',
      vlCustas: '',
    })
  }

  limparCamposPagamentos = () => {
    this.setState({
      tipoPagamento: null,
      dtPagamento: '',
      tipo: '',
      vlPagamento: ''});
  }

  listarTiposCustas = async() => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.tipoCustaService.listarTiposCusta(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({tiposCustas: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Tipos de Custa', detail:`${this.state.detail}`, life: 4000});
      })
  }

  incluirCustas = async() => {
    if(this.state.tipoCusta == null) {
      this.toast.show({severity:'error', summary: 'Custas', detail:'Informe o Tipo de Custa', life: 4000});
      this.setState({classeDiv: 'hide'});
      return false;
    }

    if(this.state.tipo == null) {
      this.toast.show({severity:'error', summary: 'Custas', detail:'Informe o tipo Débito ou Crédito', life: 4000});
      this.setState({classeDiv: 'hide'});
      return false;
    }

    if(this.state.vlCustas == '') {
      this.toast.show({severity:'error', summary: 'Custas', detail:'Informe o Valor da Custa', life: 4000});
      this.setState({classeDiv: 'hide'});
      return false;
    }

    if(this.state.dtPagamento == '') {
      this.toast.show({severity:'error', summary: 'Custas', detail:'Informe a Data do pagamanto da custa', life: 4000});
      this.setState({classeDiv: 'hide'});
      return false;
    }

    var date = this.state.dtPagamento
    var month = this.pad2(date.getMonth()+1);//months (0-11)
    var day = this.pad2(date.getDate());//day (1-31)
    var year= date.getFullYear();
    var dataFormatada =  year+"-"+month+"-"+day;

    this.setState({openSpinner: true});
    await this.custasProcessoService.incluirCustas({
      processo: this.state.processo,
      custas: this.state.tipoCusta,
      tipo: this.state.tipo.codigo,
      vlCustas: this.state.vlCustas,
      dtPagamento: dataFormatada
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Custas', detail:'Custas incluída com sucesso', life: 4000});
      this.consultarCustasProcesso(this.state.processo.codigo);
      this.fecharModalCadastro('modalCustas');
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Custas', detail:`${this.state.detail}`, life: 4000});
    })

    this.setState({openSpinner: false});

  }

  incluirPagamento = async() => {
    if(this.state.tipoPagamento == null) {
      this.toast.show({severity:'error', summary: 'Pagamentos', detail:'Informe o Tipo de Pagamento', life: 4000});
      return false;
    }

    if(this.state.tipo == null) {
      this.toast.show({severity:'error', summary: 'Pagamentos', detail:'Informe o tipo Débito ou Crédito', life: 4000});
      return false;
    }

    if(this.state.vlPagamento == '') {
      this.toast.show({severity:'error', summary: 'Pagamentos', detail:'Informe o Valor do Pagamento', life: 4000});
      return false;
    }

    if(this.state.dtPagamento == '') {
      this.toast.show({severity:'error', summary: 'Pagamentos', detail:'Informe a Data de Pagamento', life: 4000});
      return false;
    }

    var date = this.state.dtPagamento
    var month = this.pad2(date.getMonth()+1);//months (0-11)
    var day = this.pad2(date.getDate());//day (1-31)
    var year= date.getFullYear();
    var dataFormatada =  year+"-"+month+"-"+day;

    this.setState({openSpinner: true});

    await this.pagamentoProcessoService.incluirPagamento({
      processo: this.state.processo,
      pagamento: this.state.tipoPagamento,
      vlPagamento: this.state.vlPagamento,
      dtPagamento: dataFormatada,
      tipo: this.state.tipo.codigo
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Pagamentos', detail:'Pagamento incluído', life: 4000});
      this.consultarPagamentosProcesso(this.state.processo.codigo);
      this.fecharModalCadastro('modalPagamentos');
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Pagamentos', detail:`${this.state.detail}`, life: 4000});
    })

    this.setState({openSpinner: false});
  }

  acceptExcluirPagamento() {
    this.excluirPagamentoProcesso();
  }

  acceptExcluirCustas() {
    this.excluirCusta();
  }

  confirmaExclusaoPagamento(pagamento) {
    this.setState({codigoPagamento: pagamento.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir Pagamento do Processo?',
        header: 'Exclusão de Pagamento',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirPagamento,
        reject: this.reject
    });
  }

  confirmaExclusaoCusta(custa) {
    this.setState({codigoCusta: custa.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir a Custa?',
        header: 'Exclusão de Custas',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirCustas,
        reject: this.reject
    });
  }

  excluirPagamentoProcesso = async () => {
    this.setState({openSpinner: true});
    await this.pagamentoProcessoService.excluirPagamento(this.state.codigoPagamento)
    .then(response => {
        this.consultarPagamentosProcesso(this.state.processo.codigo);
        this.toast.show({severity:'success', summary: 'Pagamentos', detail:'Pagamento excluído', life: 4000});
    }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Pagamentos', detail:`${this.state.detail}`, life: 4000});
    })

    this.setState({visiblePagamento: false});
    this.setState({openSpinner: false});
  }

  excluirCusta = async() => {
    this.setState({classeDiv: 'show'});
    await this.custasProcessoService.excluirCustas(this.state.codigoCusta)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Custas', detail:'Custa Excluída', life: 4000});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Custas', detail:`${this.state.detail}`, life: 4000});
      })

      this.setState({visibleCustas: false});
      this.consultarCustasProcesso(this.state.processo.codigo);
      this.setState({classeDiv: 'hide'});
  }

  consultarCustasProcesso = async (codigo) => {
    await this.custasProcessoService.listarCustas(codigo)
      .then(response => {
        this.setState({custasProcessos: response.data});
        let vlCredito = 0;
        let vlDebito = 0;
        let saldo = 0;
        for(let i = 0; i < this.state.custasProcessos.length; i++) {
          if(this.state.custasProcessos[i].tipo === 'Crédito') {
            vlCredito = vlCredito + this.state.custasProcessos[i].vlCustas;
          } else {
            vlDebito = vlDebito + this.state.custasProcessos[i].vlCustas;
          }
        }
        saldo = vlCredito - vlDebito;
        this.setState({vlCreditoCustas: vlCredito});
        this.setState({vlDebitoCustas: vlDebito});
        this.setState({saldoCustas: saldo});
        this.setState({corSaldoCustas: saldo < 0 ? 'vermelho' : 'verde'});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Custas', detail:`${this.state.detail}`, life: 4000});
      })
  }

  retornaCustasProcessuais = (processo) => {
    if(processo.custas.length > 0) {
      this.setState({custasProcessos: processo.custas});
      let vlCredito = 0;
      let vlDebito = 0;
      let saldo = 0;
      for(let i = 0; i < processo.custas.length; i++) {
        if(processo.custas[i].tipo === 'Crédito') {
          vlCredito = vlCredito + this.state.custasProcessos[i].vlCustas;
        } else {
          vlDebito = vlDebito + processo.custas[i].vlCustas;
        }
      }
    }
  }

  consultarGarantiasProcesso = async (codigo) => {
    await this.garantiaProcessoService.listarGarantiasProcesso(codigo)
      .then(response => {
        this.setState({garantiasProcesso: response.data});
        let total = 0;
        for(let i = 0; i < this.state.garantiasProcesso.length; i++) {
          total = total + this.state.garantiasProcesso[i].vlPenhora;
        }
        this.setState({totalPenhora: total});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Garantias de Processo', detail:`${this.state.detail}`, life: 4000});
      })
  }

  retornaGarantiasprocesso = (processo) => {
    if(processo.garantias.length > 0) {
      this.setState({garantiasProcesso: processo.garantias});
      let total = 0;
      for(let i = 0; i < processo.garantias.length; i++) {
        total = total + processo.garantias[i].vlPenhora;
      }
      this.setState({totalPenhora: total});
    }
  }

  headerTotalPenhora() {
    return(
      <React.Fragment>
        <label>Garantias: &nbsp;&nbsp; 
        <span className="verde">{this.formatCurrency(this.state.totalPenhora)}</span>&nbsp;&nbsp;&nbsp; </label>
      </React.Fragment>
    )
  }

  onChangeTipoGarantia(e) {
    this.setState({tipoGarantia: e.value});
  }

  acoesGarantiasProcesso(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                tooltip="Excluir Garantia"
                onClick={() => this.confirmaExclusaoGarantia(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
      </React.Fragment>
    );
  }

  confirmaExclusaoGarantia(garantia) {
    this.setState({codigoGarantia: garantia.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir a Garantia?',
        header: 'Exclusão de Garantias',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirGarantias,
        reject: this.reject
    });
  }

  acceptExcluirGarantias() {
    this.excluirGarantia();
  }

  excluirGarantia = async() => {
    this.setState({classeDiv: 'show'});
    await this.garantiaProcessoService.excluirGarantia(this.state.codigoGarantia)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Garantias', detail:'Garantia Excluída', life: 4000});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Garantias', detail:`${this.state.detail}`, life: 4000});
      })

      this.setState({visibleGarantias: false});
      this.listarGarantiasProcesso(this.state.processo.codigo);
      this.setState({classeDiv: 'hide'});
  }

  renderFooterCadastroGarantias(name) {
    return (
        <div>
          <Button label="Cadastrar" 
                  className="p-button-primary p-button-text"
                  onClick={this.incluirGarantias}/>
          &nbsp;
          <Button label="Cancelar" 
                  className="p-button-secondary p-button-text"
                  onClick={() => this.fecharModalCadastro(name)}/>
        </div>
    );
  }

  incluirGarantias = async () => {
    if(this.state.tipoGarantia == null) {
      this.toast.show({severity:'error', summary: 'Garantias', detail:'Informe o Tipo de Garantia', life: 4000});
      this.setState({classeDiv: 'hide'});
      return false;
    }

    if(this.state.vlPenhora == '') {
      this.toast.show({severity:'error', summary: 'Garantias', detail:'Informe o Valor da Penhora', life: 4000});
      this.setState({classeDiv: 'hide'});
      return false;
    }
    this.setState({openSpinner: true});
    await this.garantiaProcessoService.incluirGarantias({
      processo: this.state.processo,
      garantia: this.state.tipoGarantia,
      vlPenhora: this.state.vlPenhora
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Garantias', detail:'Garantia Incluída com Sucesso', life: 4000});
      this.consultarGarantiasProcesso(this.state.processo.codigo);
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Garantias', detail:`${this.state.detail}`, life: 4000});
    });

    this.fecharModalCadastro('modalGarantias');
    this.setState({openSpinner: false})
  }

  abrirModalCadastroGarantias(name, position) {
    this.listarTiposGarantias();
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.limparCamposGarantias();
    this.setState(state);
  }

  limparCamposGarantias = () => {
    this.setState({
      tipoGarantia: null,
      vlPenhora: ''
    })
  }

  voltar = () => {
    const consultaIndice = LocalStorageService.obterConsulta('_consulta_processo_indice');
    const consultaIndiceJson = JSON.parse(consultaIndice);

    const consultaFiltro = LocalStorageService.obterConsulta('_consulta_processo_filtro');
    const consultaFiltroJson = JSON.parse(consultaFiltro);

    if(consultaIndiceJson != null) {
      this.processoService.consultarProcessoPorIndice(consultaIndiceJson)
        .then(response => {
            this.props.history.push(`/processos?indice=${consultaIndiceJson.indice}&empresa=${consultaIndiceJson.empresa}&usuario=${consultaIndiceJson.usuario}`);
        }).catch(error => {
          this.setState(error.response.data);
          this.toast.show({severity:'error', summary: 'Processos', detail:`${this.state.detail}`, life: 4000});
        })
    } else if(consultaFiltroJson != null) {
      
      let params = `/processos?empresa=${consultaFiltroJson.empresa.codigo}&usuario=${consultaFiltroJson.usuario}`;

      if(consultaFiltroJson.pessoa != '') {
        params = `${params}&pessoa=${consultaFiltroJson.pessoa}`;
      }

      if(consultaFiltroJson.grupoTrabalho != null) {
        params = `${params}&grupoTrabalho=${consultaFiltroJson.grupoTrabalho.codigo}`;
      }

      if(consultaFiltroJson.tipoAcao != null) {
        params = `${params}&tipoAcao=${consultaFiltroJson.tipoAcao.codigo}`;
      }

      if(consultaFiltroJson.statusProcessual != null) {
        params = `${params}&statusProcessual=${consultaFiltroJson.statusProcessual.codigo}`;
      }

      if(consultaFiltroJson.tipoDecisao != null) {
        params = `${params}&tipoDecisao=${consultaFiltroJson.tipoDecisao.codigo}`;
      }

      if(consultaFiltroJson.pasta != '') {
        params = `${params}&pasta=${consultaFiltroJson.pasta}`;
      }

      if(consultaFiltroJson.numeroProcesso != '') {
        params = `${params}&numeroProcesso=${consultaFiltroJson.numeroProcesso}`;
      }

      if(consultaFiltroJson.numeroCnj != '') {
        params = `${params}&numeroCnj=${consultaFiltroJson.numeroCnj}`;
      }

      if(consultaFiltroJson.importanteParaMim === 'SIM') {
        params = `${params}&importanteParaMim=${consultaFiltroJson.importanteParaMim}`
      } 

      this.props.history.push(params);

    } else {
      this.props.history.push('/processos');
    }
  }

  acoesPartes(rowData) {
    return(
      <React.Fragment>
        <a className="cursor" 
           title="Excluir Parte"
           onClick={() => this.confirmaExclusaoParte(rowData)}>
             <i className="pi pi-trash"></i>
        </a>
        &nbsp;
        &nbsp;
        <a href={this.state.linkFichaPessoa} 
           className="cursor" 
           target="_blank"
           title="Consultar Pessoa"
           onClick={() => this.consultarPessoaFicha(rowData)}>
             <i className="pi pi-user"></i>
        </a>
      </React.Fragment>
    );
  }

  exibirNovaParte = () => {
    this.setState({selectParte: null});
    this.setState({tipoParte: null});
    if(this.state.exibirNovaParte == 'none') {
      this.setState({exibirNovaParte: 'block'});
      this.setState({iconeExibirNovaParte: '-'});
    } else {
      this.setState({exibirNovaParte: 'none'});
      this.setState({iconeExibirNovaParte: '+'});
    }
  }

  confirmaExclusaoParte(parte) {
    this.setState({codigoParte: parte.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir esta parte do processo?',
        header: 'Exclusão de Partes',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirParte,
        reject: this.reject
    });
  }

  acceptExcluirParte() {
    this.excluirParte();
  }

  excluirParte = async () => {
    this.setState({openSpinner: true});
    await this.processoService.excluirParte(this.state.codigoParte)
      .then(response => {
        this.consultarPartes();
        this.toast.show({severity:'success', summary: 'Processos', detail:'Parte retirada do processo', life: 4000});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao excluir parte', life: 4000});
      })

      this.setState({openSpinner: false});
  }

  async incluirParte(e){
    if(this.state.selectParte == null) {
      this.toast.show({severity:'error', summary: 'Processo', detail:'Informe o nome da parte', life: 4000});
      this.setState({tipoParte: null});
      this.setState({selectParte: null});
      return;
    }
    this.setState({openSpinner: true});
    this.setState({tipoParte: e.value})
    for(let i = 0; i < this.state.selectParte.length; i++) {
      const parteIncluir = {
        pessoa: this.state.selectParte[i],
        processo: this.state.processo,
        tipoParte: e.value.codigo
      }
      await this.processoService.cadastrarPartes(parteIncluir)
        .then(response => {
          this.consultarPartes();
          this.toast.show({severity:'success', summary: 'Processos', detail:`${this.state.selectParte[i].nome} incluído no processo`, life: 4000});
        })
    }
    this.setState({selectParte: null});
    this.setState({exibirNovaParte: 'none'});
    this.setState({iconeExibirNovaParte: '+'});
    this.setState({tipoParte: null});
    this.setState({openSpinner: false});
  }

  consultarPartes = async () => {
    await this.processoService.consultarPartesPorProcesso(this.state.processo.codigo)
      .then(response => {
        this.setState({partesProcesso: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao consultar partes do processo', life: 4000});
      })
  }

  async consultarPessoaFicha(parte) {
    this.setState({linkFichaPessoa: `#/consultarPessoas/${parte.pessoa.codigo}`});
  }

  alterarProcesso = async () => {
    if(this.state.responsavel == null) {
      this.toast.show({severity:'error', summary: 'Processos', detail:'É preciso informar o responsável do processo', life: 4000});
      return false;
    }

    if(this.state.numeroCnj == '' && this.pasta == '' && this.state.numeroProcesso) {
      this.toast.show({severity:'error', summary: 'Processos', detail:'É preciso informar uma pasta ou um processo ou um cnj', life: 4000});
      this.setState({classeDiv: 'hide'});
      return false;
    }

    if(this.state.grupoTrabalho == null) {
      this.toast.show({severity:'error', summary: 'Processos', detail:'É preciso inform o Grupo de Trabalho', life: 4000});
      this.setState({classeDiv: 'hide'});
      return false;
    }

    if(this.state.statusProcessual == null) {
      this.toast.show({severity:'error', summary: 'Processos', detail:'Informe o Status Processual', life: 4000});
      this.setState({classeDiv: 'hide'});
      return false;
    }

    if(this.state.areaAtuacao == null) {
      this.toast.show({severity:'error', summary: 'Processos', detail:'Informe a Área de Atuação', life: 4000});
      this.setState({classeDiv: 'hide'});
      return false;
    }

    if(this.state.tipoAcao == null) {
      this.toast.show({severity:'error', summary: 'Processos', detail:'Informe o Tipo de Ação', life: 4000});
      this.setState({classeDiv: 'hide'});
      return false;
    }

    if(this.state.dsComarca == '') {
      this.toast.show({severity:'error', summary: 'Processos', detail:'Informe o local de trâmite', life: 4000});
      this.setState({classeDiv: 'hide'});
      return false;
    }

    if(this.state.isArquivar) {
      if(this.state.resultadoArquivamento == null) {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Você está alterando o Status Processual para Arquivado. Informe o resultado do arquivamento', life: 4000});
        return false;
      }
    }

    const usuarioLogado = this.context.usuarioAutenticado;

    //Campos de Data
    //Data de Distribuição
    if(this.state.dataDistribuicao != '' && this.state.dataDistribuicao != null) {
      var date = this.state.dataDistribuicao;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      var dataFormatadaDataDistribuicao =  year+"-"+month+"-"+day;
    }
    //Data de Última de Decisão
    if(this.state.dataUltimaDecisao != '' && this.state.dataUltimaDecisao != null) {
      var date = this.state.dataUltimaDecisao;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      var dataFormatadaDataUltimaDecisao =  year+"-"+month+"-"+day;
    }
    //Data de Sentença
    if(this.state.dataSentenca != '' && this.state.dataSentenca != null) {
      var date = this.state.dataSentenca;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      var dataFormatadaDataSentenca =  year+"-"+month+"-"+day;
    }

    //Push
    let push = 'N';
    let email = 'N';
    let historico = 'N';
    if(this.state.push != null & this.state.push.length > 0) {
      for(let i = 0; i < this.state.push.length; i++) {
        if(this.state.push[i] == 'push') {
          push = 'S'
        }
        if(this.state.push[i] == 'email') {
          email = 'S'
        }
        if(this.state.push[i] == 'historico') {
          historico = 'S'
        }
      }
    }
    var uf = null;
    if(this.state.uf == null) {
      uf = null;
    } else {
      uf = this.state.uf.codigo;
    }
    var contingenciaContabil = null;
    if(this.state.contingenciaContabil != null) {
      contingenciaContabil = this.state.contingenciaContabil.codigo;
    } else {
      contingenciaContabil = null;
    }
    var processoArquivado = null;
    if(this.state.isArquivar) {
      //Data de Arquivamento do Tribunal
      var dataFormatadaDataArquivamentoTj = null;
      if(this.state.dataArquivamentoTj != '' && this.state.dataArquivamentoTj != null) {
        var date = this.state.dataArquivamentoTj;
        var month = this.pad2(date.getMonth()+1);//months (0-11)
        var day = this.pad2(date.getDate());//day (1-31)
        var year= date.getFullYear();
        dataFormatadaDataArquivamentoTj =  year+"-"+month+"-"+day;
      }
      processoArquivado = {
        resultadoArquivamento: this.state.resultadoArquivamento.codigo,
        dataArquivadoTribunal: dataFormatadaDataArquivamentoTj
      }
    }
    var risco = '';
    if(this.state.risco != null) {
      risco = this.state.risco.codigo;
    }
    this.setState({openSpinner: true});
    await this.processoService.alterarProcesso({
      codigo: this.state.processo.codigo,
      grupoTrabalho: this.state.grupoTrabalho,
      pasta: this.state.pasta,
      nrProcesso: this.state.nrProcesso,
      nrCnj: this.state.nrCnj,
      instancia: this.state.instancia,
      dsComarca: this.state.dsComarca,
      tipoAcao: this.state.tipoAcao,
      statusProcessual: this.state.statusProcessual,
      areaAtuacao: this.state.areaAtuacao,
      tipoDecisao: this.state.tipoDecisao,
      vlProvavel: this.state.vlProvavel,
      vlPossivel: this.state.vlPossivel,
      vlRemoto: this.state.vlRemoto,
      vlCausa: this.state.vlCausa,
      dsPedidos: this.state.dsPedidos,
      dataDistribuicao : dataFormatadaDataDistribuicao,
      dataUltimaDecisao: dataFormatadaDataUltimaDecisao,
      dataSentenca: dataFormatadaDataSentenca,
      snPush: push,
      snEmail: email,
      snHistorico: historico,
      observacao: this.state.observacao,
      usuario: usuarioLogado,
      responsavel: this.state.responsavel,
      empresa: usuarioLogado.empresa,
      tipoContingenciaContabil: contingenciaContabil,
      motivoDto: this.state.motivo,
      fase: this.state.fase,
      rito: this.state.rito,
      uf: uf,
      orgaoColegiado: this.state.orgaoColegiado,
      relator: this.state.relatorProcesso,
      bancada: this.state.bancada,
      processoArquivado: processoArquivado,
      risco: risco
    }).then(response => {
      this.setState({classeDivAutor: 'hide'});
      this.setState({classeDivReu: 'hide'});
      this.setState({classeDivAdvogado: 'hide'});
      this.setState({iconReu: 'pi pi-plus-circle'});
      this.setState({iconAutor: 'pi pi-plus-circle'});
      this.setState({iconAdvogado: 'pi pi-plus-circle'});
      if(this.state.agravoApensoConsulta.codigo != null) {
        const agravoApenso = {
          codigo: this.state.agravoApensoConsulta.codigo,
          processo: this.state.agravoApensoConsulta.processo,
          processoPrincipal: this.state.agravoApensoConsulta.processoPrincipal,
          camara: this.state.camaraConsulta,
          relator: this.state.relatorConsulta,
          tipo: this.state.agravoApensoConsulta.tipo
        }
        this.agravoApensoService.alterar(agravoApenso)
          .then(response => {
            this.toast.show({severity:'success', summary: 'Processo Agravo Apenso', detail:'Processo Agravo/Apenso alterado', life: 4000});
          }).catch(error => {
            this.toast.show({severity:'success', summary: 'Processo Agravo Apenso', detail:'Processo Agravo/Apenso alterado', life: 4000});
          })
      }
      this.consultarProcesso(this.state.processo.codigo);
      this.toast.show({severity:'success', summary: 'Processos', detail:'Processo alterado com sucesso', life: 4000});
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Processos', detail:`${this.state.detail}`, life: 4000});
    })

    this.setState({openSpinner: false})
  }

  cadastrarPartes = async (processo) => {
    if(this.state.selectedAutor != null) {
      for(let i = 0; i < this.state.selectedAutor.length; i++) {
        await this.processoService.cadastrarPartes({
          processo: processo,
          pessoa: this.state.selectedAutor[i],
          tipoParte: 'A'
        }).then(response => {
          console.log('Partes cadastrada',this.state.selectedAutor[i].nome);
        }).catch(error => {
          this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao cadastrar uma das partes do processo - Autor', life: 4000});
        })
      };
    }
    
    if(this.state.selectedReu != null) {
      for(let i = 0; i < this.state.selectedReu.length; i++) {
        await this.processoService.cadastrarPartes({
          processo: processo,
          pessoa: this.state.selectedReu[i],
          tipoParte: 'R'
        }).then(response => {
          console.log('Partes cadastrada',this.state.selectedReu[i].nome);
        }).catch(error => {
          this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao cadastrar uma das partes do processo - Réu', life: 4000});
        })
      }
    }

    if(this.state.selectedAdvogado != null) {
      for(let i = 0; i < this.state.selectedAdvogado.length; i++) {
        await this.processoService.cadastrarPartes({
          processo: processo,
          pessoa: this.state.selectedAdvogado[i],
          tipoParte: 'D'
        }).then(response => {
          console.log('Partes cadastrada',this.state.selectedAdvogado[i].nome);
        }).catch(error => {
          this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao cadastrar uma das partes do processo - Réu', life: 4000});
        })
      }
    }

    //exlui o [indice e cadastra com o novo
    await this.excluirIndiceProcesso(processo.codigo);
    //diciona novo índice
    this.cadastrarIndiceProcesso(processo);
  }

  excluirIndiceProcesso = (processo) => {
    this.processoService.excluirIndiceProcesso(processo)
      .then(response => {
        console.log('Indice de processo excluído com sucesso');
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao excluir índice de processo', life: 4000});
      })
  }

  cadastrarIndiceProcesso = (processo) => {
    this.processoService.cadastrarIndiceProcesso({
      codigo: processo.codigo
    }).then(response => {
      console.log('Indice cadastrado')
    })
  }

  cadastrarObjetosProcesso = async () => {
    if(this.state.objetoAcao == null && this.state.selectSubObjetos == null) {
      this.toast.show({severity:'error', summary: 'Objetos de Ação', detail:'Nenhum objeto selecionado', life: 4000});
      return;
    }
  
    let objeto = null;
    if(this.state.objetoAcao != null) {
      objeto = {
        processo: this.state.processo,
        objeto: this.state.objetoAcao
      }

      this.objetosProcesso.push(objeto);
    }

    if(this.state.selectSubObjetos != null) {
      for(let i = 0; i < this.state.selectSubObjetos.length; i++) {
        objeto = {
          processo: this.state.processo,
          objeto: this.state.selectSubObjetos[i]
        }
        this.objetosProcesso.push(objeto);
      }
    }
    var cadastrou = false;
    this.setState({openSpinner: true});
    for(let i = 0; i < this.objetosProcesso.length; i++) {
      await this.objetoAcaoProcessoService.cadastrarObjetoAcaoProcesso({
        processo: this.state.processo,
        objeto: this.objetosProcesso[i].objeto
      }).then(response => {
        console.log('Objeto Cadastrado')
        cadastrou = true;
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao cadastrar Objetos de Ação no Processo', life: 4000});
      })
    }
    this.fecharModal('modalObjetos');
    if(cadastrou) {
      this.toast.show({severity:'success', summary: 'Objeto de Ação', detail:'Objeto(s) cadastrado(s) com sucesso', life: 4000});
    }
    await this.listarObjetosAcao(this.state.processo.empresa);
    await this.consultarObjetosPorProcesso(this.state.processo.codigo);
    this.setState({objetoAcao: null});
    this.setState({openSpinner: false});
  }

  onCityChange(e) {
    let selectedCities = [...this.state.push];

    if (e.checked)
        selectedCities.push(e.value);
    else
        selectedCities.splice(selectedCities.indexOf(e.value), 1);

    this.setState({ push: selectedCities });
  }

  //Upload de Documentos
  handleUpload = async files => {
    const upLoadFiles = files.map(file => ({
      file,
      id: uniqueId(),
      name: file.name,
      readableSize: filesize(file.size),
      progress: 0,
      uploaded: false, 
      error: false,
      url: file.url
    }))

    this.setState({
      upLoadFiles: this.state.upLoadFiles.concat(upLoadFiles)
    });

    await upLoadFiles.forEach(this.processar);
  }

  updateFile = (id, data) => {
    this.setState({upLoadFiles: this.state.upLoadFiles.map(upLoadFile => {
      return id === upLoadFile.id ? { ...upLoadFile, ...data } : upLoadFile;
    })})
  }

  processar = async (upLoadFile) => {
    const usuarioLogado = this.context.usuarioAutenticado;
    const data = new FormData();
    data.append('file',upLoadFile.file);
    data.append('processo',upLoadFile.file, this.state.processo.codigo) //Envia código do processo para criar diretório
    data.append('usuario', upLoadFile.file, usuarioLogado.codigo);
    await this.arquivoProcessoService.incluirArquivo(data)
      .then(response => {
        this.handleDelete(upLoadFile.id);
        this.listarArquivosProcesso(this.state.processo.codigo);
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarArquivosProcesso = (processo) => {
    this.arquivoProcessoService.listarArquivos(processo)
      .then(response => {
        this.setState({arquivos: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  handleDelete  = async id => {
    this.setState({upLoadFiles: this.state.upLoadFiles.filter(file => file.id !== id)});
  } 

  consultarArquivo = async (arquivo) => {
    await this.arquivoProcessoService.consultarArquivo(arquivo)
      .then(response => {
        this.setState({arquivo: response.data});
        this.setState({dsArquivo: response.data.dsArquivo});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      });
  }

  async consultarArquivoDescricao(arquivo) {
    await this.arquivoProcessoService.consultarArquivo(arquivo.codigo)
      .then(response => {
        this.setState({arquivo: response.data});
        this.setState({dsArquivo: response.data.dsArquivo});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      });

      this.abrirModalDescricaoArquivo('modalDescricaoArquivo');
  }

  adicionarDescricao = async () => {
    await this.arquivoProcessoService.adicionarDescricao({
      codigo: this.state.arquivo.codigo,
      nome: this.state.arquivo.nome,
      dsArquivo: this.state.dsArquivo,
      dataArquivo: this.state.arquivo.dataArquivo,
      usuario: this.state.arquivo.usuario,
      processo: this.state.arquivo.processo
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Arquivos', detail:'Descrição de arquiivo alterada', life: 4000});
      this.listarArquivosProcesso(this.state.processo.codigo);
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
    });

    this.fecharModalCadastro('modalDescricaoArquivo');
  }

  async download (rowData){
    await this.consultarArquivo(rowData.codigo);
    await this.arquivoProcessoService.download(rowData.codigo)
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.state.arquivo.nome); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
  }

  acoesArquivos(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-comment" className="p-button-rounded p-button-text"
                tooltip="Adicionar descrição ao arquivo"
                tooltipOptions={{position: 'top'}}
                onClick={() => this.consultarArquivoDescricao(rowData)}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-cloud-download" className="p-button-rounded p-button-text"
                tooltip="Baixar Arquivo"
                onClick={() => this.download(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                tooltip="Excluir Arquivo"
                onClick={() => this.confirmaExclusaoArquivo(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
      </React.Fragment>
    );
  }

  excluirArquivo = async () => {
    this.setState({classeDiv: 'show'});
    await this.arquivoProcessoService.excluirArquivo(this.state.arquivoCodigo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Arquivos', detail:'Arquivo excluído com sucesso', life: 4000});
        this.listarArquivosProcesso(this.state.processo.codigo);
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
        this.setState({classeDiv: 'hide'});
      })

      this.setState({classeDiv: 'hide'});
  }

  confirmaExclusaoArquivo(arquivo) {
    this.setState({arquivoCodigo: arquivo.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir este arquivo?',
        header: 'Exclusão de Arquivos',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirArquivo,
        reject: this.reject
    });
  }

  acceptExcluirArquivo() {
    this.excluirArquivo();
  }

  renderFooterDescricaoArquivo(name) {
    return (
        <div>
          <Button label="Cancelar" 
                  className="p-button-secondary p-button-text"
                  onClick={() => this.fecharModalCadastro(name)}/>
          &nbsp;
          <Button label="Alterar" 
                  className="p-button-primary p-button-text"
                  onClick={this.adicionarDescricao}/>
        </div>
    );
  }

  renderFooterDescricaoArquivoNovaAtividade(name) {
    return (
        <div>
            <button type="button" 
                    className="btn btn-primary bg-gradient-secondary" 
                    onClick={() => this.fecharModalCadastro(name)}>
                <i className="fas fa-times"></i> Cancelar
            </button>
            <button type="button" className="btn btn-primary bg-gradient-success"
                    onClick={this.adicionarDescricaoNovaAtividade}>
                <i className="fas fa-check"></i> Alterar
            </button>
        </div>
    );
  }

  abrirModalDescricaoArquivo(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  consultarProcessoImportancia = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    const filtro = {
      usuario: usuarioLogado.codigo,
      processo: this.state.processo.codigo
    }

    await this.processoImportanciaService.consultarProcessoImportancia(filtro)
      .then(response => {
        if(response.data != '') {
          this.setState({iconeImportanteParaMim: 'p-button-rounded p-button-danger'});
          this.setState({iconeImportanteParaMimTitle: 'Processo classificado como meus favoritos'});
          this.setState({exibirFavorito: 'hide'});
        } else {
          this.setState({iconeImportanteParaMim: 'p-button-rounded p-button-secondary'});
          this.setState({iconeImportanteParaMimTitle: 'Clique para favoritar o processo'});
          this.setState({exibirFavorito: 'none'});
        }
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processo Importancia', detail:`${this.state.detail}`, life: 4000});
      })
  }

  iincluirProcessoImportancia = async () => {
    const usuarioLogado = this.context.usuarioAutenticado
    const filtro = {
      usuario: usuarioLogado.codigo,
      processo: this.state.processo.codigo
    }
    this.setState({openSpinner: true});
    await this.processoImportanciaService.consultarProcessoImportancia(filtro)
      .then(response => {
        this.setState({processoImportancia: response.data});
        if(this.state.processoImportancia != '') {
          this.processoImportanciaService.excluirProcesso(response.data.codigo)
            .then(response => {
              this.setState({iconeImportanteParaMim: 'p-button-rounded p-button-secondary'});
              this.setState({iconeImportanteParaMimTitle: 'Clique para favoritar o processo'});
            }).catch(error => {
              this.setState(error.response.data);
              this.toast.show({severity:'error', summary: 'Processo Importancia', detail:`${this.state.detail}`, life: 4000});
            })
        } else {
          this.processoImportanciaService.incluirProcesso({
            usuario: usuarioLogado,
            processo: this.state.processo
          }).then(response => {
            this.setState({iconeImportanteParaMim: 'p-button-rounded p-button-danger'});
            this.setState({iconeImportanteParaMimTitle: 'Processo classificado como meus favoritos'});
          }).catch(error => {
            this.setState(error.response.data);
            this.toast.show({severity:'error', summary: 'Processo Importancia', detail:`${this.state.detail}`, life: 4000});
          })
        }
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processo Importancia', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  incluirProcessoImportanteParaEmpresa = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(usuarioLogado.empresa.codigo != 142) { // Unimed Fama
      if(usuarioLogado.perfil.codigo != 1) {
        this.toast.show({severity:'error', summary: 'Processo Importancia', detail:'O usuário não tem permissão para executar esta ação', life: 4000});
        return false;
      }
    }

    let importancia = '';
    if(this.state.processo.snImportante == 'S') {
      importancia = 'N';
    } else {
      importancia = 'S';
    }

    this.setState({openSpinner: true});
    await this.processoService.alterarImportanciaEmpresa({
      codigo: this.state.processo.codigo,
      snImportante: importancia
    }).then(response => {
      if(importancia == 'S') {
        this.setState({iconeImportanteParaEmpresa: 'p-button-rounded p-button-warning'});
        this.setState({iconeImportanteParaEmpresaTitle: 'Processo importante para empresa'});
      } else {
        this.setState({iconeImportanteParaEmpresa: 'p-button-rounded p-button-secondary'});
        this.setState({iconeImportanteParaEmpresaTitle: 'Clique para incluir o processo como importante'});
      }
      this.consultarProcesso(this.state.processo.codigo);
    });
    this.setState({openSpinner: false});
  }

  incluirProcessoEstrategico = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(usuarioLogado.empresa.codigo != 142) {
      if(usuarioLogado.perfil.codigo != 1) {
        this.toast.show({severity:'error', summary: 'Processo Importancia', detail:'O usuário não tem permissão para executar esta ação', life: 4000});
        return false;
      }
    }

    let estrategico = '';
    if(this.state.processo.estrategico == 'S') {
      estrategico = 'N';
    } else {
      estrategico = 'S';
    }

    this.setState({openSpinner: true});
    await this.processoService.alterarEstrategicoEmpresa({
      codigo: this.state.processo.codigo,
      estrategico: estrategico
    }).then(response => {
      if(estrategico == 'S') {
        this.setState({iconeEstrategico: 'p-button-rounded p-button-warning'});
        this.setState({iconeEstrátegicoTitle: 'Processo Estratégico'});
      } else {
        this.setState({iconeEstrategico: 'p-button-rounded p-button-secondary'});
        this.setState({iconeEstrátegicoTitle: 'Clique para tornar o processo estratégico'});
      }
      this.consultarProcesso(this.state.processo.codigo);
    });
    this.setState({openSpinner: false});
  }

  consultarAtividades = async (processo) => {
    await this.atividadeService.consultarAtividadePorProcesso(this.state.processo.codigo)
      .then(response => {
        this.setState({atividades: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }
 
  templateStatus(data) {
    let status = '';
    switch(data.status.codigo) {
      case 1:
          status = 'statusAtivo';
          break;
      case 2:
          status = 'statusAguardando';
          break;
      case 3:
          status = 'statusCancelado'
          break;
      case 4:
          status = 'statusCiente';
          break;
      case 5:
          status = 'statusConcluido'
          break;
      default: 
          status = 'statusFazendo'
    }
    
    return(
      <React.Fragment>
        <div className={status}>{data.status.status}</div>
      </React.Fragment>
    );
  }

  templateHistoricoAtividade(data) {
    var icone = '';
    var titulo = '';
    if(data.tpHistorico == 'A') {
      icone = 'fa fa-solid fa-robot';
      titulo = 'Incluído de forma automática';
    } else {
      icone = 'pi pi-user-plus';
      titulo = 'Incluído manualmente';
    }
    return (
      <div className="col-12">
        <div>
          <strong style={{textAlign: 'left', color: 'blue'}}
                  className="grupoTrabalho">
             {data.usuario.nome} - {data.dtHistorico}
          </strong>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <strong style={{textAlign: 'right'}}>
            <i className={icone} title={titulo}/>
          </strong>
        </div>
        <br />
        <div className="balao" style={{borderRadius: '6px'}}>
          {data.dsHistorico}
        </div>
        <br/>
      </div>
    )
  }

  novaAtividadeHeader() {
    return (
      <React.Fragment>
        <div>
          <Button icon="fas fas fa-tasks" className="p-button-rounded p-button-text" 
                  tooltip="Criar Atividade Atônoma"
                  onClick={() => this.abrirModalAtividade('displayAtividade')}
                  tooltipOptions={{position: 'top'}} />
          &nbsp;
          <Button icon="fab fa-stack-overflow" className="p-button-rounded p-button-text" 
                  tooltip="Criar Atividade Agrupada"
                  onClick={() => this.abrirModalAtividadeAgrupada('modalTarefaAgrupada')}
                  tooltipOptions={{position: 'top'}} />
        </div>
      </React.Fragment>
    )
  }

  acoesAtividade(data) {
    return(
      <React.Fragment>
        <div>
          <Button icon="pi pi-pencil" className="p-button-rounded p-button-text" 
                  tooltip="Editar Atividade"
                  onClick={() => this.consultarAtividade(data)}
                  tooltipOptions={{position: 'top'}} />
        </div>
      </React.Fragment>
    )
  }

  fecharModalAtividade(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  renderFooterAtividade(name) {
    return (
        <div className="left">
            <Button label="Alterar" 
                    className="p-button-primary p-button-text"
                    onClick={this.alterarAtividade}/>
            &nbsp;
            <Button label="Anexar" 
                    icon="pi pi-paperclip"
                    onClick={() => this.abrirModalArquivosAnexos('displayArquivosAnexadosAtividade')}
                    className="p-button-help p-button-text"/>
            &nbsp;
            <Button label="Histórico" 
                    icon="pi pi-history"
                    className="p-button-help p-button-text"
                    onClick={this.consultarHistorico}/>
            &nbsp;
            <Button label="Cancelar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModalAtividade(name)}/>
        </div>
    );
  }

  async onChangeFasesPorTitulo(e) {
    this.setState({openSpinner: true});
    if(e.value != null) {
      this.setState({tituloAtividade: e.value});
      await this.listarFasesTarefasPorTitulo(e.value);
    } else {
      this.setState({tituloAtividade: null});
    };
    this.setState({openSpinner: false});
  }

  abrirModalAtividade(name, position) {
    const usuarioLogado = this.context.usuarioAutenticado;
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState({openSpinner: true});
    if(usuarioLogado.empresa.tituloPredefinido == 'N') {
      this.listarFases();
    } else {
      this.setState({fasesAtividade: null});
    }
    this.excluirArquivosTemp();
    this.setState(state);
    this.consultarSubGrupos(this.state.grupoTrabalho.grupoPai);
    this.setState({grupoTrabalhoNome: this.state.grupoTrabalho.nome});
    if(this.state.nrCnj == null) {
      this.setState({pesquisaProcesso: this.state.nrProcesso});
    } else {
      this.setState({pesquisaProcesso: this.state.nrCnj});
    }
    this.listarResponsaveis();
    this.listarInteressados();
    this.limparCamposAtividade();
    this.listarTitulosAtividade();
    this.setState({openSpinner: false});
  }

  limparCamposAtividade = () => {
    this.setState({tituloAtividade: null});
    this.setState({titulo: ''});
    this.setState({hora: ''});
    this.setState({descricao: ''});
    this.setState({dtLimite: ''});
    this.setState({hora: ''});
    this.setState({dtFatal: ''});
    this.setState({tipo: ''});
    this.setState({status: ''});
    this.setState({responsavel: null});
    this.setState({interessado: null});
    this.setState({responsaveis: []});
    this.setState({selectSubGrupo: null});
    this.setState({recorrencia: null});
    this.setState({repeticao: null});
    this.setState({faseAtividade: null});
  }

  onSubGrupoChange(e) {
    this.setState({selectSubGrupo: e.value});
  }

  cadastrarAtividade = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(usuarioLogado.empresa.tituloPredefinido == 'S') {
      if(this.state.tituloAtividade == null) {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o título da Atividade', life: 4000});
        return false;
      }  
    } else {
      if(this.state.titulo == '') {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o título da Atividade', life: 4000});
        return false;
      }
    }

    if(this.state.selectSubGrupo == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o Sub-Grupo de Trabalho', life: 4000});
      return false;
    }

    if(this.state.responsavel == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'A atividade precisa de ao menos um responsável', life: 4000});
      return false;
    }

    if(this.state.recorrencia != null) {
      if(this.state.recorrencia.codigo == 'R' && this.state.repeticao == null) {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Você selecionou recorrência e não definiu a repetição', life: 4000});
        return false;
      }
    }

    if(this.state.dtLimite == '' || this.state.dtLimite == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe a Data Limite', life: 4000});
      return false;
    }

     //Data Limite
     var tipoTarefa = '';
     var dataFormatadaDataLimite = '';
     if(this.state.dtLimite != '' && this.state.dtLimite != null) {
       var date = this.state.dtLimite;
       var month = this.pad2(date.getMonth()+1);//months (0-11)
       var day = this.pad2(date.getDate());//day (1-31)
       var year= date.getFullYear();
       if(this.state.hora != '') {
         dataFormatadaDataLimite =  year+"-"+month+"-"+day+" "+this.state.hora+":00";
         tipoTarefa = 'A'
       } else {
          dataFormatadaDataLimite =  year+"-"+month+"-"+day+" 00:00:00";
          tipoTarefa = 'T';
       }
     }

     var dataFormatadaDataFatal = '';
     if(this.state.dtFatal != '' && this.state.dtFatal != null) {
       var date = this.state.dtFatal;
       var month = this.pad2(date.getMonth()+1);//months (0-11)
       var day = this.pad2(date.getDate());//day (1-31)
       var year= date.getFullYear();
       if(this.state.hora != '') {
          dataFormatadaDataFatal =  year+"-"+month+"-"+day+" "+this.state.hora+":00";
        } else {
          dataFormatadaDataFatal =  year+"-"+month+"-"+day+" 00:00:00";
        }
    }

    var responsaveis = [];
    for(let i = 0; i < this.state.responsavel.length; i++) {
      responsaveis.push(this.state.responsavel[i]);
    };

    var interessados = [];
    if(this.state.interessado != null) {
      for(let i = 0; i < this.state.interessado.length; i++) {
        interessados.push(this.state.interessado[i]);
      }
    }

    var titulo = '';
    if(usuarioLogado.empresa.tituloPredefinido == 'S') {
      titulo = this.state.tituloAtividade.titulo;
    } else {
      titulo = this.state.titulo;
    }

    var recorrencia = null;;
    if(this.state.recorrencia == null) {
      recorrencia = '0';
    } else {
      recorrencia = this.state.recorrencia.codigo;
    }

    const atividadeCadastro = {
      atividade: {
        titulo: titulo,
        processo: this.state.processo,
        subGrupo: this.state.selectSubGrupo,
        dtLimite: dataFormatadaDataLimite,
        descricao: this.state.descricao,
        usuario: usuarioLogado,
        tipo: tipoTarefa,
        status: {
          codigo: 1 // Ativo
        },
        fase: this.state.faseAtividade
      },
      recorrencia: recorrencia,
      responsaveis: responsaveis,
      interessados: interessados
    }

    this.setState({separador: 'block'});
    this.setState({classeDiv: 'show'})
    await this.atividadeService.cadastrarAtividade(atividadeCadastro)
      .then(response => {
        this.fecharModalAtividade('displayAtividade');
        this.toast.show({severity:'success', summary: 'Atividades', detail:'Atividade cadastrada com sucesso', life: 4000});
        this.consultarAtividades(this.state.processo.codigo);
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${error}`, life: 4000});
      });

      this.setState({classeDiv: 'hide'});
      this.setState({separador: 'none'});
  }

  abrirModalAnexo(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  onSubGrupoChange(e) {
    this.setState({selectSubGrupo: e.value});
  }

  onChangeStatusAtividade(e) {
    this.setState({optionStatus: e.value})
  }

  consultarSubGrupos = async(codigo) => {
    await this.grupoTrabalhoService.listarSubGrupos(codigo)
      .then(response => {
        this.setState({subGrupos: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao carregar Sub-Grupos de Trabalho', life: 4000});
      })
  }

  listarResponsaveis = async() => {
    await this.usuarioGrupoTrabalhoService.listarUsuariosAtividade(this.state.processo.grupoTrabalho.codigo)
      .then(response => {
        this.setState({responsaveis: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar responśaveis', life: 4000});
      })
  }

  listarInteressados = async() => {
    await this.usuarioGrupoTrabalhoService.listarUsuariosAtividade(this.state.grupoTrabalho.codigo)
      .then(response => {
        this.setState({interessados: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar interssados', life: 4000});
      })
  }

  async consultarAtividade(atividade) {
    this.setState({openSpinner: true});
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.atividadeService.consultarAtividade(atividade.codigo)
      .then(response => {
        this.setState({atividade: response.data});
        this.setState({codigo: response.data.codigo});
        this.setState({titulo: response.data.titulo});
        this.setState({descricao: response.data.descricao});
        this.consultarGrupoTrabalhoPai(response.data.subGrupo.grupoPai);
        this.consultarSubGrupos(response.data.subGrupo.grupoPai);
        this.setState({tipo: response.data.tipo});
        this.setState({faseAtividade: response.data.fase});
        //this.consultarGruposTrabalho();
        this.setState({selectSubGrupo: response.data.subGrupo}); //vasconcelos
        this.setState({grupoTrabalhoNome: response.data.processo.grupoTrabalho.nome});
        
        //this.setState({processo: response.data.processo});
        if(response.data.processo.nrCnj != '' && response.data.processo.nrCnj != null) {
          this.setState({pesquisaProcesso: response.data.processo.nrCnj});
        } else {
          this.setState({pesquisaProcesso: response.data.processo.nrProcesso});
        }
        this.setState({partes: response.data.processo.autor});
        if(response.data.processo.snImportante != 'N' && response.data.processo.snImportante != null) {
          this.setState({importante: 'p-button-rounded p-button-warning'});
          this.setState({titleImportante: 'Processo classificado como importante para empresa'});
          this.setState({exibirImportanteEmpresa: 'hide'});
        } else {
          this.setState({exibirImportanteEmpresa: 'none'});
        }
    
        var dataLimite = new Date(response.data.dtLimite);
        //if(response.data.tipo == 'T') {
          dataLimite.setDate(dataLimite.getDate() + 1);
        //} else {
          //dataLimite.setDate(dataLimite.getDate() + 2);
        //}
        this.setState({dtLimite: new Date(Date.parse(dataLimite))});
        this.setState({hora: response.data.hora});
        if(response.data.dtFatal != null) {
          var dataFatal = new Date(response.data.dtFatal);
          dataFatal.setDate(dataFatal.getDate() + 1)
          this.setState({dtFatal: new Date(Date.parse(dataFatal))});
        } else {
          this.setState({dtFatal: ''});
        }
        this.listarStatusAtividade();
        this.setState({optionStatus: response.data.status});
  
        this.listarArquivosAtividade();
      }
    ).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
    })
    /*if(usuarioLogado.empresa.tituloPredefinido == 'N') {
      await this.listarFases();
    } else {
      await this.consultarTituloAtividadePorNome(this.state.titulo, usuarioLogado.empresa.codigo);
      await this.listarFasesTarefasPorTitulo(this.state.tituloAtividade);
    }*/
    await this.consultarProcessoImportancia();
    await this.consultarResponsaveis();
    await this.consultarInteressados();
    this.abrirModalAtividadeAlterar('displayAtividadeAlterar');
    this.setState({openSpinner: false});
  }

  consultarTituloAtividadePorNome = async (nome) => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.tituloAtividadeService.consultarPorNome(nome, usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({tituloAtividade: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao consultar Título da Atividade pelo nome', life: 4000});
      })
  }

  abrirModalAtividadeAlterar(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  listarArquivosAtividade = async () => {
    await this.arquivoAtividadeService.listarArquivos(this.state.atividade.codigo)
      .then(response => {
        this.setState({arquivosAtividades: response.data});
        if(response.data.length > 0) {
          this.setState({exibirLinkAnexo: 'block'});
        } else {
          this.setState({exibirLinkAnexo: 'none'});
        }
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarResponsaveis = async () => {
    await this.atividadeService.consultarUsuariosAtividade(this.state.atividade.codigo, 'R')
      .then(response => {
        this.setState({responsaveisLista: response.data});
        this.setState({quantidadeResponsaveis: 'Responsaveis da Atividade ( ' + this.state.responsaveisLista.length + ' )'});
        this.listarResponsaveis(); 
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar responsáveis da atividade', life: 4000});
      })
  }

  consultarInteressados = async () => {
    await this.atividadeService.consultarUsuariosAtividade(this.state.codigo, 'I')
      .then(response => {
        this.setState({interessadosLista: response.data});
        if(this.state.interessadosLista.length == 0) {
          this.setState({quantidadeInteressados: 'Atividade sem interessados'});
        } else {
          this.setState({quantidadeInteressados: 'Interessados da Atividade ( ' + this.state.interessadosLista.length + ' )'});
        }
        this.listarInteressados();
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar responsáveis da atividade', life: 4000});
      })
  }

  consultarHistorico = async () => {
    await this.atividadeService.consultarHistorico(this.state.codigo)
      .then(response => {
        this.setState({historico: response.data});
        this.abrirModalHistorico('displayHistorico');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  acoesHistoricoUsuario(rowData) {
      if(rowData.tpHistorico == 'A') {
        return (
          <React.Fragment>
            <i className="fa fa-solid fa-robot" title="Incluído de forma automática"/>
          </React.Fragment>
        )
      } else {
        return (
          <React.Fragment>
            <i className="pi pi-user-plus" title="Incluído manualmente"/>
          </React.Fragment>
        )
      }
  }

  acoesHistoricoAtividade(rowData) {
    if(rowData.tpHistorico != 'A') {
      return (
        <React.Fragment>
           <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                   tooltip="Excluir Histórico"
                   onClick={() => this.confirmaExclusaoHistoricoAtividade(rowData)}
                   tooltipOptions={{position: 'top'}}
                   style={{width: '20px', height: '10px'}}/>
        </React.Fragment>
      )
    } 
}

  consultarGrupoTrabalhoPai = async (codigo) => {
    await this.grupoTrabalhoService.consultarGrupo(codigo)
      .then(response => {
        this.setState({selectGrupo: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao consultar Grupo de Trabalho', life: 4000});
      })
  }

  abrirModalDescricao(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  abrirModalHistorico(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  novoHistorico = () => {
    this.setState({dsHistorico: ''});
    this.abrirModalHistorico('displayHistoricoIncluir');
  }

  async incluirHistoricoAtividade () {
    const usuarioLogado = this.context.usuarioAutenticado

    if(this.state.dsHistorico == '') {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o histórico da Atividade', life: 4000});
      return false;
    }

    let tipoHistorico = 'M';
    if(usuarioLogado.empresa.codigo == 138) {
      let data = 'N';
        if(this.state.mudancaDataHistorico != null & this.state.mudancaDataHistorico.length > 0) {
          for(let i = 0; i < this.state.mudancaDataHistorico.length; i++) {
            if(this.state.mudancaDataHistorico[i] == 'mudancaData') {
              data = 'S'
            }
          }
        }

        if(data == 'S') {
          tipoHistorico = 'D';
        } else {
          tipoHistorico = 'M';
        }
    } else {
      tipoHistorico = 'M';
    }

    await this.atividadeService.incluirHistorico({
      atividade: this.state.atividade,
      dsHistorico: this.state.dsHistorico,
      usuario: usuarioLogado,
      tpHistorico: tipoHistorico
    }).then(response => {
      this.listarHistorico();
      this.fecharModalAtividade('displayHistoricoIncluir');
      this.toast.show({severity:'success', summary: 'Atividades', detail:'Histórico incluído com sucesso', life: 4000});
    });
  }

  listarHistorico = async () => {
    await this.atividadeService.consultarHistorico(this.state.codigo)
      .then(response => {
        this.setState({historico: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
    })
  }

  confirmaExclusaoHistoricoAtividade(historico) {
    this.setState({registroHistorico: historico});
    confirmDialog({
        message: 'Deseja realmente excluir o Histórico da Atividade?',
        header: 'Exclusão de Histórico de Atividades',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirHistoricoAtividade,
        reject: this.reject
    });
  }

  acceptExcluirHistoricoAtividade() {
    this.excluirHistoricoAtividade();
  }

  excluirHistoricoAtividade = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.atividadeService.excluirHistorico(this.state.registroHistorico.codigo, this.state.registroHistorico.usuario.codigo, usuarioLogado.codigo)
      .then(response => {
        this.listarHistorico();
        this.toast.show({severity:'success', summary: 'Atividades', detail:'Histórico excluído', life: 4000});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  //Tudo referente a upload de documentos da atividade
  acoesArquivosAtividade(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-comment" className="p-button-rounded p-button-text"
                tooltip="Adicionar descrição ao arquivo"
                tooltipOptions={{position: 'top'}}
                onClick={() => this.consultarArquivoAtividadeDescricao(rowData)}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-cloud-download" className="p-button-rounded p-button-text"
                tooltip="Baixar Arquivo"
                tooltipOptions={{position: 'top'}}
                onClick={() => this.downloadArquivoAtividade(rowData)}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                tooltip="Excluir Arquivo"
                onClick={() => this.confirmaExclusaoArquivoAtividade(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
      </React.Fragment>
    );
  }

  async downloadArquivoAtividade(rowData) {
    await this.consultarArquivoAtividade(rowData);
    await this.arquivoAtividadeService.download(rowData.codigo)
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.state.arquivo.arquivo); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
  }

  consultarArquivoAtividade = async (arquivo) => {
    await this.arquivoAtividadeService.consultarArquivo(arquivo.codigo)
      .then(response => {
        this.setState({arquivo: response.data});
        this.setState({dsArquivo: response.data.dsArquivo});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      });
  }

  async consultarArquivoAtividadeDescricao(arquivo){
    await this.arquivoAtividadeService.consultarArquivo(arquivo.codigo)
      .then(response => {
        this.setState({arquivo: response.data});
        this.setState({dsArquivo: response.data.dsArquivo});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      });

      this.abrirModalDescricaoArquivo('modalDescricaoArquivoAtividade');
  }

  abrirModalDescricaoArquivo(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  excluirArquivoAtividade = () => {
    this.arquivoAtividadeService.excluirArquivo(this.state.arquivoCodigo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Arquivos', detail:'Arquivo excluído com sucesso', life: 4000});
        this.listarArquivosAtividade();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  confirmaExclusaoArquivoAtividade(arquivo) {
    this.setState({arquivoCodigo: arquivo.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir este arquivo?',
        header: 'Exclusão de Arquivos',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirArquivoAtividade,
        reject: this.reject
    });
  }

  acceptExcluirArquivoAtividade() {
    this.excluirArquivoAtividade();
  }

  renderFooterDescricaoArquivoAtividade(name) {
    return (
        <div>
            <button type="button" 
                    className="btn btn-primary bg-gradient-secondary" 
                    onClick={() => this.fecharModalCadastro(name)}>
                <i className="fas fa-times"></i> Cancelar
            </button>
            <button type="button" className="btn btn-primary bg-gradient-success"
                    onClick={this.adicionarDescricaoAtividade}>
                <i className="fas fa-check"></i> Alterar
            </button>
        </div>
    );
  }

  adicionarDescricaoAtividade = () => {
    this.arquivoAtividadeService.adicionarDescricao({
      codigo: this.state.arquivo.codigo,
      dsArquivo: this.state.dsArquivo
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Arquivos', detail:'Descrição adicionada com sucesso', life: 4000});
      this.fecharModalCadastro('modalDescricaoArquivoAtividade');
      this.listarArquivosAtividade();
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
    });
  }

  adicionarDescricaoNovaAtividade = () => {
    this.arquivoAtividadeService.adicionarDescricaoTemp({
      codigo: this.state.arquivo.codigo,
      descricao: this.state.descricao
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Arquivos', detail:'Descrição adicionada com sucesso', life: 4000});
      this.listarArquivosTemp();
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
    });

    this.fecharModalCadastro('modalDescricaoArquivoNovaAtividade');
  }

  handleUploadAtividade = async files => {
    const upLoadFiles = files.map(file => ({
      file,
      id: uniqueId(),
      name: file.name,
      readableSize: filesize(file.size),
      progress: 0,
      uploaded: false, 
      error: false,
      url: file.url
    }))

    this.setState({
      upLoadFiles: this.state.upLoadFiles.concat(upLoadFiles)
    });

    await upLoadFiles.forEach(this.processarAtividade);
  }

  processarAtividade = async (upLoadFile) => {
    const usuarioLogado = this.context.usuarioAutenticado;
    const data = new FormData();
    data.append('file',upLoadFile.file);
    data.append('atividade',upLoadFile.file, this.state.atividade.codigo); //Envia código de atividade para salvar os arquivos
    data.append('usuario',upLoadFile.file, usuarioLogado.codigo); //Envia código de atividade para salvar os arquivos
    await this.arquivoAtividadeService.incluirArquivo(data)
      .then(response => {
        this.listarArquivosAtividade();
        this.handleDeleteAtividade(upLoadFile.id);
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  handleDeleteAtividade  = async id => {
    this.setState({upLoadFiles: this.state.upLoadFiles.filter(file => file.id !== id)});
  } 

  async abrirModalArquivosAnexos(name, position){
    await this.listarArquivosAtividade()
    let state = {
      [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  //Nova Atividade
  handleUploadNovaAtividade = async files => {
    const upLoadFiles = files.map(file => ({
      file,
      id: uniqueId(),
      name: file.name,
      readableSize: filesize(file.size),
      progress: 0,
      uploaded: false, 
      error: false,
      url: file.url
    }))

    this.setState({
      upLoadFiles: this.state.upLoadFiles.concat(upLoadFiles)
    });

    await upLoadFiles.forEach(this.processarNovaAtividade);
  }

  processarNovaAtividade = async (upLoadFile) => {
    const usuarioLogado = this.context.usuarioAutenticado;
    const data = new FormData();
    data.append('file',upLoadFile.file);
    data.append('usuario',upLoadFile.file, usuarioLogado.codigo) //Envia código de usuário para guardar arquivos
    await this.arquivoAtividadeService.incluirArquivoTemp(data)
      .then(response => {
        this.listarArquivosTemp();
        this.handleDeleteNovaAtividade(upLoadFile.id);
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarArquivosTemp = async () => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.arquivoAtividadeService.listarArquivosTemp(usuarioLogado.codigo)
      .then(response => {
        this.setState({arquivosNovaAtividade: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  handleDeleteNovaAtividade  = async id => {
    this.setState({upLoadFiles: this.state.upLoadFiles.filter(file => file.id !== id)});
  } 

  acoesArquivosNovaAtividade(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-comment" className="p-button-rounded p-button-text"
                tooltip="Adicionar descrição ao arquivo"
                tooltipOptions={{position: 'top'}}
                onClick={() => this.consultarArquivoNovaAtividadeDescricao(rowData)}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-cloud-download" className="p-button-rounded p-button-text"
                tooltip="Baixar Arquivo"
                onClick={() => this.downloadTemp(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                tooltip="Excluir Arquivo"
                onClick={() => this.confirmaExclusaoArquivoNovaAtividade(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
      </React.Fragment>
    );
  }

  async downloadTemp(rowData) {
    await this.consultarArquivoTemp(rowData);
    await this.arquivoAtividadeService.downloadTemp(rowData.codigo)
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.state.arquivo.arquivo); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
  }

  consultarArquivoTemp = async (arquivo) => {
    await this.arquivoAtividadeService.consultarArquivoTemp(arquivo.codigo)
      .then(response => {
        this.setState({arquivo: response.data});
        this.setState({descricao: response.data.descricao});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      });
  }

  async consultarArquivoNovaAtividadeDescricao(arquivo){
    await this.arquivoAtividadeService.consultarArquivoTemp(arquivo.codigo)
      .then(response => {
        this.setState({arquivo: response.data});
        this.setState({descricao: response.data.descricao});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      });

      this.abrirModalDescricaoArquivo('modalDescricaoArquivoNovaAtividade');
  }

  abrirModalDescricaoArquivo(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  excluirArquivosTemp = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.arquivoAtividadeService.excluirArquivosTemp(usuarioLogado.codigo)
      .then(response => {
        console.log('Arquivos Temporários excluídos');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  excluirArquivoNovaAtividade = () => {
    this.arquivoAtividadeService.excluirArquivoTemp(this.state.arquivoCodigo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Arquivos', detail:'Arquivo excluído com sucesso', life: 4000});
        this.listarArquivosTemp();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  confirmaExclusaoArquivoNovaAtividade(arquivo) {
    this.setState({arquivoCodigo: arquivo.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir este arquivo?',
        header: 'Exclusão de Arquivos',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirArquivoNovaAtividade,
        reject: this.reject
    });
  }

  acceptExcluirArquivoNovaAtividade() {
    this.excluirArquivoNovaAtividade();
  }

  renderFooterAtividadeNovaAtividade(name) {
    return (
        <div className="left">
            <Button label="Cadastrar" 
                    className="p-button-primary p-button-text"
                    onClick={this.cadastrarAtividade}/>
            &nbsp;
            <Button label="Anexar" 
                    icon="pi pi-paperclip"
                    onClick={() => this.abrirModalAnexo('displayAnexoNovaAtividade')}
                    className="p-button-help p-button-text"/>
            &nbsp;
            <Button label="Cancelar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModalAtividade(name)}/>
        </div>
    );
  }

  //Alterar Atividade
  alterarAtividade = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;

    if(this.state.titulo == '') {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o título da Atividade', life: 4000});
      return false;
    }

    if(this.state.selectSubGrupo == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o Sub-Grupo de Trabalho', life: 4000});
      return false;
    }

    if(this.state.responsaveisLista == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'A atividade precisa de ao menos um responsável', life: 4000});
      return false;
    }

    if(this.state.dtLimite == '' && this.state.dtLimite == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe a Data Limite', life: 4000});
      return false;
    }

    let tipoTarefa = '';
    var dataFormatadaDataLimite = '';
    if(this.state.dtLimite != '' && this.state.dtLimite != null) {
      var date = this.state.dtLimite;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      if(this.state.hora != '' && this.state.hora != null) {
        var dataFormatadaDataLimite =  year+"-"+month+"-"+day+ " " + this.state.hora + ":00";
        tipoTarefa = 'A';
      } else {
        var dataFormatadaDataLimite =  year+"-"+month+"-"+day+" 00:00:00";
        tipoTarefa = this.state.tipo;
      }
    }

    var dataFormatadaDataFatal = '';
    if(this.state.dtFatal != '' && this.state.dtFatal != null) {
      var date = this.state.dtFatal;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      if(this.state.hora != null && this.state.hora != '') {
        var dataFormatadaDataFatal =  year+"-"+month+"-"+day+ " " + this.state.hora + ":00";
      } else {
        var dataFormatadaDataFatal =  year+"-"+month+"-"+day+" 00:00:00";
      }
    }

    const atividadeAlterar = {
      atividade: {
        codigo: this.state.atividade.codigo,
        titulo: this.state.titulo,
        tipo: tipoTarefa,
        descricao: this.state.descricao,
        usuario: usuarioLogado,
        processo: this.state.processo,
        dtLimite: dataFormatadaDataLimite,
        dtFatal: dataFormatadaDataFatal,
        status: this.state.optionStatus,
        subGrupo: this.state.selectSubGrupo,
        fase: this.state.faseAtividade
      },
      responsaveis: this.state.responsaveisLista,
      interessados: this.state.interessadosLista
    }

    var hora = "00:00";
    if(this.state.hora != null) {
      hora = this.state.hora;
    }

    this.setState({openSpinner: true});
    await this.atividadeService.alterarAtividade(this.state.atividade.dtLimite + " " + hora + ":00",
      this.state.atividade.status.codigo, usuarioLogado.codigo,atividadeAlterar)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Atividades', detail:'Atividade alterada com sucesso', life: 4000});
        this.fecharModalAtividade('displayAtividadeAlterar');
        this.consultarAtividades(this.state.processo.codigo);
        this.consultarGraficosAtividades();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      });

      this.setState({openSpinner: false});
  }

  consultarGraficosAtividades = async () => { 
    await this.graficoAtividadeSerice.graficoAtividadeFaseProcesso(this.state.processo.codigo)
      .then(response => {
        this.graficoAtividadeFase(response.data);
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao recarregar gráficos de fases de atividades', life: 4000});
      });

    await this.graficoAtividadeSerice.graficoAtividadeStatusProcesso(this.state.processo.codigo)
      .then(response => {
        this.ativdadesStatus(response.data);
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao recarregar gráficos de status de atividades', life: 4000});
      })
  }

  refreshPage = () => {
    window.location.reload();
  }

  async abrirModalObjetos(name, position) {
    this.setState({openSpinner: true});
    const usuarioLogado = this.context.usuarioAutenticado;
    this.listarObjetosAcao(usuarioLogado.empresa);
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState({subObjetosAcao: null});
    this.setState({selectSubObjetos: null});
    this.setState({openSpinner: false});
    this.setState(state);
  }

  graficoAtividadeFase = async (fasesProcesso) => {
      //Fases
      let fases = [];
      for(let i = 0; i < fasesProcesso.length; i++) {
        fases.push(fasesProcesso[i].fase);
      }
      //Cores
      let cores = [];
      for(let i = 0; i < fasesProcesso.length; i++) {
        cores.push(fasesProcesso[i].cor);
      }

      //Total
      let valores = [];
      for(let i = 0; i < fasesProcesso.length; i++) {
        valores.push(fasesProcesso[i].total);
      }

      await this.setState({graficoAtividadeFasesPie: {
        labels: fases,
        datasets: [
          {
            data: valores,
            label: 'Fases',
            backgroundColor: "#42A5F5",
          }
        ]
      }});
  }

  ativdadesStatus = async (atividadesStatus) => {
      let status = [];
      for(let i = 0; i < atividadesStatus.length; i++) {
        status.push(atividadesStatus[i].status);
      }

      let totais = [];
      for(let i = 0; i < atividadesStatus.length; i++) {
        totais.push(atividadesStatus[i].total);
      }

      await this.setState({graficoStatusData: {
        labels: status,
        datasets: [
          {
            data: totais,
            backgroundColor: [
              "#42A5F5",
              "#66BB6A",
              "#FFA726",
              "#BBCCCC",
              "#FF0000"
            ],
          }
        ]
      }});
  }

  getLightTheme() {
    let basicOptions = {
        maintainAspectRatio: false,
        aspectRatio: .8,
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            }
        }
    };

    let horizontalOptions = {
        indexAxis: 'y',
        maintainAspectRatio: false,
        aspectRatio: .8,
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            }
        }
    };

    let stackedOptions = {
        maintainAspectRatio: false,
        aspectRatio: .8,
        plugins: {
            tooltips: {
                mode: 'index',
                intersect: false
            },
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        },
        scales: {
            x: {
                stacked: true,
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                stacked: true,
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            }
        }
    };

    let multiAxisOptions = {
        maintainAspectRatio: false,
        aspectRatio: .8,
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                }
            },
            tooltips: {
                mode: 'index',
                intersect: true
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                type: 'linear',
                display: true,
                position: 'left',
                ticks: {
                    min: 0,
                    max: 100,
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y1: {
                type: 'linear',
                display: true,
                position: 'right',
                grid: {
                    drawOnChartArea: false,
                    color: '#ebedef'
                },
                ticks: {
                    min: 0,
                    max: 100,
                    color: '#495057'
                }
            }
        }
    };

    return {
        basicOptions,
        horizontalOptions,
        stackedOptions,
        multiAxisOptions
    }
  }

  listarBancadas = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.pessoaService.listarBancadas(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({bancadas: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarTiposProvisoesJudiciais = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.provisaoJudicialService.consultarTipos(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({tiposProvisao: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Tipos de Provisões Judiciais', detail:`${error}`, life: 4000});
      })
  }

  novaProvisaoJudicial = async () => {
    this.setState({openSpinner: true});
    await this.listarTiposProvisoesJudiciais();
    this.setState({tipoProvisao: null});
    this.setState({observacaoProvisao: ''});
    this.abrirModal('modalProvisaoJudicial');
    this.setState({openSpinner: false});
  }

  abrirModal(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  cadastrarProvisao = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;

    if(this.state.tipoProvisao == null) {
      this.toast.show({severity:'error', summary: 'Provisões Judiciais', detail:'Informe a Provisão Judicial', life: 6000});
      return;
    }

    const provisao = {
      tipo: this.state.tipoProvisao,
      processo: this.state.processo,
      observacao: this.state.observacaoProvisao
    }

    this.setState({openSpinner: true});
    await this.provisaoJudicialService.cadastrarProvisao(provisao)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Provisões Judiciais', detail:'Provisão cadastrada com sucesso', life: 6000});
        this.retornaProvisoesJudiciais(this.state.processo);
        this.fecharModal('modalProvisaoJudicial');
        this.setState({openSpinner: false});
      }).catch(error => {
        this.setState({openSpinner: false});
        this.toast.show({severity:'error', summary: 'Provisões Judiciais', detail:`${error}`, life: 4000});
      })
  }

  async consultarProvisaoJudicial(provisao) {
    this.setState({openSpinner: true});
    await this.provisaoJudicialService.consultarProvisao(provisao.codigo)
      .then(response => {
        this.listarTiposProvisoesJudiciais();
        this.setState({provisaoJudicial: response.data});
        this.setState({tipoProvisao: response.data.tipo})
        this.setState({observacaoProvisao: response.data.observacao});
        this.abrirModal('modalProvisaoJudicialAlterar');
        this.setState({openSpinner: false});
      }).catch(error => {
        this.setState({openSpinner: false});
        this.toast.show({severity:'error', summary: 'Provisões Judiciais', detail:`${error}`, life: 4000});
      })
  }

  alterarProvisaoJudicial = async () => {
    if(this.state.tipoProvisao == null) {
      this.toast.show({severity:'error', summary: 'Provisões Judiciais', detail:'Informe a Provisão Judicial', life: 6000});
      return;
    }

    this.setState({openSpinner: true});

    const provisao = {
      codigo: this.state.provisaoJudicial.codigo,
      tipo: this.state.tipoProvisao,
      processo: this.state.processo,
      observacao: this.state.observacaoProvisao
    }

    await this.provisaoJudicialService.alterarProvisao(provisao)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Provisões Judiciais', detail:'Provisão alterada com sucesso', life: 6000});
        this.retornaProvisoesJudiciais(this.state.processo);
        this.fecharModal('modalProvisaoJudicialAlterar');
        this.setState({openSpinner: false});
      }).catch(error => {
        this.setState({openSpinner: false});
        this.toast.show({severity:'error', summary: 'Provisões Judiciais', detail:`${error}`, life: 4000});
      })
  }


  confirmaExclusaoProvisaoJudicial(provisao) {
    this.setState({codigoProvisao: provisao.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir a Provisão Judicial?',
        header: 'Exclusão de Provisão Judicial',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirProvisao,
        reject: this.reject
    });
  }

  acceptExcluirProvisao() {
    this.excluirProvisaoJudicial();
  }

  excluirProvisaoJudicial = async () => {
    this.setState({openSpinner: true});
    await this.provisaoJudicialService.excluirProvisao(this.state.codigoProvisao)
      .then(response => {
        this.retornaProvisoesJudiciais(this.state.processo);
        this.toast.show({severity:'success', summary: 'Provisões Judiciais', detail:'Provisão Judicial excluída com sucesso', life: 5000});
        this.setState({openSpinner: false});
      }).catch(error => {
        this.setState({openSpinner: false});
        this.toast.show({severity:'error', summary: 'Provisões Judiciais', detail:`${error}`, life: 5000});
      });
  }

  render() {
    const { basicOptions, horizontalOptions, multiAxisOptions, stackedOptions } = this.options;
    const usuarioLogado = this.context.usuarioAutenticado;
    const usuarioPerfil = usuarioLogado.perfil.codigo;
    var adm = 'none';
    if(usuarioPerfil == 1) {
      adm = 'hide';
    }

    var exibieDataHistorico = 'none';
    if(usuarioLogado.empresa.codigo == 138) {
      exibieDataHistorico = 'block'
    } else {
      exibieDataHistorico = 'none'
    }

    var tituloPredefinidoSim = 'none';
    var tituloNaoPredefinido = 'block';
    if(usuarioLogado.empresa.tituloPredefinido == 'S') {
     tituloPredefinidoSim = 'block';
     tituloNaoPredefinido = 'none';
    } else {
     tituloPredefinidoSim = 'none';
     tituloNaoPredefinido = 'block';
    }

    var bloqueiaTitulo = '';
    if(usuarioLogado.empresa.codigo == 138) {
      bloqueiaTitulo = 'false';
    }

    var camposFama = "";
    var camposOutros = "";

    if(usuarioLogado.empresa.codigo == 142) {
      camposFama = 'hide';
      camposOutros = 'none';
    } else {
      camposFama = 'none';
      camposOutros = 'hide';
    }

    const { upLoadFiles } = this.state;
    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={this.state.openSpinner}>
          <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
        </Backdrop>
        {/**Incluir Liminar */}
        <Dialog header="Cadastrar Liminar"
                visible={this.state.modalLiminar} 
                style={{ width: '40vw' }} 
                footer={this.renderFooterCadastroLiminar('modalLiminar')} 
                onHide={() => this.fecharModalCadastro('modalLiminar')}>

          <div className="row">
            <div className="col-sm-12">
              <div className="form-group">
                <label>Tipo de Decisão</label>
                <Dropdown value={this.state.liminarDecisao} 
                          options={this.tipoDecisao} style={{width: '100%', height: '32px'}}
                          optionLabel="nome" 
                          emptyMessage=" "
                          onChange={(e) => this.setState({liminarDecisao: e.value})} 
                          id="liminarDecisao"
                          className="p-inputtext-sm p-d-block p-mb-1"/>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6">
              <div className="form-group">
                <label>Data Liminar</label>
                <Calendar id="idDecisaoDtFatal" 
                          value={this.state.liminarDtFatal} 
                          onChange={(e) => this.setState({ liminarDtFatal: e.value })} 
                          locale="es"
                          style={{width: '100%', height: '32px'}} 
                          dateFormat="dd/mm/yy"
                          mask="99/99/9999"/>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="form-group">
              <label>Valor</label>
              <InputNumber inputId="valorLiminar" 
                           value={this.state.liminarMultaDiaria} 
                           style={{width: '100%', height: '32px'}} 
                           onChange={(e) => this.setState({liminarMultaDiaria: e.value})} 
                           mode="decimal" locale="de-BR" minFractionDigits={2}/>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="form-group">
                <label>Observação</label>
                <InputTextarea id="observacaoLiminar" 
                              type="text" 
                              style={{width: '100%'}} 
                              value={this.state.observacaoLiminar}
                              onChange={e => this.setState({observacaoLiminar: e.target.value})}
                              className="p-inputtext-sm p-d-block p-mb-1"
                              rows={6} cols={60}/>
              </div>
            </div>
          </div>
        </Dialog>        
        {/**Alterar Liminar */}
        <Dialog header="Alterar Liminar"
                visible={this.state.modalAlterarLiminar} 
                style={{ width: '40vw' }} 
                footer={this.renderFooterAlterarLiminar('modalAlterarLiminar')} 
                onHide={() => this.fecharModalCadastro('modalAlterarLiminar')}>

          <div className="row">
            <div className="col-sm-12">
              <div className="form-group">
                <label>Tipo de Decisão</label>
                <Dropdown value={this.state.liminarDecisao} 
                          options={this.tipoDecisao} style={{width: '100%', height: '32px'}}
                          optionLabel="nome" 
                          emptyMessage=" "
                          onChange={(e) => this.setState({liminarDecisao: e.value})} 
                          id="liminarDecisao"
                          className="p-inputtext-sm p-d-block p-mb-1"/>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6">
              <div className="form-group">
                <label>Data Liminar</label>
                <Calendar id="idLiminarDtFatal" 
                          value={this.state.liminarDtFatal} 
                          onChange={(e) => this.setState({ liminarDtFatal: e.value })} 
                          locale="es"
                          style={{width: '100%', height: '32px'}} 
                          dateFormat="dd/mm/yy"
                          mask="99/99/9999"/>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="form-group">
              <label>Valor</label>
              <InputNumber inputId="valorLiminar" 
                           value={this.state.liminarMultaDiaria} 
                           style={{width: '100%', height: '32px'}} 
                           onChange={(e) => this.setState({liminarMultaDiaria: e.value})} 
                           mode="decimal" locale="de-BR" minFractionDigits={2}/>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="form-group">
                <label>Observação</label>
                <InputTextarea id="observacaoLiminarAlterar" 
                              type="text" 
                              style={{width: '100%'}} 
                              value={this.state.observacaoLiminar}
                              onChange={e => this.setState({observacaoLiminar: e.target.value})}
                              className="p-inputtext-sm p-d-block p-mb-1"
                              rows={6} cols={60}/>
              </div>
            </div>
          </div>
        </Dialog>
        {/**Incluir Decisão */}
        <Dialog header="Cadastrar Decisão"
                visible={this.state.modalDecisao} 
                style={{ width: '40vw' }} 
                footer={this.renderFooterCadastroDecisao('modalDecisao')} 
                onHide={() => this.fecharModalCadastro('modalDecisao')}>

          <div className="row">
            <div className="col-sm-12">
              <div className="form-group">
                <label>Tipo de Decisão</label>
                <Dropdown value={this.state.decisaoDecisao} 
                          options={this.tipoDecisao} style={{width: '100%', height: '32px'}}
                          optionLabel="nome" 
                          emptyMessage=" "
                          onChange={(e) => this.setState({decisaoDecisao: e.value})} 
                          id="decisaoSetorInterno"
                          className="p-inputtext-sm p-d-block p-mb-1"/>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6">
              <div className="form-group">
                <label>Data Decisao</label>
                <Calendar id="idDecisaoDtFatal" 
                          value={this.state.decisaoDtFatal} 
                          onChange={(e) => this.setState({ decisaoDtFatal: e.value })} 
                          locale="es"
                          style={{width: '100%', height: '32px'}} 
                          dateFormat="dd/mm/yy"
                          mask="99/99/9999"/>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="form-group">
              <label>Valor da Condenação</label>
              <InputNumber inputId="valorCondenaao" 
                           value={this.state.multaDiaria} 
                           style={{width: '100%', height: '32px'}} 
                           onChange={(e) => this.setState({multaDiaria: e.value})} 
                           mode="decimal" locale="de-BR" minFractionDigits={2}/>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="form-group">
                <label>Observação</label>
                <InputTextarea id="observacaoDecisao" 
                              type="text" 
                              style={{width: '100%'}} 
                              value={this.state.observacaoDecisao}
                              onChange={e => this.setState({observacaoDecisao: e.target.value})}
                              className="p-inputtext-sm p-d-block p-mb-1"
                              rows={6} cols={60}/>
              </div>
            </div>
          </div>
        </Dialog>
        {/**Alterar Decisão */}
        <Dialog header="Alterar Decisão"
                visible={this.state.modalAlterarDecisao} 
                style={{ width: '40vw' }} 
                footer={this.renderFooterAlterarDecisao('modalAlterarDecisao')} 
                onHide={() => this.fecharModalCadastro('modalAlterarDecisao')}>

          <div className="row">
            <div className="col-sm-12">
              <div className="form-group">
                <label>Tipo de Decisão</label>
                <Dropdown value={this.state.decisaoDecisao} 
                          options={this.tipoDecisao} style={{width: '100%', height: '32px'}}
                          optionLabel="nome" 
                          emptyMessage=" "
                          onChange={(e) => this.setState({decisaoDecisao: e.value})} 
                          id="decisaoSetorInterno"
                          className="p-inputtext-sm p-d-block p-mb-1"/>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6">
              <div className="form-group">
                <label>Data Decisao</label>
                <Calendar id="idDecisaoDtFatal" 
                          value={this.state.decisaoDtFatal} 
                          onChange={(e) => this.setState({ decisaoDtFatal: e.value })} 
                          locale="es"
                          style={{width: '100%', height: '32px'}} 
                          dateFormat="dd/mm/yy"
                          mask="99/99/9999"/>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="form-group">
              <label>Valor da Condenação</label>
              <InputNumber inputId="valorCondenaao" 
                           value={this.state.decisaoMultaDiaria} 
                           style={{width: '100%', height: '32px'}} 
                           onChange={(e) => this.setState({decisaoMultaDiaria: e.value})} 
                           mode="decimal" locale="de-BR" minFractionDigits={2}/>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="form-group">
                <label>Observação</label>
                <InputTextarea id="observacaoDecisao" 
                              type="text" 
                              style={{width: '100%'}} 
                              value={this.state.observacaoDecisao}
                              onChange={e => this.setState({observacaoDecisao: e.target.value})}
                              className="p-inputtext-sm p-d-block p-mb-1"
                              rows={6} cols={60}/>
              </div>
            </div>
          </div>
        </Dialog>
        {/**Incluir Custas Processuais */}
        <Dialog header="Incluir Custas"
                visible={this.state.modalCustas} 
                style={{ width: '40vw' }} 
                footer={this.renderFooterCadastroCustas('modalCustas')} 
                onHide={() => this.fecharModalCadastro('modalCustas')}>

          <div className="row">
            <div className="col-sm-12">
              <div className="form-group">
                <label htmlFor="tipoCusta">Tipo de Custa</label>
                <Dropdown value={this.state.tipoCusta} 
                          options={this.state.tiposCustas} style={{width: '100%', height: '32px'}}
                          optionLabel="nome" 
                          emptyMessage=" "
                          filter showClear filterBy="nome"
                          onChange={this.onChangeTipoCustas}
                          id="tipoCusta"
                          className="p-inputtext-sm p-d-block p-mb-1"/>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="form-group">
                <label>Débito/Cédito</label>
                <Dropdown value={this.state.tipo} 
                          options={this.tiposPagamentosCustas} style={{width: '100%', height: '32px'}}
                          optionLabel="nome" 
                          emptyMessage=" "
                          onChange={(e) => this.setState({tipo: e.value})} 
                          id="tipoCusta"
                          className="p-inputtext-sm p-d-block p-mb-1"/>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6">
              <div className="form-group">
              <label>Valor Custas</label>
              <InputNumber inputId="locale-german" 
                            value={this.state.vlCustas} 
                            style={{width: '100%', height: '32px'}} 
                            onChange={(e) => this.setState({vlCustas: e.value})} 
                            mode="decimal" locale="de-BR" minFractionDigits={2}/>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="form-group">
                <label>Dt. Pagamento</label>
                <Calendar id="maskCusta" 
                          value={this.state.dtPagamento} 
                          onChange={(e) => this.setState({ dtPagamento: e.value })} 
                          locale="es"
                          style={{width: '100%', height: '32px'}} 
                          dateFormat="dd/mm/yy"
                          mask="99/99/9999"/>
              </div>
            </div>
          </div>
        </Dialog>
        <ConfirmDialog visible={this.state.visibleCusas} 
                       onHide={() => this.setState({ visibleCusas: false })} 
                       message="Are you sure you want to proceed?"
                       header="Confirmation"
                       icon="pi pi-exclamation-triangle" 
                       accept={() => this.excluirCusta} 
                       reject={() => this.setState({visible: false})}/>

        {/**Incluir Garantias do Processo */}
        <Dialog header="Incluir Garantias"
                visible={this.state.modalGarantias} 
                style={{ width: '40vw' }} 
                footer={this.renderFooterCadastroGarantias('modalGarantias')} 
                onHide={() => this.fecharModalCadastro('modalGarantias')}>

          <div className="row">
            <div className="col-sm-12">
              <div className="form-group">
                <label htmlFor="tipoCusta">Tipo de Garantia</label>
                <Dropdown value={this.state.tipoGarantia} 
                          options={this.state.tiposGarantias} style={{width: '100%', height: '32px'}}
                          optionLabel="nome" 
                          emptyMessage=" "
                          filter showClear filterBy="nome"
                          onChange={this.onChangeTipoGarantia}
                          id="tipoCusta"
                          className="p-inputtext-sm p-d-block p-mb-1"/>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6">
              <div className="form-group">
              <label>Valor Penhora</label>
              <InputNumber inputId="locale-german" 
                            value={this.state.vlPenhora} 
                            style={{width: '100%', height: '32px'}} 
                            onChange={(e) => this.setState({vlPenhora: e.value})} 
                            mode="decimal" locale="de-BR" minFractionDigits={2}/>
              </div>
            </div>
          </div>
        </Dialog>
        <div className="content-wrapper">
          <div className="container-fluid">
            <section className="content-header">
              <div className="card card-primary card-outline">
                <div className="card-header">
                  <h3 className="card-title">
                    <i className="fas fa-users"></i>
                    <span> Ficha do Processo - Código[ {this.state.codigo} ]</span>
                  </h3>
                  <div style={{textAlign: 'right'}}>
                    <Button icon="pi pi-heart"
                                  className={this.state.iconeImportanteParaMim} 
                                  onClick={this.iincluirProcessoImportancia}
                                  tooltip={this.state.iconeImportanteParaMimTitle} 
                                  tooltipOptions={{ className: 'blue-tooltip', position: 'top' }} 
                                  />
                    &nbsp;&nbsp;&nbsp;
                    <Button icon="pi pi-star" 
                            onClick={this.incluirProcessoImportanteParaEmpresa}
                            className={this.state.iconeImportanteParaEmpresa}
                            tooltip={this.state.iconeImportanteParaEmpresaTitle}
                            tooltipOptions={{ className: 'blue-tooltip', position: 'top' }} 
                             />
                    &nbsp;&nbsp;&nbsp;
                    <Button icon="pi pi-info" 
                            onClick={this.incluirProcessoEstrategico}
                            className={this.state.iconeEstrategico}
                            tooltip={this.state.iconeEstrátegicoTitle}
                            tooltipOptions={{ className: 'blue-tooltip', position: 'top' }} 
                             />
                    &nbsp;&nbsp;&nbsp;
                    <Button className="p-button-secondary p-button-text" 
                            icon="pi pi-arrow-left"
                            title="Voltar"
                            onClick={this.voltar}
                            />
                  </div>  
                </div>

                <TabView className="tabview-custom">
                 <TabPanel header="Processo">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-sm-8">
                          <div className="form-group">
                            <h6><label>
                                  Partes
                                  &nbsp;
                                  &nbsp;
                                  <a  
                                      className="cursor" 
                                      target="_blank"
                                      title="Incluir nova Parte"
                                      onClick={this.exibirNovaParte}>({this.state.iconeExibirNovaParte})</a>
                                </label>
                            </h6>
                            <div style={{display: `${this.state.exibirNovaParte}`}}>
                              <div className="row">
                                <div className="col-sm-12">
                                  <div className="form-group">
                                    <AutoComplete value={this.state.selectParte}
                                                  suggestions={this.state.filterPessoas} 
                                                  completeMethod={this.consultarPessoa}
                                                  style={{width: '152%'}}
                                                  field="nome" multiple onChange={(e) => this.setState({selectParte: e.value })} 
                                                  className="p-autoComplete-sm p-d-block p-mb-0"/>
                                  <a className="linkCadastroNovoCliente" onClick={() => this.novoAutor()}>Cadastrar novo cliente
                                  </a>
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm-12">
                                  <div className="form-group">
                                    <label>Tipo<span className="obrigatorioAsterisco"> *</span></label>
                                    <Dropdown value={this.state.tipoParte} 
                                              options={this.tipoPartes} style={{width: '100%', height: '32px'}}
                                              optionLabel="nome" 
                                              filter showClear filterBy="nome"
                                              onChange={this.incluirParte} 
                                              id="tipoParte"
                                              className="p-inputtext-sm p-d-block p-mb-1"/>
                                  </div>
                                </div>
                              </div> 
                            </div>
                            <DataTable value={this.state.partesProcesso} 
                                       emptyMessage=" "
                                       size="small"
                                       showGridlines>
                              <Column field="pessoa.nome" header="Nome"></Column>
                              <Column field="nomeTipo" header="Parte"></Column>
                              <Column body={this.acoesPartes} 
                                      exportable={false} 
                                      style={{ minWidth: '4rem', textAlign: 'center' }}></Column>
                            </DataTable>
                          </div>
                        </div>
                      </div>
                      <br/>
                      <div className="row">
                        <div className="col-sm-2">
                          <div className="form-group">
                            <label>Dt. Cadastro</label>
                            <label value={this.state.dataCadastro}></label>
                            <Calendar id="mask2"
                                      value={this.state.dataCadastro}
                                      style={{width: '100%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      disabled="true"
                                      mask="99/99/9999"/>
                          </div>
                        </div>
                        <div className="col-sm-2">
                          <div className="form-group">
                            <label>Ult. Mov.</label>
                            <Calendar id="mask2"
                                      value={new Date(this.state.dataUltimaMovimentacao)}
                                      style={{width: '100%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      disabled="true"
                                      mask="99/99/9999"/>
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Responsável</label>
                            <Dropdown value={this.state.responsavel}
                                      options={this.state.usuarios} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      filter showClear filterBy="nome"
                                      onChange={e => this.setState({responsavel: e.target.value})}
                                      id="uf"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-8">
                          <div className="form-group">
                            <hr></hr>
                          </div>
                        </div>
                      </div>
                      <br></br>
                        <div className="row" style={{display: `${camposOutros}`}}>
                          <div className="col-sm-8">
                            <div className="form-group">
                              <label htmlFor="push">
                                <Checkbox inputId="push" 
                                          name="push" 
                                          value="push" 
                                          onChange={this.onCityChange} 
                                          checked={this.state.push.indexOf('push') !== -1} />
                                &nbsp;
                                Processo no Push
                                &nbsp;
                                <Checkbox inputId="email" 
                                          name="email" 
                                          value="email" 
                                          onChange={this.onCityChange} 
                                          checked={this.state.push.indexOf('email') !== -1} />
                                &nbsp;
                                Receber push por email
                                &nbsp;
                                <Checkbox inputId="historico" 
                                          name="historico" 
                                          value="historico" 
                                          onChange={this.onCityChange} 
                                          checked={this.state.push.indexOf('historico') !== -1} />
                                &nbsp;
                                Incluir no Histórico
                              </label>
                            </div>
                          </div>
                        </div>
                        
                        <br></br>

                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Bancada de Advogados</label>
                              <Dropdown value={this.state.bancada} 
                                        options={this.state.bancadas} style={{width: '100%', height: '32px'}}
                                        optionLabel="nome" 
                                        filter showClear filterBy="nome"
                                        onChange={e => this.setState({bancada: e.target.value})}
                                        id="bancada"
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>

                          <div className="col-sm-2">
                            <div className="form-group">
                              <label>UF</label>
                              <Dropdown value={this.state.uf} 
                                        options={this.estados} style={{width: '100%', height: '32px'}}
                                        optionLabel="nome" 
                                        filter showClear filterBy="nome"
                                        onChange={e => this.setState({uf: e.target.value})}
                                        id="uf"
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>

                        </div>
                        <div className="row" style={{display: `${camposOutros}`}}>
                          <div className="col-sm-8">
                            <div className="form-group">
                              <label>Pasta</label>
                              <InputText id="pasta" 
                                          type="text" 
                                          style={{width: '100%', height: '32px'}} 
                                          value={this.state.pasta}
                                          onChange={e => this.setState({pasta: e.target.value})}
                                          className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                        </div>


                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Processo Judicial</label>
                              <InputMask id="numeroCnj" 
                                          type="text" 
                                          mask="9999999-99.9999.9.99.9999"
                                          style={{width: '100%', height: '32px'}} 
                                          value={this.state.nrCnj}
                                          onChange={e => this.setState({nrCnj: e.target.value})}
                                          className="p-inputtext-sm p-d-block p-mb-1"/>
                              <br></br>
                              <br></br>
                              <div>
                                <strong style={{display: `${this.state.exibeLInkProcessoPrincipal}`}}>Processo Principal:&nbsp;&nbsp;
                                <a href={this.state.paramProcessoPrincipal} 
                                  className="cursor" 
                                  target="_blank"
                                  onClick={this.consultarProcessoPrincipal}>{this.state.linkProcessoPrincipal}</a></strong>
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Processo Administrativo</label>
                              <InputText id="numeroProcesso" 
                                          type="text" 
                                          style={{width: '100%', height: '32px'}} 
                                          value={this.state.nrProcesso}
                                          onChange={e => this.setState({nrProcesso: e.target.value})}
                                          className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                        </div>
                        <div style={{display: `${this.state.exibirAgravoApenso}`}}>
                          <div className="row">
                            <div className="col-sm-4">
                              <div className="form-group">
                                <label>Câmara</label>
                                <InputText id="camaraConsulta" 
                                          type="text" 
                                          style={{width: '100%', height: '32px'}} 
                                          value={this.state.camaraConsulta}
                                          onChange={e => this.setState({camaraConsulta: e.target.value})}
                                          className="p-inputtext-sm p-d-block p-mb-1"/>
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div className="form-group">
                                <label>Relator</label>
                                <InputText id="relatorConsulta" 
                                          type="text" 
                                          style={{width: '100%', height: '32px'}} 
                                          value={this.state.relatorConsulta}
                                          onChange={e => this.setState({relatorConsulta: e.target.value})}
                                          className="p-inputtext-sm p-d-block p-mb-1"/>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Grupo de Trabalho
                                <span className="obrigatorioAsterisco"> * </span>
                                <span style={{display: `${adm}`}}>
                                  <Button icon="pi pi-plus-circle" className="p-button-rounded p-button-text"
                                          tooltip="Clique para adicionar um novo Grupo de Trabalho" 
                                          tooltipOptions={{position: 'top'}}
                                          style={{width: '20px', height: '10px'}}/>
                                </span>
                              </label>
                              <Dropdown value={this.state.grupoTrabalho} 
                                        options={this.state.gruposTrabalho} style={{width: '100%', height: '32px'}}
                                        optionLabel="nome" 
                                        filter showClear filterBy="nome"
                                        onChange={this.onChangeGrupoTrabalho}
                                        id="grupoTrabalho"
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Status Processual
                                <span className="obrigatorioAsterisco"> * </span>
                                <span style={{display: `${adm}`}}>
                                  <Button icon="pi pi-plus-circle" className="p-button-rounded p-button-text"
                                          tooltip="Clique para adicionar um Novo Status Processual" 
                                          tooltipOptions={{position: 'top'}}
                                          style={{width: '20px', height: '10px'}}/>
                                </span>
                              </label>
                              <Dropdown value={this.state.statusProcessual} 
                                        options={this.state.statusProcessuais} style={{width: '100%', height: '32px'}}
                                        optionLabel="descricao" 
                                        filter showClear filterBy="descricao"
                                        onChange={this.onChangeStatusProcessual}
                                        id="statusProcessual"
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                        </div>
                        <div style={{display: `${this.state.exibeDatasStatusProcessual}`}}>
                          <div className="row">
                           <div className="col-sm-2">
                              <div className="form-group">
                                <label>Dt. Arquivamento</label>
                                <Calendar id="dataArquivamento"
                                          value={this.state.dataArquivamento} 
                                          onChange={(e) => this.setState({ dataArquivamento: e.value })} 
                                          locale="es"
                                          style={{width: '100%', height: '32px'}} 
                                          dateFormat="dd/mm/yy"
                                          mask="99/99/9999"/>
                              </div>
                            </div>
                            <div className="col-sm-2">
                              <div className="form-group">
                                <label>Dt. Arquivamento Tribunal</label>
                                <Calendar id="dataArquivamentotj"
                                          value={this.state.dataArquivamentoTj} 
                                          onChange={(e) => this.setState({ dataArquivamentoTj: e.value })} 
                                          locale="es"
                                          style={{width: '100%', height: '32px'}} 
                                          dateFormat="dd/mm/yy"
                                          mask="99/99/9999"/>
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div className="form-group">
                                <label>Resultado do Arquivamento</label>
                                <Dropdown value={this.state.resultadoArquivamento} 
                                          options={this.resultadoArquivamento} style={{width: '100%', height: '32px'}}
                                          optionLabel="nome" 
                                          filter showClear filterBy="nome"
                                          onChange={(e) => this.setState({ resultadoArquivamento: e.value })} 
                                          id="resultadoArquivamento"
                                          className="p-inputtext-sm p-d-block p-mb-1"/>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Área de Atuação
                                <span className="obrigatorioAsterisco"> * </span>
                                <span style={{display: `${adm}`}}> 
                                  <Button icon="pi pi-plus-circle" className="p-button-rounded p-button-text"
                                          tooltip="Clique para adicionar uma nova Área de Atuação" 
                                          tooltipOptions={{position: 'top'}}
                                          style={{width: '20px', height: '10px'}}/>
                                </span>
                              </label>
                              <Dropdown value={this.state.areaAtuacao} 
                                        options={this.state.areasAtuacao} style={{width: '100%', height: '32px'}}
                                        optionLabel="nome" 
                                        filter showClear filterBy="nome"
                                        onChange={this.onChangeAreaAtuacao}
                                        id="areaAtuacao"
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Tipo de Ação
                                <span className="obrigatorioAsterisco"> * </span>
                                <span style={{display: `${adm}`}}>
                                  <Button icon="pi pi-plus-circle" className="p-button-rounded p-button-text"
                                          tooltip="Clique para adicionar um Novo Tipo de Ação" 
                                          tooltipOptions={{position: 'top'}}
                                          style={{width: '20px', height: '10px'}}/>
                                </span>
                              </label>
                              <Dropdown value={this.state.tipoAcao} 
                                        options={this.state.tiposAcao} style={{width: '100%', height: '32px'}}
                                        optionLabel="nome" 
                                        filter showClear filterBy="nome"
                                        onChange={this.onChangeTipoAcao}
                                        id="tipoAcao"
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-8">
                            <div className="form-group">
                              <label>Comarca
                                <span className="obrigatorioAsterisco"> * </span>
                              </label>
                              <InputText id="comarca" 
                                        type="text" 
                                        style={{width: '100%', height: '32px'}} 
                                        value={this.state.dsComarca}
                                        onChange={e => this.setState({dsComarca: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Juízo
                              </label>
                              <InputText id="orgaoColegiado" 
                                        type="text" 
                                        style={{width: '100%', height: '32px'}} 
                                        value={this.state.orgaoColegiado}
                                        onChange={e => this.setState({orgaoColegiado: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                          <div className="col-sm-4" style={{display: `${camposOutros}`}}>
                            <div className="form-group">
                              <label>Relator
                              </label>
                              <InputText id="relatorProcesso" 
                                        type="text" 
                                        style={{width: '100%', height: '32px'}} 
                                        value={this.state.relatorProcesso}
                                        onChange={e => this.setState({relatorProcesso: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                        </div>
                        <div style={{display: `${this.state.exibirAgravoApensoNegacao}`}}>
                          <div className="row">
                            <div className="col-sm-3">
                              <div className="form-group">
                                <label>Data de Distribuição</label>
                                <Calendar id="mask2"
                                          value={this.state.dataDistribuicao} 
                                          onChange={(e) => this.setState({ dataDistribuicao: e.value })} 
                                          locale="es"
                                          style={{width: '100%', height: '32px'}} 
                                          dateFormat="dd/mm/yy"
                                          mask="99/99/9999"/>
                              </div>
                            </div>
                            <div className="col-sm-3" style={{display: `${camposOutros}`}}>
                              <div className="form-group">
                                <label>Data da Setença</label>
                                <Calendar id="mask" 
                                          value={this.state.dataSentenca} 
                                          onChange={(e) => this.setState({ dataSentenca: e.value })} 
                                          locale="es"
                                          style={{width: '100%', height: '32px'}} 
                                          dateFormat="dd/mm/yy"
                                          mask="99/99/9999"/>
                              </div>
                            </div>
                            <div className="col-sm-2" style={{display: `${camposOutros}`}}>
                              <div className="form-group">
                                <label>Data Ultima Decisão</label>
                                <Calendar id="mask" 
                                          value={this.state.dataUltimaDecisao} 
                                          onChange={(e) => this.setState({ dataUltimaDecisao: e.value })} 
                                          locale="es"
                                          style={{width: '100%', height: '32px'}} 
                                          dateFormat="dd/mm/yy"
                                          mask="99/99/9999"/>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div style={{display: `${this.state.exibirAgravoApensoNegacao}`}}>
                          <div className="row">
                            <div className="col-sm-4" style={{display: `${camposOutros}`}}>
                              <div className="form-group">
                                <label>Fase</label>
                                <Dropdown value={this.state.fase} 
                                          options={this.state.fases} style={{width: '100%', height: '32px'}}
                                          optionLabel="nome" 
                                          filter showClear filterBy="nome"
                                          onChange={(e) => this.setState({ fase: e.value })} 
                                          id="fase"
                                          className="p-inputtext-sm p-d-block p-mb-1"/>
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div className="form-group">
                                <label>Rito</label>
                                <Dropdown value={this.state.rito} 
                                          options={this.state.ritos} style={{width: '100%', height: '32px'}}
                                          optionLabel="nome" 
                                          filter showClear filterBy="nome"
                                          onChange={(e) => this.setState({ rito: e.value })} 
                                          id="fase"
                                          className="p-inputtext-sm p-d-block p-mb-1"/>
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div className="form-group">
                                <label>Contingência Contábil</label>
                                <Dropdown value={this.state.contingenciaContabil} 
                                          options={this.contingenciaContabil} style={{width: '100%', height: '32px'}}
                                          optionLabel="nome" 
                                          filter showClear filterBy="nome"
                                          onChange={(e) => this.setState({contingenciaContabil: e.value})} 
                                          id="grupoTrabalho"
                                          className="p-inputtext-sm p-d-block p-mb-1"/>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row" style={{display: `${camposOutros}`}}>
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Tipo de Decisão
                                <span>
                                  <Button icon="pi pi-plus-circle" className="p-button-rounded p-button-text"
                                          tooltip="Clique para adicionar um novo Tipo de Decisão" 
                                          tooltipOptions={{position: 'top'}}
                                          style={{width: '20px', height: '10px'}}/>
                                </span>
                              </label>
                              <Dropdown value={this.state.tipoDecisao} 
                                options={this.state.tiposDecisao} style={{width: '100%', height: '32px'}}
                                optionLabel="nome" 
                                filter showClear filterBy="nome"
                                onChange={this.onTipoDecisaoChange}
                                id="grupoTrabalho"
                                className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Risco</label>
                              <Dropdown value={this.state.risco} 
                                        options={this.riscos} style={{width: '100%', height: '32px'}}
                                        optionLabel="nome" 
                                        filter showClear filterBy="nome"
                                        onChange={(e) => this.setState({risco: e.value})} 
                                        id="risco"
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-2">
                            <div className="form-group">
                              <label>Vl. Provável</label>
                              <InputNumber inputId="vlProvavel" 
                                          value={this.state.vlProvavel} 
                                          style={{width: '100%', height: '32px'}} 
                                          onChange={(e) => this.setState({vlProvavel: e.value})} 
                                          mode="decimal" locale="de-BR" minFractionDigits={2}/>
                            </div>
                          </div>
                          <div className="col-sm-2">
                            <div className="form-group">
                              <label>Vl. Possível</label>
                              <InputNumber inputId="vlPossivel" 
                                          value={this.state.vlPossivel} 
                                          style={{width: '100%', height: '32px'}} 
                                          onChange={(e) => this.setState({vlPossivel: e.value})} 
                                          mode="decimal" locale="de-BR" minFractionDigits={2}/>
                            </div>
                          </div>
                          <div className="col-sm-2">
                            <div className="form-group">
                              <label>Vl. Remoto</label>
                              <InputNumber inputId="vlRemoto" 
                                          value={this.state.vlRemoto} 
                                          style={{width: '100%', height: '32px'}} 
                                          onChange={(e) => this.setState({vlRemoto: e.value})} 
                                          mode="decimal" locale="de-BR" minFractionDigits={2}/>
                            </div>
                          </div>
                          <div className="col-sm-2">
                            <div className="form-group">
                              <label>Vl. Causa</label>
                              <InputNumber inputId="vlCausa" 
                                          value={this.state.vlCausa} 
                                          style={{width: '100%', height: '32px'}} 
                                          onChange={(e) => this.setState({vlCausa: e.value})} 
                                          mode="decimal" locale="de-BR" minFractionDigits={2}/>
                            </div>
                          </div>
                        </div>
                        <div style={{display: `${this.state.exibirAgravoApensoNegacao}`}}>
                          <div className="row">
                            <div className="col-sm-8">
                              <div className="form-group">
                                <Accordion multiple>
                                  <AccordionTab header="Liminares">
                                    <DataTable value={this.state.liminares} emptyMessage=" ">
                                      <Column field="decisao" header="Decisão"></Column>
                                      <Column field="dtFatalFormat" header="Data Liminar"></Column>
                                      <Column field="multaDiariaFormat" header="Valor"></Column>
                                      <Column field="dtRegistro" header="Data Registro"></Column>
                                      <Column field="observacao" header="Observação"></Column>
                                      <Column body={this.acoesLiminares} exportable={false} style={{ minWidth: '8rem' }}header={
                                        <Button icon="pi pi-plus" className="p-button-rounded p-button-text"
                                        tooltip="Clique para adicionar uma nova liminar" 
                                        tooltipOptions={{position: 'top'}}
                                        style={{width: '20px', height: '20px'}}
                                        data-toggle="modal" 
                                        onClick={() => this.abrirModalLiminar('modalLiminar')}
                                        data-target="#modal-default"/>
                                      }></Column>
                                    </DataTable>
                                  </AccordionTab>
                                  <AccordionTab header="Registro de Provisões Judiciais - Prováveis">
                                    <DataTable value={this.state.provisoesJudiciais} emptyMessage=" ">
                                      <Column field="tipo.nome" header="Provisão Judicial"></Column>
                                      <Column field="observacao" header="Observação"></Column>
                                      <Column body={this.acoesProvisoes} exportable={false} style={{ minWidth: '8rem' }}header={
                                        <Button icon="pi pi-plus" className="p-button-rounded p-button-text"
                                        tooltip="Clique para adicionar uma nova provisão judicial" 
                                        tooltipOptions={{position: 'top'}}
                                        style={{width: '20px', height: '20px'}}
                                        data-toggle="modal" 
                                        onClick={this.novaProvisaoJudicial}
                                        data-target="#modal-default"/>
                                      }></Column>
                                    </DataTable>
                                  </AccordionTab>
                                  <AccordionTab header="Decisões">
                                    <DataTable value={this.state.decisoes} emptyMessage=" ">
                                      <Column field="decisao" header="Tipo de Decisão"></Column>
                                      <Column field="dtFatalFormat" header="Data Decisão"></Column>
                                      <Column field="multaDiariaFormat" header="Valor da Condenação"></Column>
                                      <Column field="dtRegistro" header="Data Registro"></Column>
                                      <Column field="observacao" header="Observação"></Column>
                                      <Column body={this.acoesDecisoes} exportable={false} style={{ minWidth: '8rem' }}header={
                                        <Button icon="pi pi-plus" className="p-button-rounded p-button-text"
                                        tooltip="Clique para adicionar uma nova liminar" 
                                        tooltipOptions={{position: 'top'}}
                                        style={{width: '20px', height: '20px'}}
                                        data-toggle="modal" 
                                        onClick={() => this.abrirModalDecisao('modalDecisao')}
                                        data-target="#modal-default"/>
                                      }></Column>
                                    </DataTable>
                                  </AccordionTab>
                                  <AccordionTab header="Pedidos">
                                    <DataTable value={this.state.pedidosProcesso} emptyMessage=" ">
                                      <Column field="pedido.nome" header="Pedido"></Column>
                                      <Column field="vlRemoto" header="Valor"></Column>
                                      <Column field="observacao" header="Observação"></Column>
                                      <Column body={this.acoesPedidos} exportable={false} style={{ minWidth: '8rem' }}header={
                                        <Button icon="pi pi-plus" className="p-button-rounded p-button-text"
                                        tooltip="Clique para adicionar um novo Pagamento" 
                                        tooltipOptions={{position: 'top'}}
                                        style={{width: '20px', height: '20px'}}
                                        data-toggle="modal" 
                                        onClick={() => this.abrirModalPedidos('modalPedidos')}
                                        data-target="#modal-default"/>
                                      }></Column>
                                    </DataTable>
                                  </AccordionTab>
                                  <AccordionTab header="Objetos de Ação">
                                    <DataTable value={this.state.objetosProcesso} emptyMessage=" ">
                                      <Column field="objeto.nome" header="Objeto"></Column>
                                      <Column body={this.acoesObjetosAcao} exportable={false} style={{ minWidth: '8rem' }}header={
                                        <Button icon="pi pi-plus" className="p-button-rounded p-button-text"
                                        tooltip="Clique para adicionar um novo Pagamento" 
                                        tooltipOptions={{position: 'top'}}
                                        style={{width: '20px', height: '20px'}}
                                        data-toggle="modal" 
                                        onClick={() => this.abrirModalObjetos('modalObjetos')}
                                        data-target="#modal-default"/>
                                      }></Column>
                                    </DataTable>
                                  </AccordionTab>
                                  <AccordionTab header={this.headerResumoPagamentos()}>
                                    <DataTable value={this.state.pagamentos} emptyMessage="Nenhum pagamento cadastrado">
                                      <Column field="pagamento.nome" header="Pagamento" className="cabecalho"></Column>
                                      <Column field="vlPagamento" header="R$" body={this.vlPagamento}></Column>
                                      <Column field="tipo" header="Deb/Cre"></Column>
                                      <Column field="dtPagamento" header="Dt. Pag"></Column>
                                      <Column body={this.acoesPagamentosProcesso} exportable={false} style={{ minWidth: '8rem' }}header={
                                        <Button icon="pi pi-plus" className="p-button-rounded p-button-text"
                                        tooltip="Clique para adicionar um novo Pagamento" 
                                        tooltipOptions={{position: 'top'}}
                                        style={{width: '20px', height: '20px'}}
                                        data-toggle="modal" 
                                        onClick={() => this.abrirModalCadastroPagamentos('modalPagamentos')}
                                        data-target="#modal-default"/>
                                      }></Column>
                                    </DataTable>
                                    {/**Incluir Pagamentos de Processo */}
                                    <Dialog header="Incluir Pagamento"
                                            visible={this.state.modalPagamentos} 
                                            style={{ width: '40vw' }} 
                                            footer={this.renderFooterCadastroPagamentos('modalPagamentos')} 
                                            onHide={() => this.fecharModalCadastro('modalPagamentos')}>

                                      <div className="row">
                                        <div className="col-sm-12">
                                          <div className="form-group">
                                            <label htmlFor="nomeGrupo">Tipo de Pagamento</label>
                                            <Dropdown value={this.state.tipoPagamento} 
                                                      options={this.state.tiposPagamentos} style={{width: '100%', height: '32px'}}
                                                      optionLabel="nome" 
                                                      emptyMessage=" "
                                                      filter showClear filterBy="nome"
                                                      onChange={this.onChangeTipoPagamento}
                                                      id="tipoPagamento"
                                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="row">
                                        <div className="col-sm-12">
                                          <div className="form-group">
                                          <label>Débito/Crédito</label>
                                            <Dropdown value={this.state.tipo} 
                                                      options={this.tiposPagamentosCustas} style={{width: '100%', height: '32px'}}
                                                      optionLabel="nome" 
                                                      emptyMessage=" "
                                                      onChange={(e) => this.setState({tipo: e.value})} 
                                                      id="tipoPagamento"
                                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="row">
                                        <div className="col-sm-6">
                                          <div className="form-group">
                                          <label>Valor Pagamento</label>
                                          <InputNumber inputId="locale-german" 
                                                        value={this.state.vlPagamento} 
                                                        style={{width: '100%', height: '32px'}} 
                                                        onChange={(e) => this.setState({vlPagamento: e.value})} 
                                                        mode="decimal" locale="de-BR" minFractionDigits={2}/>
                                          </div>
                                        </div>
                                        <div className="col-sm-6">
                                          <div className="form-group">
                                            <label>Dt. Pagamento</label>
                                            <Calendar id="mask" 
                                                      value={this.state.dtPagamento} 
                                                      onChange={(e) => this.setState({ dtPagamento: e.value })} 
                                                      locale="es"
                                                      style={{width: '100%', height: '32px'}} 
                                                      dateFormat="dd/mm/yy"
                                                      mask="99/99/9999"/>
                                          </div>
                                        </div>
                                      </div>
                                    </Dialog>
                                    <ConfirmDialog visible={this.state.visiblePagamento} 
                                                  onHide={() => this.setState({ visiblePagamento: false })} 
                                                  message="Are you sure you want to proceed?"
                                                  header="Confirmation"
                                                  icon="pi pi-exclamation-triangle" 
                                                  accept={() => this.excluirPagamentoProcesso} 
                                                  reject={() => this.setState({visible: false})}/>
                                  </AccordionTab>
                                  <AccordionTab header={this.headerResumoCustas()}>
                                    <DataTable value={this.state.custasProcessos} emptyMessage="Nenhuma custa cadastrada">
                                      <Column field="custas.nome" header="Custa" className="cabecalho"></Column>
                                      <Column field="vlCustas" header="R$" body={this.vlCustas}></Column>
                                      <Column field="tipo" header="Deb/Cre"></Column>
                                      <Column field="dtPagamento" header="Dt. Pag"></Column>
                                      <Column body={this.acoesCustasProcesso} exportable={false} style={{ minWidth: '8rem' }}header={
                                        <Button icon="pi pi-plus" className="p-button-rounded p-button-text"
                                                tooltip="Clique para adicionar uma nova Custa" 
                                                tooltipOptions={{position: 'top'}}
                                                style={{width: '20px', height: '20px'}}
                                                data-toggle="modal" 
                                                onClick={() => this.abrirModalCadastroCustas('modalCustas')}
                                                data-target="#modal-default"/>
                                      }></Column>
                                    </DataTable>
                                  </AccordionTab>
                                  <AccordionTab header={this.headerTotalPenhora()}>
                                    <DataTable value={this.state.garantiasProcesso} emptyMessage="Nenhuma garantia cadastrada">
                                      <Column field="garantia.nome" header="Garantia" className="cabecalho"></Column>
                                      <Column field="vlPenhora" header="R$" body={this.vlPenhora}></Column>
                                      <Column body={this.acoesGarantiasProcesso} exportable={false} style={{ minWidth: '8rem' }}header={
                                        <Button icon="pi pi-plus" className="p-button-rounded p-button-text"
                                                tooltip="Clique para adicionar uma nova garantia" 
                                                tooltipOptions={{position: 'top'}}
                                                style={{width: '20px', height: '20px'}}
                                                data-toggle="modal" 
                                                onClick={() => this.abrirModalCadastroGarantias('modalGarantias')}
                                                data-target="#modal-default"/>
                                      }></Column>
                                    </DataTable>
                                  </AccordionTab>
                                </Accordion>
                              </div>
                            </div>
                          </div>


                          <div className="row" style={{display: `${camposOutros}`}}>
                            <div className="col-sm-8">
                              <div className="form-group">
                                <Accordion multiple>
                                  <AccordionTab header="Pedidos">
                                    <DataTable value={this.state.pedidosProcesso} emptyMessage=" ">
                                      <Column field="pedido.nome" header="Pedido"></Column>
                                      <Column field="vlProvavel" header="Vl. Provável"></Column>
                                      <Column field="vlPossivel" header="Vl. Possível"></Column>
                                      <Column field="vlRemoto" header="Vl. Remoto"></Column>
                                      <Column body={this.acoesPedidos} exportable={false} style={{ minWidth: '8rem' }}header={
                                        <Button icon="pi pi-plus" className="p-button-rounded p-button-text"
                                        tooltip="Clique para adicionar um novo Pagamento" 
                                        tooltipOptions={{position: 'top'}}
                                        style={{width: '20px', height: '20px'}}
                                        data-toggle="modal" 
                                        onClick={() => this.abrirModalPedidos('modalPedidos')}
                                        data-target="#modal-default"/>
                                      }></Column>
                                    </DataTable>
                                  </AccordionTab>
                                  <AccordionTab header="Objetos de Ação">
                                    <DataTable value={this.state.objetosProcesso} emptyMessage=" ">
                                      <Column field="objeto.nome" header="Objeto"></Column>
                                      <Column body={this.acoesObjetosAcao} exportable={false} style={{ minWidth: '8rem' }}header={
                                        <Button icon="pi pi-plus" className="p-button-rounded p-button-text"
                                        tooltip="Clique para adicionar um novo Pagamento" 
                                        tooltipOptions={{position: 'top'}}
                                        style={{width: '20px', height: '20px'}}
                                        data-toggle="modal" 
                                        onClick={() => this.abrirModalObjetos('modalObjetos')}
                                        data-target="#modal-default"/>
                                      }></Column>
                                    </DataTable>
                                  </AccordionTab>
                                  
                                </Accordion>
                              </div>
                            </div>
                          </div>



                        </div>
                        <div style={{display: `${this.state.exibirAgravoApensoNegacao}`}}>
                          <div className="row" style={{display: `${camposOutros}`}}>
                            <div className="col-sm-8">
                              <div className="form-group">
                              <label>Motivo do Resultado</label>
                              <Dropdown value={this.state.motivo} 
                                        options={this.state.motivos} style={{width: '100%', height: '32px'}}
                                        optionLabel="nome" 
                                        filter showClear filterBy="nome"
                                        onChange={(e) => this.setState({motivo: e.value})} 
                                        id="motivoResultado"
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div style={{display: `${this.state.exibirAgravoApensoNegacao}`}}>
                          <div className="row">
                            <div className="col-sm-8">
                              <div className="form-group">
                                <label>Observação</label>
                                <InputTextarea id="pedidos" 
                                              type="text" 
                                              style={{width: '100%'}} 
                                              value={this.state.observacao}
                                              onChange={e => this.setState({observacao: e.target.value})}
                                              className="p-inputtext-sm p-d-block p-mb-1"
                                              rows={6} cols={30}/>
                              </div>
                            </div>
                          </div>
                        </div>
                        <br />
                        <div className="row">
                          <div className="col-sm-8">
                            <div className="form-group">
                              <div style={{textAlign: 'right'}}>
                                <Button label="Salvar" 
                                        className="p-button-primary p-button-text"
                                        onClick={this.alterarProcesso}/> 
                                &nbsp;
                                <Button label="Voltar" 
                                        className="p-button-secondary p-button-text"
                                        onClick={this.voltar}/>
                            
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                  </TabPanel>
                  <TabPanel header="Andamento Processual">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label>Partes:&nbsp;&nbsp;<span className="partes">{this.state.montaPartes}</span></label>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-3">
                        <div className="form-group">
                          <label>Pasta</label>
                          <InputText id="pasta" 
                                      type="text" 
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.pasta}
                                      onChange={e => this.setState({pasta: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      disabled="true"/>
                        </div>
                      </div>
                      <div className="col-sm-2">
                        <div className="form-group">
                          <label>Processo Judicial</label>
                          <InputMask id="numeroCnj" 
                                      type="text" 
                                      mask="9999999-99.9999.9.99.9999"
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.nrCnj}
                                      onChange={e => this.setState({nrCnj: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      disabled="true"/>
                        </div>
                      </div>
                      <div className="col-sm-2">
                        <div className="form-group">
                          <label>Processo Administrativo</label>
                          <InputText id="numeroProcesso" 
                                      type="text" 
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.nrProcesso}
                                      onChange={e => this.setState({nrProcesso: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      disabled="true"/>
                        </div>
                      </div>               
                    </div>
                    <div className="row">
                      <div className="col-md-5">
                        <span className="input-group">
                          <button type="button" className="btn btn-primary bg-gradient-primary"  
                                  aria-haspopup aria-controls="overlay_panel"
                                  data-toggle="modal" 
                                  onClick={() => this.abrirModalCadastroHistorico('modalHistorico')}
                                  data-target="#modal-default">
                            <i className="fas fa-plus"></i> Adicionar</button>
                        </span>
                      </div>
                    </div>
                    <br/>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <DataTable value={this.state.listaHistorico} paginator responsiveLayout="scroll" size="small"
                                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                    currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10}
                                    emptyMessage="Nenhuma Andamento">
                              <Column body={this.usuarioHistorico} exportable={false} style={{ textAlign: 'center', minWidth: '8rem' }}/>
                              <Column field="historico" header="Descrição" style={{ width: '70rem' }}></Column>
                              <Column field="tipoAndamento.nome" header="Tipo de Andamento"></Column>
                              <Column field="dataOcorrencia" header="Dt. Ocorrência"></Column>
                              <Column field="dataHistorico" header="Dt. Cadastro"></Column>
                              <Column field="usuario.nome" header="Usuaário"></Column>
                              <Column body={this.acoesHistoricoProcesso} exportable={false} style={{ minWidth: '8rem' }} header="Ações"/>
                          </DataTable>
                          {/**Incluir Histórico */}
                          <Dialog header="Incluir Andamento"
                                  visible={this.state.modalHistorico} 
                                  style={{ width: '40vw' }} 
                                  footer={this.renderFooterCadastroHistorico('modalHistorico')} 
                                  onHide={() => this.fecharModalCadastro('modalHistorico')}>

                            <div className="row">
                              <div className="col-sm-12">
                                <div className="form-group">
                                  <label htmlFor="dataPagamentoHistorico">Data de Ocorrência</label>
                                  <Calendar id="mask" 
                                            value={this.state.dataOcorrencia} 
                                            onChange={(e) => this.setState({ dataOcorrencia: e.value })} 
                                            locale="es"
                                            style={{width: '100%', height: '32px'}} 
                                            dateFormat="dd/mm/yy"
                                            mask="99/99/9999"/>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-sm-12">
                                <div className="form-group">
                                  <label htmlFor="tipoAndamento">Tipo de Andamento</label>
                                  <Dropdown value={this.state.tipoAndamento} 
                                            options={this.state.tiposAndamento} style={{width: '100%', height: '32px'}}
                                            optionLabel="nome" 
                                            filter showClear filterBy="nome"
                                            onChange={(e) => this.setState({tipoAndamento: e.value})} 
                                            id="grupoTrabalho"
                                            className="p-inputtext-sm p-d-block p-mb-1"/>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-sm-12">
                                <div className="form-group">
                                  <label htmlFor="descAndamento">Descrição</label>
                                  <InputTextarea id="descAndamento" 
                                                type="text" 
                                                style={{width: '100%'}} 
                                                value={this.state.historico}
                                                onChange={e => this.setState({historico: e.target.value})}
                                                className="p-inputtext-sm p-d-block p-mb-1"
                                                rows={7} cols={30}/>
                                </div>
                              </div>
                            </div>
                          </Dialog>
                          <ConfirmDialog visible={this.state.visibleHistorico} 
                                        onHide={() => this.setState({ visibleHistorico: false })} 
                                        message="Are you sure you want to proceed?"
                                        header="Confirmation"
                                        icon="pi pi-exclamation-triangle" 
                                        accept={() => this.excluirHistpricoProcesso} 
                                        reject={() => this.setState({visible: false})}/>
                        </div>
                      </div>                  
                    </div>
                  </TabPanel>
                  <TabPanel header="Recurso">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label>Partes:&nbsp;&nbsp;<span className="partes">{this.state.montaPartes}</span></label>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-3">
                        <div className="form-group">
                          <label>Pasta</label>
                          <InputText id="pasta" 
                                      type="text" 
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.pasta}
                                      onChange={e => this.setState({pasta: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      disabled="true"/>
                        </div>
                      </div>
                      <div className="col-sm-2">
                        <div className="form-group">
                          <label>Processo Judicial</label>
                          <InputMask id="numeroCnj" 
                                      type="text" 
                                      mask="9999999-99.9999.9.99.9999"
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.nrCnj}
                                      onChange={e => this.setState({nrCnj: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      disabled="true"/>
                        </div>
                      </div>
                      <div className="col-sm-2">
                        <div className="form-group">
                          <label>Processo Administrativo</label>
                          <InputText id="numeroProcesso" 
                                      type="text" 
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.nrProcesso}
                                      onChange={e => this.setState({nrProcesso: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      disabled="true"/>
                        </div>
                      </div>               
                    </div>
                    <div className="row">
                      <div className="col-md-5">
                        <span className="input-group">
                          <button type="button" className="btn btn-primary bg-gradient-primary"  
                                  aria-haspopup aria-controls="overlay_panel"
                                  data-toggle="modal" 
                                  onClick={() => this.abrirModalReurso('modalRecurso')}
                                  data-target="#modal-default">
                            <i className="fas fa-plus"></i> Adicionar</button>
                        </span>
                      </div>
                    </div>
                    <br />
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <DataTable value={this.state.agravosApensos} paginator responsiveLayout="scroll" size="small"
                                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                    currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10}
                                    emptyMessage="Nenhum Processo">
                              <Column field="processo.nrProcesso" header="Processo"></Column>
                              <Column field="tipo" header="Tipo"></Column>
                              <Column field="camara" header="Juízo"></Column>
                              <Column field="status.status" header="Status"></Column>
                              <Column field="observacao" header="Observação"></Column>
                              <Column body={this.acoesProcessoAgravosApensos} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                          </DataTable>
                        </div>
                      </div>
                    </div>
                    {/**Incluir Recurso */}
                    <Dialog header="Incluir Recurso"
                                  visible={this.state.modalRecurso} 
                                  style={{ width: '40vw' }} 
                                  footer={this.renderFooterCadastroRecurso('modalRecurso')} 
                                  onHide={() => this.fecharModalCadastro('modalRecurso')}>

                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                            <label>Número do Processo</label>
                            <InputText id="numeroCnjAgravoApenso" 
                                        type="text" 
                                        style={{width: '100%', height: '32px'}} 
                                        value={this.state.numeroAgravoApenso}
                                        onChange={e => this.setState({numeroAgravoApenso: e.target.value})}
                                        onBlur={this.consultarAgravoApensoExistente}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Tipo</label>
                              <Dropdown value={this.state.tipoProcessoAgravoApenso} 
                                        options={this.tiposProcessoAgravoApenso} style={{width: '100%', height: '32px'}}
                                        optionLabel="nome" 
                                        onChange={(e) => this.setState({tipoProcessoAgravoApenso: e.value})} 
                                        id="tipoProcessoAgravoApenso"
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label>Juízo</label>
                              <InputText id="camara" 
                                    type="text" 
                                    style={{width: '100%', height: '32px'}} 
                                    value={this.state.camara}
                                    onChange={e => this.setState({camara: e.target.value})}
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-8">
                            <div className="form-group">
                              <label>Parte</label>
                              <Dropdown value={this.state.parteRecurso} 
                                        options={this.state.partesRecurso} style={{width: '100%', height: '32px'}}
                                        optionLabel="nome" 
                                        onChange={(e) => this.setState({parteRecurso: e.value})} 
                                        id="grupoTrabalho"
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                          <div className="col-sm-3"> 
                            <div className="form-group">
                              <label>Tipo Parte</label>
                              <Dropdown value={this.state.tipoRecurso} 
                                        options={this.tipoParte} style={{width: '100%', height: '32px'}}
                                        optionLabel="nome" 
                                        onChange={(e) => this.setState({tipoRecurso: e.value})} 
                                        id="grupoTrabalho"
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                          <div className="col-sm-1"> 
                            <div className="form-group">
                              <br/>
                              <Button icon="pi pi-check" 
                                      className="p-button-rounded p-button-text" 
                                      placeholder="Incluir Parte"
                                      onClick={this.incluirParteAgravoApenso}
                                      aria-label="Submit" />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <DataTable value={this.partesAgravoApenso} responsiveLayout="scroll" size="small"
                                      emptyMessage="Nenhuma Parte">
                                  <Column field="parte.nome" header="Nome"></Column>
                                  <Column field="tipo.nome" header="Tipo"></Column>
                                  <Column body={this.acoesPartesAgravoApenso} exportable={false} style={{ minWidth: '8rem' }}></Column>
                              </DataTable>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label>Status</label>
                              <Dropdown value={this.state.statusRecursoApenso} 
                                        options={this.state.statusRecursoApensos} style={{width: '100%', height: '32px'}}
                                        optionLabel="status" 
                                        onChange={(e) => this.setState({statusRecursoApenso: e.value})} 
                                        id="statusRecurso"
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <InputTextarea value={this.state.observacaoRecursoApenso} style={{width: '100%'}}
                                            id="observacaoRecursoApenso"
                                            onChange={e => this.setState({observacaoRecursoApenso: e.target.value})}
                                            rows={4} 
                                            cols={60} />
                            </div>
                          </div>
                        </div>
                    </Dialog>
                  </TabPanel>
                  <TabPanel header="Apenso">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label>Partes:&nbsp;&nbsp;<span className="partes">{this.state.montaPartes}</span></label>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-3">
                        <div className="form-group">
                          <label>Pasta</label>
                          <InputText id="pasta" 
                                      type="text" 
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.pasta}
                                      onChange={e => this.setState({pasta: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      disabled="true"/>
                        </div>
                      </div>
                      <div className="col-sm-2">
                        <div className="form-group">
                          <label>Processo Judicial</label>
                          <InputMask id="numeroCnj" 
                                      type="text" 
                                      mask="9999999-99.9999.9.99.9999"
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.nrCnj}
                                      onChange={e => this.setState({nrCnj: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      disabled="true"/>
                        </div>
                      </div>
                      <div className="col-sm-2">
                        <div className="form-group">
                          <label>Processo Administrativo</label>
                          <InputText id="numeroProcesso" 
                                      type="text" 
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.nrProcesso}
                                      onChange={e => this.setState({nrProcesso: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      disabled="true"/>
                        </div>
                      </div>               
                    </div>
                    <div className="row">
                      <div className="col-md-5">
                        <span className="input-group">
                          <button type="button" className="btn btn-primary bg-gradient-primary"  
                                  aria-haspopup aria-controls="overlay_panel"
                                  data-toggle="modal" 
                                  onClick={() => this.abrirModalAgravoApenso('modalAgravoApenso')}
                                  data-target="#modal-default">
                            <i className="fas fa-plus"></i> Adicionar</button>
                        </span>
                      </div>
                    </div>
                    <br />
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <DataTable value={this.state.agravosApensos} paginator responsiveLayout="scroll" size="small"
                                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                    currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10}
                                    emptyMessage="Nenhum Processo">
                              <Column field="processo.nrProcesso" header="Processo"></Column>
                              <Column field="tipo" header="Tipo"></Column>
                              <Column field="camara" header="Câmara"></Column>
                              <Column field="relator" header="Relator"></Column>
                              <Column body={this.acoesProcessoAgravosApensos} 
                                      exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                          </DataTable>
                        </div>
                      </div>
                    </div>
                    {/**Incluir Agravo Apenso */}
                    <Dialog header="Incluir Processo Agravo/Apenso"
                                  visible={this.state.modalAgravoApenso} 
                                  style={{ width: '40vw' }} 
                                  footer={this.renderFooterCadastroAgravoApenso('modalAgravoApenso')} 
                                  onHide={() => this.fecharModalCadastro('modalAgravoApenso')}>

                            <div className="row">
                              <div className="col-sm-6">
                                <div className="form-group">
                                <label>Número do Processo</label>
                                <InputText id="numeroCnjAgravoApenso" 
                                           type="text" 
                                           style={{width: '100%', height: '32px'}} 
                                           value={this.state.numeroAgravoApenso}
                                           onChange={e => this.setState({numeroAgravoApenso: e.target.value})}
                                           className="p-inputtext-sm p-d-block p-mb-1"/>
                                </div>
                              </div>
                              <div className="col-sm-6">
                                <div className="form-group">
                                  <label>Tipo Agraco/Apenso</label>
                                  <Dropdown value={this.state.tipoProcessoAgravoApenso} 
                                            options={this.tiposProcessoAgravoApenso} style={{width: '100%', height: '32px'}}
                                            optionLabel="nome" 
                                            onChange={(e) => this.setState({tipoProcessoAgravoApenso: e.value})} 
                                            id="tipoProcessoAgravoApenso"
                                            className="p-inputtext-sm p-d-block p-mb-1"/>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-sm-12">
                                <div className="form-group">
                                  <label>Juízo</label>
                                  <InputText id="camara" 
                                        type="text" 
                                        style={{width: '100%', height: '32px'}} 
                                        value={this.state.camara}
                                        onChange={e => this.setState({camara: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                                </div>
                              </div>
                            </div>
                    </Dialog>
                    <Dialog header="Agravo/Apenso"
                            visible={this.state.modalAgravoApensoExistente} 
                            style={{ width: '40vw' }} 
                            footer={this.renderFooterAgravoApensoExistente('modalAgravoApensoExistente')}>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            Processo já existente no sistema. Deseja incluí-lo mesmo assim ? 
                          </div>
                        </div>
                      </div>
                    </Dialog>
                  </TabPanel>                    

                  <TabPanel header="Atividades">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label>Partes:&nbsp;&nbsp;<span className="partes">{this.state.montaPartes}</span></label>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-3">
                        <div className="form-group">
                          <label>Pasta</label>
                          <InputText id="pasta" 
                                      type="text" 
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.pasta}
                                      onChange={e => this.setState({pasta: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      disabled="true"/>
                        </div>
                      </div>
                      <div className="col-sm-2">
                        <div className="form-group">
                          <label>Processo Judicial</label>
                          <InputMask id="numeroCnj" 
                                      type="text" 
                                      mask="9999999-99.9999.9.99.9999"
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.nrCnj}
                                      onChange={e => this.setState({nrCnj: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      disabled="true"/>
                        </div>
                      </div>
                      <div className="col-sm-2">
                        <div className="form-group">
                          <label>Processo Administrativo</label>
                          <InputText id="numeroProcesso" 
                                      type="text" 
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.nrProcesso}
                                      onChange={e => this.setState({nrProcesso: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      disabled="true"/>
                        </div>
                      </div>               
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <DataTable value={this.state.atividades} paginator responsiveLayout="scroll" size="small"
                                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                    currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={5}
                                    emptyMessage="Nenhuma Atividade">
                              <Column body={this.templateStatus} exportable={false} style={{ minWidth: '8rem' }}header="Situação"></Column>
                              <Column field="titulo" header="Título"></Column>
                              <Column field="fase.nome" header="Fase"></Column>
                              <Column field="subGrupo.nome" header="Sub-Grupo"></Column>
                              <Column field="responsaveis" header="Responsáveis"></Column>
                              <Column field="dtLimite" header="Data Limite"></Column>
                              <Column field="dtFatal" header="Prazo Fatal"></Column>
                              <Column body={this.acoesAtividade} exportable={false} style={{ minWidth: '8rem' }}header={this.novaAtividadeHeader}></Column>
                          </DataTable>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form-group">
                          <h5>Fases das Atividades</h5>
                          <Chart type="bar" data={this.state.graficoAtividadeFasesPie} options={basicOptions} />
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-group">
                          <h5>Status das Atividades</h5>
                          <Chart type="pie" data={this.state.graficoStatusData} options={horizontalOptions} />
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel header="Documentos">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>Partes:&nbsp;&nbsp;<span className="partes">{this.state.montaPartes}</span></label>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-3">
                      <div className="form-group">
                        <label>Pasta</label>
                        <InputText id="pasta" 
                                    type="text" 
                                    style={{width: '100%', height: '32px'}} 
                                    value={this.state.pasta}
                                    onChange={e => this.setState({pasta: e.target.value})}
                                    className="p-inputtext-sm p-d-block p-mb-1"
                                    disabled="true"/>
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <div className="form-group">
                        <label>Processo Judicial</label>
                        <InputMask id="numeroCnj" 
                                    type="text" 
                                    mask="9999999-99.9999.9.99.9999"
                                    style={{width: '100%', height: '32px'}} 
                                    value={this.state.nrCnj}
                                    onChange={e => this.setState({nrCnj: e.target.value})}
                                    className="p-inputtext-sm p-d-block p-mb-1"
                                    disabled="true"/>
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <div className="form-group">
                        <label>Processo Adminitrativo</label>
                        <InputText id="numeroProcesso" 
                                    type="text" 
                                    style={{width: '100%', height: '32px'}} 
                                    value={this.state.nrProcesso}
                                    onChange={e => this.setState({nrProcesso: e.target.value})}
                                    className="p-inputtext-sm p-d-block p-mb-1"
                                    disabled="true"/>
                      </div>
                    </div>               
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">  
                        <div className="container">
                          
                          <Upload onUpload={this.handleUpload}/>
                          {!!upLoadFiles && (
                            <FileList files={upLoadFiles} onDelete={this.handleDelete}/>
                          )}
                         
                        </div>
                      </div>
                    </div>
                  </div>
                    <DataTable value={this.state.arquivos} paginator responsiveLayout="scroll" size="small"
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10}
                                emptyMessage="Nenhum Arquivo">
                          <Column field="nome" header="Arquivo"/>
                          <Column field="dsArquivo" header="Descrição"></Column>
                          <Column field="usuario.nome" header="Usuário"></Column>
                          <Column body={this.acoesArquivos} exportable={false} style={{ minWidth: '8rem' }} header="Ações"/>
                    </DataTable> 
                    {/**Adicionar descrição ao arquivo */}
                    <Dialog header="Descrição do Arquivo"
                                visible={this.state.modalDescricaoArquivo} 
                                style={{ width: '40vw' }} 
                                footer={this.renderFooterDescricaoArquivo('modalDescricaoArquivo')}
                                onHide={() => this.fecharModalCadastro('modalDescricaoArquivo')}>

                          <div className="row">
                            <div className="col-sm-12">
                              <div className="form-group">
                                <label htmlFor="descricaoArquivo">Descrição</label>
                                <InputText id="descricaoArquivo" 
                                      type="text" 
                                      style={{width: '100%', height: '37px'}} 
                                      value={this.state.dsArquivo}
                                      onChange={e => this.setState({dsArquivo: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                              </div>
                            </div>
                          </div>
                    </Dialog>
                    <ConfirmDialog visible={this.state.visibleExcluirArquivo} 
                                   onHide={() => this.setState({ visibleExcluirArquivo: false })} 
                                   message="Are you sure you want to proceed?"
                                   header="Confirmation"
                                   icon="pi pi-exclamation-triangle" 
                                   accept={() => this.excluirArquivo} 
                                   reject={() => this.setState({visibleExcluirArquivo: false})}/>              
                  </TabPanel>
                  <TabPanel header="Financeiro">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label>Partes:&nbsp;&nbsp;<span className="partes">{this.state.montaPartes}</span></label>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-3">
                        <div className="form-group">
                          <label>Pasta</label>
                          <InputText id="pasta" 
                                      type="text" 
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.pasta}
                                      onChange={e => this.setState({pasta: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      disabled="true"/>
                        </div>
                      </div>
                      <div className="col-sm-2">
                        <div className="form-group">
                          <label>Processo Judicial</label>
                          <InputMask id="numeroCnj" 
                                      type="text" 
                                      mask="9999999-99.9999.9.99.9999"
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.nrCnj}
                                      onChange={e => this.setState({nrCnj: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      disabled="true"/>
                        </div>
                      </div>
                      <div className="col-sm-2">
                        <div className="form-group">
                          <label>Processo Adminitrativo</label>
                          <InputText id="numeroProcesso" 
                                      type="text" 
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.nrProcesso}
                                      onChange={e => this.setState({nrProcesso: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      disabled="true"/>
                        </div>
                      </div>               
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <DataTable value={this.state.lancamentosFinanceiros} paginator responsiveLayout="scroll" size="small"
                                          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                          currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10}
                                          emptyMessage="Nenhum Lançamento Financeiro">
                            <Column field="categoria" header="Categoria"></Column>
                            <Column field="tipo.nome" header="Tipo"></Column>
                            <Column field="valorLancamentoFormat" header="Valor"></Column>
                            <Column field="dtVencimento" header="Dt. Vencto."></Column>
                            <Column field="valorPagamentoFormat" header="Valor Pago"></Column>
                            <Column field="dtPago" header="Dt. Pgto."></Column>
                            <Column field="situacao" header="Situação"></Column>
                            <Column body={this.acoesFinanceiro} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                          </DataTable>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                </TabView>
                {/**Aqui entra o modal de atividade */}
                <Dialog header="Alterar Atividade" autoComplete="nope"
                          visible={this.state.displayAtividadeAlterar} 
                          style={{ width: '43vw' }} 
                          footer={this.renderFooterAtividade('displayAtividadeAlterar')} 
                          onHide={() => this.fecharModalAtividade('displayAtividadeAlterar')}>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <InputText id="titulo" 
                                        disabled={bloqueiaTitulo}
                                        style={{width: '100%', height: '32px'}}
                                        type="text" 
                                        autoComplete="nope"
                                        value={this.state.titulo}
                                        onChange={e => this.setState({titulo: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"
                                        placeholder="Título"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <Dropdown value={this.state.faseAtividade} style={{width: '100%', height: '32px'}} 
                                      options={this.state.fasesAtividade} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      emptyMessage=" "
                                      filter showClear filterBy="nome"
                                      onChange={e => this.setState({faseAtividade: e.target.value})}
                                      id="faseAtividade"
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      placeholder="Fase da Atividade"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <InputText id="processo" style={{width: '100%', height: '32px'}}
                                      type="text"
                                      disabled="true"
                                      value={this.state.pesquisaProcesso}
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            {this.state.partes}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                          <InputText id="grupoAlterar" style={{width: '100%', height: '32px'}}
                                     type="text"
                                     disabled="true"
                                     value={this.state.grupoTrabalhoNome}
                                     className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <Dropdown value={this.state.selectSubGrupo} style={{width: '100%', height: '32px'}} 
                                      options={this.state.subGrupos} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      emptyMessage=" "
                                      filter showClear filterBy="nome"
                                      onChange={this.onSubGrupoChange}
                                      id="subGrupoTrabalho"
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      placeholder="Sub-Grupo de Trabalho"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <MultiSelect inputId="multiselect" 
                                        value={this.state.responsaveisLista} 
                                        options={this.state.responsaveis} 
                                        style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                        onChange={(e) => this.setState({ responsaveisLista: e.value })} 
                                        filter showClear filterBy="nome"
                                        optionLabel="nome" 
                                        placeholder="Responsáveis"/>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <MultiSelect inputId="multiselect" 
                                        value={this.state.interessadosLista} 
                                        options={this.state.interessados} 
                                        style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                        onChange={(e) => this.setState({ interessadosLista: e.value })}  
                                        filter showClear filterBy="nome"
                                        optionLabel="nome" 
                                        placeholder="Interssados"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-3">
                          <div className="form-group">
                            <Calendar id="mask" 
                                      value={this.state.dtLimite} 
                                      onChange={(e) => this.setState({ dtLimite: e.value })} 
                                      locale="es"
                                      style={{width: '100%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      mask="99/99/9999"
                                      placeholder="Data Limite"/>
                          </div>
                        </div>
                        <div className="col-sm-3">
                          <div className="form-group">
                          <InputMask id="hora" style={{width: '100%', height: '32px'}}
                                    type="text"
                                    mask="99:99"
                                    value={this.state.hora}
                                    onChange={e => this.setState({hora: e.target.value})}
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <Calendar id="mask" 
                                      value={this.state.dtFatal} 
                                      onChange={(e) => this.setState({ dtFatal: e.value })} 
                                      locale="es"
                                      style={{width: '100%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      mask="99/99/9999"
                                      placeholder="Prazo fatal"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <InputTextarea value={this.state.descricao} style={{width: '100%'}}
                                           id="descricaoE"
                                           onChange={e => this.setState({descricao: e.target.value})}
                                           rows={4} 
                                           cols={60} />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <Dropdown value={this.state.optionStatus} style={{width: '100%', height: '32px'}} 
                                      options={this.state.statusAtividade} style={{width: '100%', height: '32px'}}
                                      optionLabel="status" 
                                      emptyMessage=" "
                                      filter showClear filterBy="status"
                                      onChange={this.onChangeStatusAtividade}
                                      id="idStatusAtividade"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                  </Dialog>
                  {/**Informação de usuário */}
                  <Dialog header="Usuários da Tarefa"
                          style={{ width: '30vw' }} 
                          visible={this.state.modalInformacaoUsuario} 
                          footer={this.renderFooterInformacaoUsuario('modalInformacaoUsuario')} 
                          onHide={() => this.fecharModalAtividade('modalInformacaoUsuario')}>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                        <DataTable value={this.state.usuariosTarefas} emptyMessage="Nenum usuário para esta tarefa">
                          <Column field="usuario.nome" header="Usuário"></Column>
                        </DataTable>
                        </div>
                      </div>
                    </div>   
                  </Dialog>
                  {/**Aqui entra o modal de atividade agrupada*/}
                  <Dialog header="Incluir Atividade Agrupada"
                          disabled="true"
                          style={{ width: '40vw' }} 
                          visible={this.state.modalTarefaAgrupada} 
                          footer={this.renderFooterAtividadeAgrupada('modalTarefaAgrupada')} 
                          onHide={() => this.fecharModalAtividade('modalTarefaAgrupada')}>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                          <Dropdown value={this.state.grupoTarefa} style={{width: '100%', height: '32px'}} 
                                    options={this.state.gruposTarefas} style={{width: '100%', height: '32px'}}
                                    optionLabel="nome" 
                                    filter showClear filterBy="nome"
                                    onChange={this.onChangeGrupoTarefa}
                                    id="grupoTarefa"
                                    className="p-inputtext-sm p-d-block p-mb-1"
                                    placeholder="Grupo de Tarefas"/>
                          </div>
                        </div>
                      </div>
                      <div className="row" style={{display: `${this.state.exibirComponentes}`}}>
                        <div className="col-sm-12">
                          <div className="form-group">
                            <DataTable value={this.state.tarefas}  alwaysShowPaginator responsiveLayout="scroll"
                                  paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                  currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={4} emptyMessage=" "
                                  paginatorRight selectionMode="multiple">
                              <Column field="titulo" header="Tarefa"></Column>
                              <Column field="prazo" header="Prazo"></Column>
                              <Column field="tempo" header="Tempo"></Column>
                              <Column body={this.informacoesUsuariosTarefas} exportable={false} style={{ minWidth: '8rem' }}header="Usuários"></Column>
                            </DataTable>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                          <InputText id="grupoAlterar" style={{width: '100%', height: '32px'}}
                                     type="text"
                                     disabled="true"
                                     value={this.state.grupoTrabalhoNome}
                                     className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <Dropdown value={this.state.selectSubGrupo} style={{width: '100%', height: '32px'}} 
                                      options={this.state.subGrupos} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      emptyMessage=" "
                                      filter showClear filterBy="nome"
                                      onChange={this.onSubGrupoChange}
                                      id="subGrupoTrabalho"
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      placeholder="Sub-Grupo de Trabalho"/>
                          </div>
                        </div>
                      </div>
                      
                      <div style={{display: `${this.state.exibirComponentesGrupos}`}}>
                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <Calendar id="mask" 
                                        value={this.state.dtLimite} 
                                        onChange={(e) => this.setState({ dtLimite: e.value })} 
                                        locale="es"
                                        style={{width: '100%', height: '32px'}} 
                                        dateFormat="dd/mm/yy"
                                        mask="99/99/9999"
                                        placeholder="Data Referência"/>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <InputTextarea id="descricaoAgrupada" 
                                            type="text" 
                                            autoComplete="nope"
                                            style={{width: '100%'}} 
                                            value={this.state.descricao}
                                            onChange={e => this.setState({descricao: e.target.value})}
                                            className="p-inputtext-sm p-d-block p-mb-1"
                                            rows={4} cols={30}
                                            placeholder="Descrição da Atividade"/>
                            </div>
                          </div>
                        </div>
                      </div>
                  </Dialog>

                  {/**Arquivos Anexados */}
                  <Dialog header="Arquivos Anexados atividade"
                          style={{ width: '40vw' }} 
                          visible={this.state.displayArquivosAnexadosAtividade} 
                          footer={
                            <frameElement>
                              <Button label="Fechar" 
                                      className="p-button-secondary p-button-text"
                                      onClick={() => this.fecharModalAtividade('displayArquivosAnexadosAtividade')}/>
                            </frameElement>
                            
                          } 
                          onHide={() => this.fecharModalAtividade('displayArquivosAnexadosAtividade')}>
                      
                      <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">  
                              <div className="container">
                                
                                <Upload onUpload={this.handleUploadAtividade}/>
                                {!!upLoadFiles && (
                                  <FileList files={upLoadFiles} onDelete={this.handleDeleteAtividade}/>
                                )}
                              
                              </div>
                            </div>
                          </div>
                        </div>
                        <DataTable value={this.state.arquivosAtividades} paginator responsiveLayout="scroll" size="small"
                                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                    currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10}
                                    emptyMessage="Nenhum Arquivo">
                          <Column field="arquivo" header="Arquivo"/>
                          <Column field="dsArquivo" header="Descrição"/>
                          <Column body={this.acoesArquivosAtividade} exportable={false} style={{ minWidth: '8rem' }} header="Ações"/>
                        </DataTable> 
                    </Dialog>   
                    {/**Adicionar descrição ao arquivo */}
                    <Dialog header="Descrição do Arquivo - Atividade"
                            visible={this.state.modalDescricaoArquivoAtividade} 
                            style={{ width: '40vw' }} 
                            footer={this.renderFooterDescricaoArquivoAtividade('modalDescricaoArquivoAtividade')}
                            onHide={() => this.fecharModalCadastro('modalDescricaoArquivoAtividade')}>

                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label htmlFor="descricaoArquivo">Descrição</label>
                              <InputText id="descricaoArquivo" 
                                    type="text" 
                                    style={{width: '100%', height: '37px'}} 
                                    value={this.state.dsArquivo}
                                    onChange={e => this.setState({dsArquivo: e.target.value})}
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                        </div>
                  </Dialog>
                  {/**Histórico de Atividades */}
                  <Dialog header="Histórico da Atividade" autoComplete="nope"
                          style={{ height: '50vw', width: '25vw' }}
                          visible={this.state.displayHistorico} 
                          footer={
                            <frameElement>
                              <Button label="Incluir" 
                                      className="p-button-primary p-button-text"
                                      onClick={this.novoHistorico}/>
                              &nbsp;
                              <Button label="Fechar" 
                                      className="p-button-secondary p-button-text"
                                      onClick={() => this.fecharModalAtividade('displayHistorico')}/>
                            </frameElement>
                            
                          } 
                          onHide={() => this.fecharModalAtividade('displayHistorico')}>
                      <DataView value={this.state.historico}
                                layout={this.state.layout}
                                emptyMessage=" "
                                itemTemplate={this.templateHistoricoAtividade}/>
                  </Dialog>
                  {/**Confirmação de exclusão de Histórico */}
                  <ConfirmDialog visible={this.state.visibleHistorico} 
                                onHide={() => this.setState({ visibleHistorico: false })} 
                                message="Are you sure you want to proceed?"
                                header="Confirmation"
                                icon="pi pi-exclamation-triangle" 
                                accept={() => this.excluirHistorico} 
                                reject={() => this.setState({visibleHistorico: false})}/>
                  
                  {/**Incluir um novo histórico */}
                  <Dialog header="Incluir Histórico" autoComplete="nope"
                          style={{ width: '40vw' }} 
                          visible={this.state.displayHistoricoIncluir} 
                          footer={
                            <frameElement>
                              <Button label="Incluir" 
                                      className="p-button-primary p-button-text"
                                      onClick={() => this.incluirHistoricoAtividade()}/>
                              &nbsp;
                              <Button label="Fechar" 
                                      className="p-button-secondary p-button-text"
                                      onClick={() => this.fecharModalAtividade('displayHistoricoIncluir')}/>
                            </frameElement>
                            
                          } 
                          onHide={() => this.fecharModalAtividade('displayHistoricoIncluir')}> 

                    <div className="row" style={{display: `${exibieDataHistorico}`}}>
                      <div className="col-sm-12">
                        <div className="form-group">
                        <Checkbox inputId="mudancaData" 
                                  name="mudancaData" 
                                  value="mudancaData" 
                                  onChange={this.onMudancaData} 
                                  checked={this.state.mudancaDataHistorico.indexOf('mudancaData') !== -1} />
                          &nbsp;
                          Mudança de Data
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <InputTextarea id="historico" 
                                          type="text" 
                                          autoComplete="nope"
                                          style={{width: '100%'}} 
                                          value={this.state.dsHistorico}
                                          onChange={e => this.setState({dsHistorico: e.target.value})}
                                          className="p-inputtext-sm p-d-block p-mb-1"
                                          rows={6} cols={30}/>
                        </div>
                      </div>
                    </div>  
                  </Dialog>
                  {/**Descrição da Atividade */}
                  <Dialog header="Descrição da Atividade"
                          style={{ width: '50vw' }} 
                          visible={this.state.displayDescricao} 
                          footer={
                            <frameElement>
                              <Button label="Salvar" 
                                      className="p-button-secondary p-button-text"
                                      onClick={() => this.fecharModalAtividade('displayDescricao')}/>
                            </frameElement>
                            
                          } 
                          onHide={() => this.fecharModalAtividade('displayDescricao')}>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <InputTextarea id="idDescricao" 
                                          type="text" 
                                          autoComplete="nope"
                                          style={{width: '100%'}} 
                                          value={this.state.descricao}
                                          onChange={e => this.setState({descricao: e.target.value})}
                                          className="p-inputtext-sm p-d-block p-mb-1"
                                          rows={6} cols={30}/>
                        </div>
                      </div>
                    </div>
                  </Dialog>
                  {/**Nova Atividade Processo */}
                  <Dialog header="Incluir Atividade"
                          visible={this.state.displayAtividade}
                          style={{ width: '43vw' }}
                          footer={this.renderFooterAtividadeNovaAtividade('displayAtividade')} 
                          onHide={() => this.fecharModalAtividade('displayAtividade')}>
                      <Progresso classeSecundaria={this.state.classeDiv}/>
                      <div style={{display: `${this.state.separador}`}}>
                        <br />
                        <strong style={{color: '#343A40'}}>Aguarde....</strong>
                        <br/>
                        <br/>
                      </div>
                      <div className="row" style={{display: `${tituloNaoPredefinido}`}}>
                        <div className="col-sm-12">
                          <div className="form-group">
                            <InputText id="titulo" 
                                        style={{width: '100%', height: '32px'}}
                                        type="text" 
                                        autoComplete="nope"
                                        value={this.state.titulo}
                                        onChange={e => this.setState({titulo: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"
                                        placeholder="Título"/>
                          </div>
                        </div>
                      </div>
                      <div className="row" style={{display: `${tituloPredefinidoSim}`}}>
                        <div className="col-sm-12">
                          <div className="form-group">
                            <Dropdown value={this.state.tituloAtividade} style={{width: '100%', height: '32px'}} 
                                      options={this.state.titulos} style={{width: '100%', height: '32px'}}
                                      optionLabel="titulo" 
                                      filter showClear filterBy="titulo"
                                      onChange={this.onChangeFasesPorTitulo}
                                      id="tituloAtividade"
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      placeholder="Título de Atividade"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <Dropdown value={this.state.faseAtividade} style={{width: '100%', height: '32px'}} 
                                      options={this.state.fasesAtividade} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      emptyMessage=" "
                                      filter showClear filterBy="nome"
                                      onChange={e => this.setState({faseAtividade: e.target.value})}
                                      id="faseAtividade"
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      placeholder="Fase da Atividade"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <InputText id="processo" style={{width: '100%', height: '32px'}}
                                        type="text"
                                        disabled="true"
                                        value={this.state.pesquisaProcesso}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                      
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                          <InputText id="processo" style={{width: '100%', height: '32px'}}
                                     type="text"
                                     disabled="true"
                                     value={this.state.grupoTrabalhoNome}
                                     className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <Dropdown value={this.state.selectSubGrupo} style={{width: '100%', height: '32px'}} 
                                      options={this.state.subGrupos} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      emptyMessage=" "
                                      filter showClear filterBy="nome"
                                      onChange={this.onSubGrupoChange}
                                      id="subGrupoTrabalho"
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      placeholder="Sub-Grupo de Trabalho"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <MultiSelect inputId="multiselect" 
                                        value={this.state.responsavel} 
                                        options={this.state.responsaveis} 
                                        style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                        onChange={(e) => this.setState({ responsavel: e.value })} 
                                        filter showClear filterBy="nome"
                                        optionLabel="nome" 
                                        placeholder="Responsáveis"/>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <MultiSelect inputId="multiselect" 
                                        value={this.state.interessado} 
                                        options={this.state.interessados} 
                                        style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                        onChange={(e) => this.setState({ interessado: e.value })}  
                                        filter showClear filterBy="nome"
                                        optionLabel="nome" 
                                        placeholder="Interssados"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                          <Dropdown value={this.state.recorrencia} style={{width: '100%', height: '32px'}} 
                                    options={this.recorrencia} style={{width: '100%', height: '32px'}}
                                    optionLabel="nome" 
                                    emptyMessage=" "
                                    filter showClear filterBy="nome"
                                    onChange={(e) => this.setState({ recorrencia: e.value })}  
                                    id="recorrencia"
                                    className="p-inputtext-sm p-d-block p-mb-1"
                                    placeholder="Recorrência ?"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-3">
                          <div className="form-group">
                            <Calendar id="mask" 
                                      value={this.state.dtLimite} 
                                      onChange={(e) => this.setState({ dtLimite: e.value })} 
                                      locale="es"
                                      style={{width: '100%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      mask="99/99/9999"
                                      placeholder="Data Limite"/>
                          </div>
                        </div>
                        <div className="col-sm-3">
                          <div className="form-group">
                          <InputMask id="hora" style={{width: '100%', height: '32px'}}
                                    type="text"
                                    mask="99:99"
                                    value={this.state.hora}
                                    onChange={e => this.setState({hora: e.target.value})}
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <Calendar id="mask" 
                                      value={this.state.dtFatal} 
                                      onChange={(e) => this.setState({ dtFatal: e.value })} 
                                      locale="es"
                                      style={{width: '100%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      mask="99/99/9999"
                                      placeholder="Prazo fatal"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <InputTextarea id="descricao" 
                                          type="text" 
                                          autoComplete="nope"
                                          style={{width: '100%'}} 
                                          value={this.state.descricao}
                                          onChange={e => this.setState({descricao: e.target.value})}
                                          className="p-inputtext-sm p-d-block p-mb-1"
                                          rows={3} cols={30}
                                          placeholder="Descrição da Atividade"/>
                          </div>
                        </div>
                      </div>
                  </Dialog>

                  {/**Anexo de Documentos Nova Atividade */}
                  <Dialog header="Anexar Documentos"
                          visible={this.state.displayAnexoNovaAtividade} 
                          style={{ width: '40vw' }} 
                          footer={
                            <frameElement>
                              <Button label="Fechar" 
                                      className="p-button-secondary p-button-text"
                                      onClick={() => this.fecharModalAtividade('displayAnexoNovaAtividade')}/>
                            </frameElement>
                          } 
                          onHide={() => this.fecharModalAtividade('displayAnexoNovaAtividade')}>
                    
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">  
                          <div className="container">
                            
                            <Upload onUpload={this.handleUploadNovaAtividade}/>
                            {!!upLoadFiles && (
                              <FileList files={upLoadFiles} onDelete={this.handleDeleteNovaAtividade}/>
                            )}
                          
                          </div>
                        </div>
                      </div>
                    </div>
                    <DataTable value={this.state.arquivosNovaAtividade} paginator responsiveLayout="scroll" size="small"
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10}
                                emptyMessage="Nenhum Arquivo">
                      <Column field="arquivo" header="Arquivo"/>
                      <Column field="descricao" header="Descrição"/>
                      <Column body={this.acoesArquivosNovaAtividade} exportable={false} style={{ minWidth: '8rem' }} header="Ações"/>
                    </DataTable> 
                          
                  </Dialog>
                  
                  {/**Adicionar descrição ao arquivo */}
                  <Dialog header="Descrição do Arquivo"
                              visible={this.state.modalDescricaoArquivoNovaAtividade} 
                              style={{ width: '40vw' }} 
                              footer={this.renderFooterDescricaoArquivoNovaAtividade('modalDescricaoArquivoNovaAtividade')}
                              onHide={() => this.fecharModalCadastro('modalDescricaoArquivoNovaAtividade')}>

                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label htmlFor="descricaoArquivoNovaAtividade">Descrição</label>
                              <InputText id="descricaoArquivoNovaAtividade" 
                                    type="text" 
                                    style={{width: '100%', height: '37px'}} 
                                    value={this.state.descricao}
                                    onChange={e => this.setState({descricao: e.target.value})}
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                        </div>
                  </Dialog>
                  <ConfirmDialog visible={this.state.visibleExcluirArquivo} 
                                onHide={() => this.setState({ visibleExcluirArquivo: false })} 
                                message="Are you sure you want to proceed?"
                                header="Confirmation"
                                icon="pi pi-exclamation-triangle" 
                                accept={() => this.excluirArquivo} 
                                reject={() => this.setState({visibleExcluirArquivo: false})}/>  

                  {/**Consultar Lançamento */}
                  <Dialog header="Consulta Lançamento"
                          visible={this.state.displayConsultaLancamento} 
                          style={{ width: '60vw' }} 
                          footer={this.renderFooterConsultaLancamento('displayConsultaLancamento')} 
                          onHide={() => this.fecharModal('displayConsultaLancamento')}>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="formGroup">
                          <label>Categoria</label>
                          <InputText id="categoriaConsulta" 
                                    type="text" 
                                    style={{width: '100%', height: '37px'}} 
                                    value={this.state.categoriaNome}
                                    disabled="true"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="formGroup">
                          <label>Tipo</label>
                          <InputText id="tipoNome" 
                                    type="text" 
                                    style={{width: '100%', height: '37px'}} 
                                    value={this.state.tipoNome}
                                    disabled="true"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="formGroup">
                          <label>Valor</label>
                          <InputText id="valorConsulta" 
                                    type="text" 
                                    style={{width: '100%', height: '37px'}} 
                                    value={this.state.vlLancamentoMascara}
                                    disabled="true"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="formGroup">
                          <label>Vencimento</label>
                          <InputText id="dataVencimentoConsulta" 
                                    type="text" 
                                    style={{width: '100%', height: '37px'}} 
                                    value={this.state.dtVencimento}
                                    disabled="true"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-4">
                        <div className="formGroup">
                          <label>Situação</label>
                          <InputText id="situacaoConsulta" 
                                    type="text" 
                                    style={{width: '100%', height: '37px'}} 
                                    value={this.state.situacao}
                                    disabled="true"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="formGroup">
                          <label>Valor Pago</label>
                          <InputText id="valorPago" 
                                    type="text" 
                                    style={{width: '100%', height: '37px'}} 
                                    value={this.state.vlPagoMascara}
                                    disabled="true"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="formGroup">
                          <label>Dt. Pagt.</label>
                          <InputText id="dataPagamento" 
                                    type="text" 
                                    style={{width: '100%', height: '37px'}} 
                                    value={this.state.dtPago}
                                    disabled="true"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="formGroup">
                          <label>Processo</label>
                          <InputText id="processoConsulta" 
                                    type="text" 
                                    style={{width: '100%', height: '37px'}} 
                                    value={this.state.dsProcesso}
                                    disabled="true"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="formGroup">
                          <label>Descrição</label>
                          <InputText id="descricaoConsulta" 
                                    type="text" 
                                    style={{width: '100%', height: '37px'}} 
                                    value={this.state.dsLancamento}
                                    disabled="true"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="formGroup">
                          <label>Observação</label>
                          <InputTextarea id="observacao" 
                                        type="text" 
                                        style={{width: '100%'}} 
                                        value={this.state.observacao}
                                        disabled="true"
                                        className="p-inputtext-sm p-d-block p-mb-1"
                                        rows={2} cols={30}/>
                        </div>
                      </div>
                    </div>
                  </Dialog>  
                  {/**Pagar outro valor despesa*/}
                  <Dialog header="Pagamento de Despesas"
                            visible={this.state.modalDespesaPagamento} 
                            style={{ width: '50vw' }}
                            footer={
                              <div alignItems="right">
                                <Button label="Pagar Lançamento" 
                                        className="p-button-success p-button-text"
                                        onClick={this.pagarDespesaReceita}/>
                                &nbsp;
                                <Button label="Fechar" 
                                        className="p-button-secondary p-button-text"
                                        onClick={() => this.fecharModal('modalDespesaPagamento')}/>
                              </div>
                            }
                            onHide={() => this.fecharModal('modalDespesaPagamento')}>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="formGroup">
                          <label>Despesa</label>
                          <InputText id="tipoNomePagamento" 
                                    type="text" 
                                    style={{width: '100%', height: '37px'}} 
                                    value={this.state.tipoNome}
                                    disabled="true"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="formGroup">
                          <label>Valor</label>
                          <InputText id="valorPagamento" 
                                    type="text" 
                                    style={{width: '100%', height: '37px'}} 
                                    value={this.state.vlLancamento}
                                    disabled="true"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="formGroup">
                          <label>Vencimento</label>
                          <InputText id="vencimentoPagamento" 
                                    type="text" 
                                    style={{width: '100%', height: '37px'}} 
                                    value={this.state.dtVencimento}
                                    disabled="true"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="formGroup">
                          <label>Pagar um novo valor</label>
                          <InputNumber inputId="pagamentoNovoValorDespesa" 
                                      value={this.state.vlLancamentoNovo} 
                                      style={{width: '100%', height: '37px'}} 
                                      onChange={(e) => this.setState({vlLancamentoNovo: e.value})} 
                                      mode="decimal" locale="de-BR" minFractionDigits={2}/>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="formGroup">
                          <label>Novo Vencimento saldo devedor</label>
                          <Calendar id="novoVencimentoDespesa" 
                                    value={this.state.dtVencimentoNovo} 
                                    onChange={(e) => this.setState({ dtVencimentoNovo: e.value })} 
                                    locale="es"
                                    style={{width: '100%', height: '37px'}} 
                                    dateFormat="dd/mm/yy"
                                    mask="99/99/9999"/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="formGroup">
                          <label>Observação</label>
                          <InputTextarea id="observacaoPagamento" 
                                        type="text" 
                                        style={{width: '100%'}} 
                                        value={this.state.observacao}
                                        onChange={e => this.setState({observacao: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"
                                        rows={2} cols={30}/>
                        </div>
                      </div>
                    </div>
                  </Dialog>

                  {/**Pagar outro valor receita*/}
                  <Dialog header="Pagamento de Receitas"
                            visible={this.state.modalReceitaPagamento} 
                            style={{ width: '50vw' }}
                            footer={
                              <div alignItems="right">
                                <Button label="Pagar Lançamento" 
                                        className="p-button-success p-button-text"
                                        onClick={this.pagarDespesaReceita}/>
                                &nbsp;
                                <Button label="Fechar" 
                                        className="p-button-secondary p-button-text"
                                        onClick={() => this.fecharModal('modalReceitaPagamento')}/>
                              </div>
                            }
                            onHide={() => this.fecharModal('modalReceitaPagamento')}>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="formGroup">
                          <label>Receita</label>
                          <InputText id="tipoNomePagamento" 
                                    type="text" 
                                    style={{width: '100%', height: '37px'}} 
                                    value={this.state.tipoNome}
                                    disabled="true"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="formGroup">
                          <label>Valor</label>
                          <InputText id="valorPagamento" 
                                    type="text" 
                                    style={{width: '100%', height: '37px'}} 
                                    value={this.state.vlLancamento}
                                    disabled="true"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="formGroup">
                          <label>Vencimento</label>
                          <InputText id="vencimentoPagamento" 
                                    type="text" 
                                    style={{width: '100%', height: '37px'}} 
                                    value={this.state.dtVencimento}
                                    disabled="true"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="formGroup">
                          <label>Pagar um novo valor</label>
                          <InputNumber inputId="pagamentoNovoValorDespesa" 
                                      value={this.state.vlLancamentoNovo} 
                                      style={{width: '100%', height: '37px'}} 
                                      onChange={(e) => this.setState({vlLancamentoNovo: e.value})} 
                                      mode="decimal" locale="de-BR" minFractionDigits={2}/>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="formGroup">
                          <label>Novo Vencimento saldo devedor</label>
                          <Calendar id="novoVencimentoDespesa" 
                                    value={this.state.dtVencimentoNovo} 
                                    onChange={(e) => this.setState({ dtVencimentoNovo: e.value })} 
                                    locale="es"
                                    style={{width: '100%', height: '37px'}} 
                                    dateFormat="dd/mm/yy"
                                    mask="99/99/9999"/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="formGroup">
                          <label>Observação</label>
                          <InputTextarea id="observacaoPagamento" 
                                        type="text" 
                                        style={{width: '100%'}} 
                                        value={this.state.observacao}
                                        onChange={e => this.setState({observacao: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"
                                        rows={2} cols={30}/>
                        </div>
                      </div>
                    </div>
                  </Dialog>
                  {/**Cadastrar um novo cliente */}
                  <Dialog header="Cadastrar nova Pessoa"
                          visible={this.state.modalNovoCliente} 
                          style={{ width: '40vw' }} 
                          footer={
                            <div>
                                <Button label="Cadastrar" 
                                        className="p-button-primary p-button-text" 
                                        onClick={this.cadastrarNovoCliente}/>
                                &nbsp;
                                <Button label="Fechar" 
                                        className="p-button-secondary p-button-text"
                                        onClick={() => this.fecharModal('modalNovoCliente')}/>
                              </div>
                          }
                          onHide={() => this.fecharModal('modalNovoCliente')}>

                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <label htmlFor="descricaoArquivo">Nome<span className="obrigatorioAsterisco"> *</span></label>
                            <InputText id="nome"
                                      autoComplete="nope"
                                      type="text" 
                                      options={this.tiposPessoa} style={{width: '100%', height: '32px'}}
                                      value={this.state.nome}
                                      onChange={e => this.setState({nome: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <label>Tipo de Pessoa<span className="obrigatorioAsterisco"> *</span></label>
                            <Dropdown value={this.state.selectTipo} 
                                      options={this.tiposPessoa} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      onChange={this.onChangeTipoPessoa}
                                      id="tipo"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <label>Perfil<span className="obrigatorioAsterisco"> *</span></label>
                            <Dropdown value={this.state.perfil} 
                                      options={this.state.perfis} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      onChange={e => this.setState({perfil: e.target.value})}
                                      id="perfil"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-3">
                          <div className="form-group">
                            <label>Estado<span className="obrigatorioAsterisco"> *</span></label>
                            <Dropdown value={this.state.selectEstado} 
                                      options={this.state.estados} style={{width: '100%', height: '32px'}}
                                      optionLabel="estado" 
                                      onChange={this.onChangeEstado}
                                      filter showClear filterBy="estado"
                                      id="estado"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-9">
                          <div className="form-group">
                            <label>Cidade<span className="obrigatorioAsterisco"> *</span></label>
                            <Dropdown value={this.state.selectCidade} 
                                      options={this.state.cidades} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      onChange={this.onChangeCidade}
                                      filter showClear filterBy="nome"
                                      id="cidade"
                                      emptyMessage=" "
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                  </Dialog>
                  {/**Cadastrar Pedidos do Processo */}
                  <Dialog header="Cadastrar Pedidos"
                          visible={this.state.modalPedidos} 
                          
                          footer={
                            <div>
                                <Button label="Cadastrar" 
                                        className="p-button-primary p-button-text" 
                                        onClick={this.cadastrarPedido}/>
                                &nbsp;
                                <Button label="Fechar" 
                                        className="p-button-secondary p-button-text"
                                        onClick={() => this.fecharModal('modalPedidos')}/>
                              </div>
                          }
                          onHide={() => this.fecharModal('modalPedidos')}>

                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <label htmlFor="descricaoArquivo">Pedido<span className="obrigatorioAsterisco"> *</span></label>
                            <Dropdown value={this.state.pedido} 
                                      options={this.state.pedidos} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      onChange={e => this.setState({pedido: e.target.value})}
                                      id="pedido"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <label>Valor</label>
                            <InputNumber inputId="locale-german3" 
                                        value={this.state.valorPedido} 
                                        style={{width: '100%', height: '32px'}} 
                                        onChange={(e) => this.setState({valorPedido: e.value})} 
                                        mode="decimal" locale="de-BR" minFractionDigits={2}/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <label>Observação</label>
                            <InputTextarea id="observacaopedido" 
                                           type="text" 
                                           style={{width: '100%'}} 
                                           value={this.state.observacaoPedido}
                                           onChange={e => this.setState({observacaoPedido: e.target.value})}
                                           className="p-inputtext-sm p-d-block p-mb-1"
                                           rows={6} cols={60}/>
                          </div>
                        </div>
                      </div>
                  </Dialog>
                  {/**Alterar Pedidos do Processo */}
                  <Dialog header="Alterar Pedidos"
                          visible={this.state.modalAlterarPedido} 
                          
                          footer={
                            <div>
                                <Button label="Alterar"
                                        className="p-button-primary p-button-text" 
                                        onClick={this.alterarPedidoProcesso}/>
                                &nbsp;
                                <Button label="Fechar" 
                                        className="p-button-secondary p-button-text"
                                        onClick={() => this.fecharModal('modalAlterarPedido')}/>
                              </div>
                          }
                          onHide={() => this.fecharModal('modalAlterarPedido')}>

                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <label htmlFor="pedidoAlterar">Pedido<span className="obrigatorioAsterisco"> *</span></label>
                            <Dropdown value={this.state.pedido} 
                                      options={this.state.pedidos} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      onChange={e => this.setState({pedido: e.target.value})}
                                      id="pedidoAlterar"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <label>Valor</label>
                            <InputNumber inputId="locale-german" 
                                        value={this.state.valorPedido} 
                                        style={{width: '100%', height: '32px'}} 
                                        onChange={(e) => this.setState({valorPedido: e.value})} 
                                        mode="decimal" locale="de-BR" minFractionDigits={2}/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <label>Observação</label>
                            <InputTextarea id="observacaopedidoAlterar" 
                                           type="text" 
                                           style={{width: '100%'}} 
                                           value={this.state.observacaoPedido}
                                           onChange={e => this.setState({observacaoPedido: e.target.value})}
                                           className="p-inputtext-sm p-d-block p-mb-1"
                                           rows={6} cols={60}/>
                          </div>
                        </div>
                      </div>
                  </Dialog>
                  {/**Cadastrar Objetos de Ação */}
                  <Dialog header="Cadastrar Objetos de Ação"
                          visible={this.state.modalObjetos} 
                          style={{ width: '40vw' }} 
                          footer={
                            <div>
                                <Button label="Incluir" 
                                        className="p-button-primary p-button-text" 
                                        onClick={this.cadastrarObjetosProcesso}/>
                                &nbsp;
                                <Button label="Fechar" 
                                        className="p-button-secondary p-button-text"
                                        onClick={() => this.fecharModal('modalObjetos')}/>
                              </div>
                          }
                          onHide={() => this.fecharModal('modalObjetos')}>

                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label htmlFor="descricaoArquivo">Objeto Principal<span className="obrigatorioAsterisco"> *</span></label>
                              <Dropdown value={this.state.objetoAcao} 
                                        options={this.state.objetosAcao} style={{width: '100%', height: '32px'}}
                                        optionLabel="nome" 
                                        onChange={this.onChangeObjetos}
                                        id="objeto"
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                            <div className="form-group">
                              <label htmlFor="descricaoArquivo">Sub-Objetos<span className="obrigatorioAsterisco"> *</span></label>
                              <DataTable value={this.state.subObjetosAcao}
                                         selection={this.state.selectSubObjetos} onSelectionChange={(e) => this.setState({ selectSubObjetos: e.value })}
                                         paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                         emptyMessage=" "
                                         currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={5}>
                                <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} exportable={false}></Column>
                                <Column field="nome" header="Sub-Objeto"></Column>
                              </DataTable>
                            </div>
                          </div>
                        </div>
                    </Dialog>

                    {/**Cadastrar Provisão Judicial */}
                    <Dialog header="Cadastrar Provisão Judicial"
                            visible={this.state.modalProvisaoJudicial} 
                            style={{ width: '40vw' }} 
                            footer={
                              <div>
                                  <Button label="Incluir" 
                                          className="p-button-primary p-button-text" 
                                          onClick={this.cadastrarProvisao}/>
                                  &nbsp;
                                  <Button label="Fechar" 
                                          className="p-button-secondary p-button-text"
                                          onClick={() => this.fecharModal('modalProvisaoJudicial')}/>
                                </div>
                            }
                            onHide={() => this.fecharModal('modalProvisaoJudicial')}>

                          <div className="row">
                            <div className="col-sm-12">
                              <div className="form-group">
                                <label htmlFor="tipoProvisao">Provisão Judicial<span className="obrigatorioAsterisco"> *</span></label>
                                <Dropdown value={this.state.tipoProvisao} 
                                          options={this.state.tiposProvisao} style={{width: '100%', height: '32px'}}
                                          optionLabel="nome" 
                                          onChange={e => this.setState({tipoProvisao: e.target.value})}
                                          id="tipoProvisao"
                                          className="p-inputtext-sm p-d-block p-mb-1"/>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-12">
                              <div className="form-group">
                                <label>Observação</label>
                                <InputTextarea id="observacaoProvisao" 
                                              type="text" 
                                              style={{width: '100%'}} 
                                              value={this.state.observacaoProvisao}
                                              onChange={e => this.setState({observacaoProvisao: e.target.value})}
                                              className="p-inputtext-sm p-d-block p-mb-1"
                                              rows={6} cols={60}/>
                              </div>
                            </div>
                          </div>
                    </Dialog>
                    {/**Alterar Provisão Judicial */}
                    <Dialog header="Alterar Provisão Judicial"
                            visible={this.state.modalProvisaoJudicialAlterar} 
                            style={{ width: '40vw' }} 
                            footer={
                              <div>
                                  <Button label="Alterar" 
                                          className="p-button-primary p-button-text" 
                                          onClick={this.alterarProvisaoJudicial}/>
                                  &nbsp;
                                  <Button label="Fechar" 
                                          className="p-button-secondary p-button-text"
                                          onClick={() => this.fecharModal('modalProvisaoJudicialAlterar')}/>
                                </div>
                            }
                            onHide={() => this.fecharModal('modalProvisaoJudicialAlterar')}>

                          <div className="row">
                            <div className="col-sm-12">
                              <div className="form-group">
                                <label htmlFor="tipoProvisaoAlterar">Provisão Judicial<span className="obrigatorioAsterisco"> *</span></label>
                                <Dropdown value={this.state.tipoProvisao} 
                                          options={this.state.tiposProvisao} style={{width: '100%', height: '32px'}}
                                          optionLabel="nome" 
                                          onChange={e => this.setState({tipoProvisao: e.target.value})}
                                          id="tipoProvisaoAlterar"
                                          className="p-inputtext-sm p-d-block p-mb-1"/>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-12">
                              <div className="form-group">
                                <label>Observação</label>
                                <InputTextarea id="observacaoProvisaoAlterar" 
                                              type="text" 
                                              style={{width: '100%'}} 
                                              value={this.state.observacaoProvisao}
                                              onChange={e => this.setState({observacaoProvisao: e.target.value})}
                                              className="p-inputtext-sm p-d-block p-mb-1"
                                              rows={6} cols={60}/>
                              </div>
                            </div>
                          </div>
                    </Dialog>
              </div>
            </section>
          </div>
        </div>
      </>
    );
  }
}

FichaProcesso.contextType = AuthContext;
export default withRouter(FichaProcesso)